{
    "common": {
        "added": {
            "label": {},
            "msg": {},
            "code": {}
        },
        "label": {
            "Views": "閲覧",
            "Updating": "更新中",
            "By URL": "URL別",
            "Usage trend": "利用推移",
            "Top {{count}} URLs": "URL 上位 {{count}}",
            "Top {{count}} referring domains": "参照元ドメイン 上位 {{count}}",
            "Top {{count}} countries": "国 上位 {{count}}",
            "{{total}} total": "全 {{total}}",
            "Published target": "公開対象",
            "Last viewed": "最終閲覧",
            "{{count}} published": "公開中 <0>{{count}}</0>",
            "As of {{hours}} hour(s) ago": "{{hours}}時間前時点",
            "As of {{days}} day(s) ago": "{{days}}日前時点",
            "As of less than an hour ago": "1 時間以内時点",
            "Public URL statistics": "公開 URL 統計",
            "Usage of {{count}} public URL(s)": "公開 URL {{count}}件の利用状況",
            "Public URL statistics details": "公開 URL 統計の詳細",
            "{{active}} published, {{released}} unpublished": "公開中 <0>{{active}}</0> · 解除 <1>{{released}}</1>",
            "({{active}} published, {{released}} unpublished)": "(公開中 {{active}} · 解除 {{released}})",
            "left axis": "(左軸)",
            "right axis": "(右軸)",
            "Estimated visitors": "推定訪問者",
            "Data transferred": "転送量",
            "Referring domains": "参照元ドメイン",
            "Countries": "国",
            "Last {{days}} days": "直近{{days}}日",
            "Gen AI": "Gen AI",
            "Dimension": "解像度",
            "When an asset is created": "アセットが作成されたとき",
            "When an asset is published": "アセットが公開されたとき",
            "When an asset is updated": "アセットが更新されたとき",
            "{{from}}-{{to}} of {{count}}": "{{count}}件中 {{from}}-{{to}}",
            " - Total {{totalSize}}": " - 合計 {{totalSize}}",
            "Add Vocabulary?": "単語を追加しますか？",
            "Add to all": "すべてに追加",
            "All items cannot be deleted.": "すべての項目を削除することはできません。",
            "Archiving...": "アーカイブ中...",
            "Asset created": "アセット作成時",
            "Asset published": "アセット公開時",
            "Asset to be analyzed": "分析する資産",
            "Asset updated": "アセット更新時",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "バケットの名は必ず3～63字以内でなければならなく、アルファベットや数字で開始され、 -, _, 。の特殊文字のみ使用できます。",
            "Choose on Organizer": "主催者を選択",
            "Close my jobs": "マイジョブを閉じる",
            "Close tab menu": "タブメニューを閉じる",
            "Collapse panel": "パネルを折りたたむ",
            "Connection settings": "接続設定",
            "Copy to {{name}}": "{{name}}にコピー",
            "Create Webhook": "ウェブフックを作成",
            "Customer": "顧客",
            "Default value": "デフォルト値",
            "Destination": "対象",
            "Domain URL": "ドメインURL",
            "Drive": "ドライブ",
            "Duplicate the item?": "アイテムを複製しますか?",
            "Empty Recoding History": "録画履歴がありません",
            "Endpoint URL": "エンドポイントURL",
            "Enter Vocabulary name": "単語名を入力してください",
            "Enter after entering": "入力後にEnterキーを押してください",
            "Enter field description": "フィールドの説明を入力してください",
            "Enter prefix": "接頭語を入力してください",
            "Entering Console…": "コンソールに接続中…",
            "Error renaming from {{item1}} to {{item2}}.": "{{item1}} から {{item2}} への名前変更中にエラーが発生しました。",
            "Event Triggers": "イベントトリガー",
            "Expand panel": "パネルを展開",
            "Failed": "失敗",
            "Find objects by prefix": "プレフィックスでオブジェクトを検索",
            "Go to Search Results": "検索結果へ移動",
            "Grouping": "グループ化",
            "Headers": "ヘッダー",
            "Height": "高さ",
            "Hide value": "値を非表示にする",
            "HTTP Method": "HTTPメソッド",
            "Id": "ID",
            "If you need permission, please contact your account manager.": "権限が必要な場合は、担当のアカウントマネージャーにお問い合わせください。",
            "In use": "使用中",
            "Ingested": "インジェストされた",
            "Ingesting": "インジェスト中",
            "Min": "最小",
            "Moving...": "移動中...",
            "No requests list": "リクエストリストがありません",
            "Offline": "オフライン",
            "Open tab menu": "タブメニューを開く",
            "Other": "その他",
            "Permission to access is required.": "アクセス権限が必要です。",
            "Please create an organizer.": "主催者を作成してください。",
            "Prefix cannot be empty": "接頭語は空にしてはいけません。",
            "Prefix must begin with s3://": "接頭語は必ず s3:// として始まらなければならないです。",
            "Preview Image": "プレビュー画像",
            "Progressing": "進行中",
            "Project name cannot be empty": "プロジェクト名は空にしてはいけません",
            "Re-Approval requested": "再承認申請された",
            "Recent deliveries": "最近の配信履歴",
            "Remove header": "ヘッダーを削除",
            "Request body example": "リクエストボディの例",
            "Response": "レスポンス",
            "Search by webhook name": "ウェブフック名で検索してください",
            "Search Projects": "プロジェクトを検索",
            "Search by execution ID": "実行IDで検索",
            "Select Language": "言語を選択",
            "Select Service Type": "サービスの種類を選択",
            "Select Storage": "ストレージを選択",
            "Share to \"{{name}}\"": "「{{name}}」に共有",
            "Show value": "値を表示",
            "Smiling": "笑顔",
            "Space ID": "スペースID",
            "CDN ID": "CDN ID",
            "System management": "システム管理",
            "There is no resource in video.": "ビデオにリソースがありません。",
            "There was an error creating the new folder {{item}}.": "新しいフォルダ {{item}} の作成中にエラーが発生しました。",
            "Total for all projects": "全プロジェクトの合計",
            "Transport format": "送信形式",
            "Triggers": "トリガー",
            "Use all": "すべて使用",
            "View Files": "ファイルを見る",
            "View History": "履歴を表示",
            "Vocabularies": "単語",
            "Vocabulary Book Search Results": "単語帳の検索結果",
            "Webhook": "ウェブフック",
            "webhook": "ウェブフック",
            "Webhooks": "ウェブフック",
            "Delivery history": "送信履歴",
            "Request ID": "リクエストID",
            "Status code": "ステータスコード",
            "Response time": "応答時間",
            "Result": "結果",
            "Select result": "結果選択",
            "Success": "成功",
            "Width": "幅",
            "You do not have permission.": "権限がありません。",
            "Zoom In": "拡大",
            "Zoom Out": "縮小",
            "and": "および",
            "canceled": "キャンセルされた",
            "complete": "完了",
            "error": "エラー",
            "group": "グループ",
            "loading...": "読み込み中...",
            "preview": "プレビュー",
            "remove": "削除",
            "requested": "リクエスト済み",
            "user": "ユーザー",
            "weekly": "週間",
            "{{name}} Search Results": "{{name}}の検索結果",
            "READY TO DOWNLOAD": "ダウンロード準備完了",
            "STARTING": "開始中",
            "STOPPING": "停止中",
            "SUBMITED": "提出済み",
            "UNKNOWN": "不明",
            "AWS": "AWS",
            "Daglo": "Daglo",
            "S3 Glacier Deep Archive": "S3 Glacier Deep Archive",
            "S3 Glacier Flexible Retrieval": "S3 Glacier Flexible Retrieval",
            "Subsy": "Subsy",
            "Image zoom in": "画像を拡大",
            "Add Option": "オプションを追加",
            "Labels": "ラベル",
            "Filter labels": "ラベルで絞り込み",
            "Go to details": "詳細へ移動",
            "Select Key": "キーを選択",
            "Current Space": "現在のスペース",
            "Stage List": "ステージリスト",
            "Empty Widget List": "ウィジェットなし",
            "Enlarge Layout": "拡大レイアウト",
            "Video Player": "ビデオプレーヤー",
            "Copying": "コピー中",
            "Empty Published History": "公開履歴なし",
            "Request Details": "リクエスト詳細",
            "Results for your Search": "検索結果",
            "Average Confidence (%) : More than": "平均信頼度(%) : 以上",
            "Prev": "前",
            "Go Detail": "詳細へ移動",
            "By Last Created": "作成日",
            "day": "日",
            "Only Unused Files": "未使用ファイルのみ",
            "Access Token": "アクセストークン",
            "Refresh Token": "リフレッシュトークン",
            "Projects Allowed to Use": "使用可能なプロジェクト",
            "WORKFLOW_QUEUED": "待機中",
            "WORKFLOW_READY": "準備中",
            "WORKFLOW_RUNNING": "実行中",
            "WORKFLOW_COMPLETED": "完了",
            "WORKFLOW_FAILED": "失敗",
            "WORKFLOW_EXPIRED": "期限切れ",
            "Start Date": "開始日時",
            "End Date": "終了日時",
            "Duration (sec)": "所要時間(秒)",
            "Go to error item": "エラー項目へ移動",
            "Error message": "エラーメッセージ",
            "How to resolve": "解決方法",
            "Continue editing": "編集を続ける",
            "Acknowledge and save": "警告を確認して保存",
            "Add parallel step": "並列ステップを追加",
            "bucketName": "バケット名",
            "prefix": "接頭語",
            "fileUrl": "ファイルURL",
            "extension": "拡張子",
            "extensions": "拡張子",
            "minByte": "最小バイト",
            "maxByte": "最大バイト",
            "assetId": "資産ID",
            "mediaType": "メディアタイプ",
            "attributions": "アトリビューション",
            "tags": "タグ",
            "categories": "カテゴリー",
            "description": "説明",
            "extendedMetadata": "拡張メタデータ",
            "virtualLocation": "位置",
            "collection": "コレクション",
            "pipelineId": "パイプラインID",
            "videoId": "ビデオID",
            "promptId": "プロンプトID",
            "storageClass": "ストレージクラス",
            "platform": "プラットフォーム",
            "isCreateOriginAsset": "原本ソースを資産として保存",
            "AI Search Mode": "AI検索モード",
            "Grant Space Admin": "スペース管理者を付与",
            "Grant Project Admin": "プロジェクト管理者を付与",
            "1st": "1週目",
            "2nd": "2週目",
            "3rd": "3週目",
            "4th": "4週目",
            "5th": "5週目",
            "6th": "6週目",
            "- Total {{totalSize}}": "- 合計{{totalSize}}",
            "{{count}} views": "{{count}}個を見る",
            "{{name}} files": "{{name}} ファイル",
            "{{name}} ID": "{{name}} ID",
            "{{name}} inquiry": "{{name}} 問い合わせ",
            "{{name}} overview": "{{name}} 概要",
            "24 hour operation": "24時間稼働",
            "24 hours": "24時間",
            "24/7": "24/7",
            "Accept": "受託",
            "Account": "アカウント",
            "Action": "動作",
            "Actions": "動作",
            "Active": "アクティブ",
            "ACTIVE": "アクティブ",
            "ACTIVE / INACTIVE TOGGLE": "アクティブ/非アクティブの切り替え",
            "Add": "追加",
            "Add {{name}}": "{{name}} 追加",
            "Add a category": "カテゴリー追加",
            "Add caption": "キャプション追加",
            "Add faces": "顔の追加",
            "Add files": "ファイルの追加",
            "Add image": "イメージの追加",
            "Add images": "イメージの追加",
            "Add lineup": "ラインナップの追加",
            "Add roles": "役割の追加",
            "Add teams": "チームの追加",
            "Add users": "ユーザーの追加",
            "Add posters": "ポスターの追加",
            "Admin": "管理者",
            "Administration": "管理",
            "Advanced search": "高度な検索",
            "ALL": "全て",
            "All event type": "全てのイベントタイプ",
            "All ingest type": "全てのインジェストタイプ",
            "All language": "全言語",
            "All media type": "全てのメディアタイプ",
            "All media types": "全てのメディアタイプ",
            "All pipeline": "すべてのパイプライン",
            "All project": "すべてのプロジェクト",
            "All source": "全てのソース",
            "All state": "すべての状態",
            "All status": "全ての状態",
            "All type": "全てのタイプ",
            "All types": "全てのタイプ",
            "Allowed special characters": "使用できる特殊文字",
            "Alternative name": "代替名",
            "Alternative names": "代替名",
            "Amount": "総量",
            "Amount : {{amount}}": "総量: {{amount}}",
            "Analyzed": "分析された",
            "Analyzing": "分析中",
            "Anywhere": "どこでも",
            "Appears to be happy": "幸せそうに見える",
            "Appears to be male": "男性に見える",
            "Apply": "適用",
            "Approval": "承認",
            "Approval in progress": "承認進行中",
            "Approval request": "承認要求",
            "Approval requested": "承認申請された",
            "Approval status": "承認状態",
            "Approve": "承認",
            "Approve whitelist": "ホワイトリスト承認",
            "Approved": "承認された",
            "Approved whitelist": "承認されたホワイトリスト",
            "Asset": "資産",
            "Asset ID": "資産ID",
            "Asset name": "資産の名前",
            "Assets": "資産",
            "Assets {{name}}": "資産 {{name}}",
            "Attribution": "アトリビューション",
            "Attributions": "アトリビューション",
            "Audio": "オーディオ",
            "Audio settings": "オーディオ設定",
            "Audit logs": "監査ログ",
            "Audit-Logs": "監査 - ログ",
            "Authority": "権限",
            "Auto Start/Stop": "自動スタート/中止",
            "Automated Workflow": "自動化ワークフロー",
            "AWS medialive channel": "AWSメディアライブチャンネル",
            "AWS medialive input": "AWSメディアライブインプット",
            "Base video": "基本ビデオ",
            "Blank time": "ブランクタイム",
            "Cancel": "キャンセル",
            "CANCELED": "キャンセルされた",
            "Cannot delete the stream": "ストリームを削除できません。",
            "CAPTION": "キャプション",
            "Caption": "キャプション",
            "Caption label": "キャプションラベル",
            "Captions": "キャプション",
            "Categories": "カテゴリー",
            "Categories selected": "カテゴリー選択",
            "Category": "カテゴリー",
            "Category description": "カテゴリー説明",
            "Category group": "カテゴリーグループ",
            "Category group description": "カテゴリーグループ説明",
            "Category group name": "カテゴリーグループ名前",
            "Category groups": "カテゴリーグループ",
            "Celebrity recognition": "芸能人の認識",
            "Channel": "チャンネル",
            "Channel description": "チャンネルの説明",
            "Channel ID": "チャンネルのID",
            "Channel overview": "チャンネルの概要",
            "Channel state of non-scheduled time": "スケジュールされてない時間のチャンネル状態",
            "Channels": "チャンネル",
            "Chapter": "チャプター",
            "Choose on schedules": "リスティング選択",
            "Choose on stream": "ストリーム選択",
            "Choose on streams": "ストリーム選択",
            "Client ID": "クライアントID",
            "Client IP": "クライアントIP",
            "Client secret": "クライアントシークレット",
            "Client useragent": "クライアントユーザーエージェント",
            "Clone": "複製",
            "Close": "クローズ",
            "Cloud": "クラウド",
            "Cloud inquiry": "クラウドの問い合わせ",
            "CloudPlex Media": "CloudPlex Media",
            "CloudPlex Media subtitle editor": "CloudPlex Media字幕編集機",
            "CMS": "CMS",
            "Code": "コード",
            "COMPLETE": "完了",
            "Completed": "完了日",
            "Conditions": "条件",
            "Confidence": "信頼度",
            "Configuration": "構成",
            "Constraints": "制約",
            "Content moderation": "コンテンツの調整",
            "Contents": "コンテンツ",
            "Contents duration": "コンテンツの再生時間",
            "Copyright": "著作権",
            "Correct status": "状態補正",
            "Create": "生成",
            "Create {{name}} asset": "{{name}} 資産生成",
            "Create MP4 asset": "ビデオ 資産生成",
            "Create MP3 asset": "オーディオ 資産生成",
            "Create IMAGE asset": "イメージ 資産生成",
            "Create CAPTION asset": "キャプション 資産生成",
            "Create {{name}}": "{{name}} 生成",
            "Created": "生成日",
            "Creator": "作成者",
            "Execution History": "実行履歴",
            "Execution Result": "実行結果",
            "Flow Detail Information": "フロー詳細情報",
            "Created by": "製作者",
            "Creating": "生成中",
            "CSV Export": "CSVエクスポート",
            "Cumulative viewers": "累積視聴者数",
            "Cumulative views": "累積視聴回数",
            "Cumulative viewing time": "累積視聴時間",
            "Current time": "現在時間",
            "Current viewers": "現在の視聴者数",
            "Currently online": "現在オンライン",
            "Custom fields": "ユーザー定義フィールド",
            "Cycle": "周期",
            "Dailys": "デイリー",
            "Dashboard": "ダッシュボード",
            "Date": "日付",
            "Date picker": "日付選択",
            "Date format": "日付形式",
            "Day": "日",
            "Days": "日",
            "Default": "デフォルト",
            "Delete": "削除",
            "Delete all": "全体削除",
            "Deleted": "削除された",
            "Deleted output asset retention": "削除されたアウトプットに資産を保管",
            "Description": "説明",
            "Desktop": "デスクトップ",
            "Destination A": "対象A",
            "Destination B": "対象B",
            "Detach": "解除",
            "Detach {{name}}": "{{name}} 解除",
            "Detail": "詳細",
            "Direct": "PCファイル",
            "Direct input": "直接入力",
            "Disable": "使用しない",
            "Down": "下り",
            "Download": "ダウンロード",
            "Download apps": "ダウンロードアプリ",
            "Download filtered list": "フィルターされたリストをダウンロード",
            "Download full list": "リスト全体をダウンロード",
            "DRAFT": "ドラフト",
            "Draft": "ドラフト",
            "DUAL": "二重の",
            "Dual": "二重の",
            "Dubbing": "ダビング",
            "MultipleAudios": "複数のオーディオ",
            "Duration": "再生時間",
            "Edit": "修正",
            "Email": "Eメール",
            "Embed code": "埋め込みコード",
            "Employee Sign in": "LX Hausys 社員ログイン",
            "Empty": "空",
            "Empty {{name}}": "{{name}}がありません。",
            "Every {{interval}} days": "{{interval}}日ごとに",
            "Enable": "使用",
            "Encoding profile": "エンコーディングプロフィール",
            "End": "終了",
            "End date": "終了日付",
            "End now": "今すぐ終了",
            "End time": "終了時間",
            "Endpoint": "エンドポイント",
            "Endpoints": "エンドポイント",
            "Error": "エラー",
            "ERROR": "エラー",
            "Etc": "その他",
            "Event": "イベント",
            "EVENT": "イベント",
            "Event triggers": "イベントトリガー",
            "Event type": "イベント種類",
            "EventTrigger": "イベントトリガー",
            "EventTrigger description": "イベントトリガーの説明",
            "EventTrigger name": "イベントトリガーの名前",
            "EventTriggers": "イベントトリガー",
            "Every": "ごとに",
            "Expired": "有効期限",
            "Expired at": "有効期限満了時点",
            "Expired date": "有効期限",
            "Face": "顔",
            "Face anlaysis": "顔の分析",
            "Face index": "顔のインデックス",
            "Face search": "顔の検索",
            "Facebook": "Facebook",
            "Faces": "顔",
            "Faces selected": "顔の選択",
            "Field type search": "フィールドタイプの検索",
            "Field {{count}}": "フィールド {{count}}",
            "File": "ファイル",
            "File name": "ファイル名",
            "File source": "ファイルソース",
            "Files": "ファイル",
            "Folder name": "フォルダ名",
            "Follow default values": "デフォルト値を使用します。",
            "Force inheritance": "強制継承",
            "Fri": "金",
            "Friday": "金曜日",
            "General": "一般",
            "Go to schedule": "スケジュールへ移動",
            "Grand additional roles": "複数の役割の追加",
            "Grant all permissions": "承認された全ての権限",
            "Grant project access": "プロジェクトアクセス権限の付与",
            "Granted": "承認可否",
            "Granted roles": "承認された役割",
            "Hide": "非表示",
            "High": "高い",
            "Highest": "最も高い",
            "Hub scope": "すべてのプロジェクト",
            "Hyper Browser": "ハイパーブラウザ",
            "ID": "ID",
            "Idle": "アイドル",
            "Image": "イメージ",
            "IMAGE": "イメージ",
            "Image setting": "イメージ設定",
            "Image sources": "イメージソース",
            "Images selected": "イメージ選択",
            "Inactive": "非アクティブ",
            "Index": "インデックス",
            "Indexing": "インデックス作成",
            "Indexed": "インデックス",
            "Index file": "インデックスファイル",
            "Individual settings": "個人設定",
            "Ingest type": "インジェストタイプ",
            "Ingest": "インジェスト",
            "INGEST": "インジェスト",
            "INGESTED": "インジェストされた",
            "INGESTING": "インジェスト中",
            "Inherit": "継承",
            "Input {{index}}": "インプット {{index}}",
            "Input asset auto delete": "インプット資産の自動削除",
            "Input detail": "インプットの詳細",
            "Input path": "インプットの経路",
            "Input storage": "インプットのストレージ",
            "Input storage path": "インプットのストレージの経路",
            "Inputs": "インプット",
            "Instagram": "インスタグラム",
            "Interval": "繰り返し間隔",
            "IP range": "IP範囲",
            "Job": "作業",
            "Job {{name}}": "{{name}} 作業",
            "Job ID": "作業ID",
            "Job overview": "ジョブ概要",
            "Jobs": "作業",
            "Key": "キー",
            "Kind": "種類",
            "Label": "ラベル",
            "Label detection": "ラベル感知",
            "Language": "言語",
            "Last access": "最終アクセス",
            "Last accessed at": "最終アクセス",
            "Leave": "退出する",
            "Leave comment": "コメントを残す",
            "Linear": "リニア",
            "LINEAR": "リニア",
            "Lineup": "ラインナップ",
            "Lineup copy": "ラインナップのコピー",
            "Lineup count": "ラインナップの個数",
            "Lineup detail": "ラインナップの詳細",
            "Lineup name": "ラインナップの名前",
            "List": "リスト",
            "Listing": "リスティング",
            "Schedules": "スケジュール",
            "SCHEDULES": "リスティング",
            "Schedules detail": "リスティングの詳細",
            "Schedules ID": "リスティングのID",
            "Schedules overview": "リスティングの概要",
            "Live": "ライブ",
            "Live player URL": "ライブプレーヤーURL",
            "Loading...": "ローディング中…",
            "Local": "ローカル",
            "Local file": "ローカルファイル",
            "Logo": "ロゴ",
            "Looks like a face": "顔のように見える",
            "Loop": "ループ",
            "Loop to fill lineup duration": "ラインナップ再生時間の繰り返し再生",
            "Low": "低い",
            "Lowest": "最低",
            "Main": "メイン",
            "Mark in": "マークイン",
            "Mark in~out": "マークイン～マークアウト",
            "Mark out": "マークアウト",
            "Max": "最大",
            "Maximum object size": "最大オブジェクトの大きさ",
            "Maximum schedule amount": "最大スケジュールの時間",
            "Media": "メディア",
            "Media service": "メディアサービス",
            "Media service inquiry": "メディアサービスの問い合わせ",
            "Media type": "メディアのタイプ",
            "Medium": "中間",
            "Megazone ID": "Megazone ID",
            "Members": "メンバー",
            "Metadata": "メタデータ",
            "Metadata description": "メタデータの説明",
            "Metadata name": "メタデータの名前",
            "Metadata schema description": "メタデータのスキーマ説明",
            "Mon": "月",
            "Monday": "月曜日",
            "Month": "月",
            "Months": "月",
            "More than 50%": "50%以上",
            "MP4": "MP4",
            "My jobs": "私の仕事",
            "Name": "名前",
            "Name / ID": "名前 / ID",
            "Name constraints": "名前の制約条件",
            "Never": "無し",
            "No": "いいえ",
            "No options": "オプションなし",
            "No {{name}}": "{{name}} なし",
            "No asset contents": "資産内容が見つかりません。",
            "No asset searched.": "資産を見つかりません。",
            "No category searched": "検索されたカテゴリーがありません。",
            "None": "なし",
            "Not copy to": "コピー先ではない",
            "Not deleted": "未削除",
            "Not found": "見つかりません",
            "Now": "今",
            "Number": "番号",
            "Off": "オフ",
            "On": "オン",
            "OR": "または",
            "Origin": "原本",
            "Origins": "原本",
            "Output": "アウトプット",
            "Outputs": "アウトプット",
            "Output {{index}}": "アウトプット {{index}}",
            "Output path": "アウトプットの経路",
            "Output preview": "アウトプットのプレビュー",
            "Output storage": "アウトプットのストレージ",
            "Output storage path": "アウトプットのストレージの経路",
            "Overview": "概要",
            "Owner": "所有者",
            "Path": "経路",
            "Payload": "ペイロード",
            "Parent device": "上位デバイス",
            "Parent region": "上位地域",
            "Pending ingesting": "インジェストの待機中…",
            "Pending transcoding": "トランスコーディングの待機中",
            "People": "ピープル",
            "People description": "ピープルの説明",
            "Period": "期間",
            "Period setting": "期間の設定",
            "Permissions": "権限",
            "Pipeline": "パイプライン",
            "Pipeline {{name}}": "{{name}} パイプライン",
            "Player": "プレーヤー",
            "Please create a schedules.": "リスティングを生成してください。",
            "Please create a stream.": "ストリームを生成してください。",
            "Poster": "ポスター",
            "Posters": "ポスター",
            "Prefix": "接頭語",
            "Preview": "プレビュー",
            "Preview button": "プレビューボタン",
            "Preview in browser URL": "ブラウザーのURLプレビュー",
            "Priority": "優先順位",
            "Privacy policy": "プライバシーポリシー",
            "Private": "非公開",
            "Profile": "プロフィール",
            "Profile {{name}}": "{{name}} プロフィール",
            "Program": "プログラム",
            "Program duration": "プログラム再生時間",
            "Programes count": "プログラムの個数",
            "Programs": "プログラム",
            "PENDING": "進行中",
            "PROGRESSING": "進行",
            "Project": "プロジェクト",
            "Project description": "プロジェクトの説明",
            "Project ID": "プロジェクトのID",
            "Project in use": "使用中であるプロジェクト",
            "Project manager": "プロジェクトマネージャー",
            "Project name": "プロジェクト名",
            "Project Name / ID": "プロジェクトの名前 / ID",
            "Project overview": "プロジェクトの概要",
            "Project settings": "プロジェクトの設定",
            "Projects": "プロジェクト",
            "Projects in use": "使用中であるプロジェクト",
            "Provider": "プロバイダー",
            "Provider / Service": "プロバイダー / サービス",
            "Public": "公開",
            "Publish": "掲示",
            "QR": "QR",
            "Quick search": "クイックサーチ",
            "Range": "範囲",
            "READY": "準備された",
            "Reanalysis": "再分析",
            "Retry AI search indexing": "AI検索インデックス再試行",
            "Retry indexing": "インデックス再試行",
            "Reason": "理由",
            "Reason for approval requested": "承認申請の理由",
            "Reason for reclaimed": "回収の理由",
            "Reason for rejected": "差し戻しの理由",
            "Reason for request": "申請の理由",
            "Reason for response": "処理の理由",
            "Reason for return requested": "返還申請の理由",
            "Reclaim": "回収",
            "Reclaim in progress": "回収進行中",
            "Reclaimed": "回収された",
            "Recorded": "記録",
            "Redirect URL": "リーディレクションURL",
            "Redundancy level": "リダンダンシーレベル",
            "Refresh": "再読込",
            "Refresh token": "トークンの更新",
            "Reject": "拒否",
            "Rejected": "差し戻しされた",
            "Related {{pascalK}}": "関連された {{pascalK}}",
            "Remaining time": "残り時間",
            "Remote": "クラウドファイル",
            "Remote file": "遠隔ファイル",
            "Remove": "除去",
            "Rendition": "レンディション",
            "Renditions": "レンディション",
            "Repeat": "繰り返し",
            "Request": "申請",
            "Request approval": "承認申請",
            "Request body": "申請ボディー",
            "Request cancel": "申請キャンセル",
            "Request return": "返還の申請",
            "Reset": "初期化",
            "Resolution": "解像度",
            "Resource": "リソース",
            "Response body": "応答ボディー",
            "Restore to default": "基本値として復元",
            "Retry": "リトライ",
            "Return": "返還",
            "Return cancel": "返還のキャンセル",
            "Return in progress": "返還進行中",
            "Return request": "返品要求",
            "Return requested": "返還申請された",
            "Returned": "返還された",
            "Role description": "役割の説明",
            "Role name": "役割の名前",
            "Role overview": "役割の概要",
            "Role": "役割",
            "Roles": "役割",
            "rules": "ルール",
            "Running": "稼働中",
            "S3://~": "s3://~",
            "Sat": "土",
            "Saturday": "土曜日",
            "Save": "保存",
            "Save origin asset": "原本資産保存",
            "Schedule": "スケジュール",
            "Schedule {{index}}": "スケジュール {{index}}",
            "Schedule repeat": "スケジュール繰り返し",
            "Scheduled lineups": "編成されたラインナップ",
            "Scheduled time": "スケジュールされた時間",
            "Scope": "範囲",
            "Search": "検索",
            "Search assets name": "検索する資産の名前",
            "Search by workflow name": "ワークフロー名で検索",
            "Search program name": "検索するプログラムの名前",
            "Search team name": "検索するチームの名前",
            "Search videos name": "検索するビデオの名前",
            "Security": "セキュリティ",
            "Select": "選択",
            "Select {{name}}": "{{name}} 選択",
            "Select a file": "ファイル選択",
            "Select a one {{type}} file": "一つの{{type}} ファイル選択",
            "Select a one caption file.": "キャプションファイルを選択してください。",
            "Select assets": "資産の選択",
            "Select categories": "カテゴリーの選択",
            "Select category": "カテゴリーの選択",
            "Select event type": "イベントタイプの選択",
            "Select files": "ファイル選択",
            "Select folder": "フォルダの選択",
            "Select kind": "種類 選択",
            "Select language": "言語 選択",
            "Select one MP4 file": "一つのMP4ファイルを選択してください。",
            "Select pipeline": "パイプラインの選択",
            "Select roles to grant": "付与する役割選択",
            "Select whitelist": "ホワイトリストの選択",
            "Select...": "選択...",
            "Selected {{name}}": "選択された {{name}}",
            "Separate by newlines": "改行文字として分離",
            "Service": "サービス",
            "Set": "設定",
            "Set as default": "基本として設定",
            "Set as primary": "代表画像として設定",
            "Settings": "設定",
            "Show all": "全て表示",
            "Show more": "もっと見る",
            "Sign in": "ログイン",
            "Sign in with Megazone Accounts": "Megazoneアカウントとしてログイン",
            "Single": "単一",
            "Single IP": "単一IP",
            "Size": "大きさ",
            "smiling": "笑顔",
            "Source": "ソース",
            "Source A": "ソースA",
            "Source B": "ソースB",
            "Source end behavior": "ソース終了時、動作",
            "Sources": "ソース",
            "Specifications": "仕様",
            "Stage": "ステージ",
            "Stage scope": "ステージの範囲",
            "Project scope": "プロジェクト範囲",
            "Start": "スタート",
            "Space": "スペース",
            "Start {{name}}": "{{name}}スタート",
            "Start analysis": "分析スタート",
            "Start date": "スタート日付",
            "Start indexing": "インデックススタート",
            "Start time": "スタート時間",
            "Start~End": "スタート～終了",
            "Started": "スタートされた",
            "Starting": "スタート中",
            "State": "状態",
            "Statistics": "統計",
            "Status": "状態",
            "Stop": "停止",
            "Stopped": "停止された",
            "Stopping": "停止中",
            "Storage path": "ストレージの経路",
            "Stream": "ストリーム",
            "STREAM": "ストリーム",
            "Stream ID": "ストリームID",
            "Streams": "ストリーム",
            "Submit": "登録",
            "Submitted": "登録された",
            "SUBMITTED": "登録された",
            "Subtitle": "字幕",
            "Sun": "日",
            "Sunday": "日曜日",
            "Supported file formats": "利用可能なファイルの形式",
            "Supported inputs": "利用可能なインプット",
            "Supported URL patterns": "利用可能なURLパターン",
            "Supported URLs": "利用可能なURL",
            "Synchronization": "同期化",
            "table": "表",
            "Tag": "タグ",
            "Tags": "タグ",
            "Target ID": "対象ID",
            "Target resource": "対象リソース",
            "Team": "チーム",
            "Team ID": "チームID",
            "Team overview": "チーム概要",
            "Teams": "チーム",
            "Terms & Conditions": "利用規約",
            "Text": "テキスト",
            "Text area": "テキストエリア",
            "Text field": "テキストフィールド",
            "There is no Stream to select.": "選択可能なストリームがありません。",
            "This {{name}}": "この {{name}}",
            "Thumbnails": "プレビューのイメージ",
            "THUMBNAILS": "プレビューのイメージ",
            "Thur": "木",
            "Thursday": "木曜日",
            "Time": "時間",
            "Timestamp": "タイムスタンプ",
            "Timezone": "タイムゾーン",
            "Title": "タイトル",
            "Today": "本日",
            "Total": "合計",
            "Total {{name}}": "合計 {{name}}",
            "Total <strong className=\\\"emphasis\\\">{{elementsLength}}</strong>": "Total<0>{{elementsLength}}</0>",
            "Total <0>{{elementsLength}}</0>": "Total<0>{{elementsLength}}</0>",
            "Total time": "合計時間",
            "Transcode": "トランスコード",
            "Transcode profile": "トランスコードのプロフィール",
            "Transcoded": "トランスコーティング",
            "Transcoder Job ID": "トランスコーダーのジョブID",
            "Transcoding": "トランスコーディング",
            "Transcoding canceled": "トランスコーディングのキャンセル",
            "Transcoding complete": "トランスコーディングの完了",
            "Transcoding error": "トランスコーディングのエラー",
            "Transcoding failed": "トランスコーディングの失敗",
            "Transcoding time": "トランスコーティングの時間",
            "Tree": "ツリー",
            "Tue": "火",
            "Tuesday": "火曜日",
            "Twitch": "ツイッチ",
            "Twitter": "ツイッター",
            "Type": "タイプ",
            "Undefined": "定義されてない",
            "Unique": "一風変わった",
            "Unknown": "不明",
            "(Unknown)": "(不明)",
            "Unscheduled time": "スケジュールされてない時間",
            "Unset default": "基本解除",
            "Up": "アップ",
            "Update file": "ファイルの更新",
            "Updated": "アップデート",
            "Updated at": "アップデート",
            "Updated by": "アップデートの実行者",
            "Updating...": "アップデート中...",
            "Upload": "アップロード",
            "Upload {{status}}.": "アップロード {{status}}.",
            "Upload rules": "アップロードの規則",
            "Uploading": "アップロード中",
            "UPLOADING": "アップロード中",
            "URL": "URL",
            "User ID": "使用者ID",
            "User information": "使用者情報",
            "User name": "使用者の名前",
            "User overview": "使用者の概要",
            "User username": "使用者のユーザー名前",
            "Username": "ユーザーの名前",
            "Users": "ユーザー",
            "Value": "値",
            "Video": "ビデオ",
            "Video ID": "ビデオID",
            "Video AI": "ビデオAI",
            "Video setting": "ビデオ設定",
            "Videos": "ビデオ",
            "View analytics data": "分析データを見る",
            "View more": "もっと見る",
            "VOD player URL": "VODプレーヤーURL",
            "Warning": "警告",
            "Wearing glasses": "メガネをかけている",
            "Wed": "水",
            "Wednesday": "水曜日",
            "Week": "週",
            "Weekly": "週間",
            "Weeks": "週",
            "Welcome": "ようこそ",
            "Whitelist": "ホワイトリスト",
            "Whitelist rules": "ホワイトリストの規則",
            "Whitelist to request": "申請するホワイトリスト",
            "Workflow": "ワークフロー",
            "Workflow Name": "ワークフロー名",
            "workflow": "ワークフロー",
            "Years old": "歳",
            "Yes": "はい",
            "Youtube": "ユーチューブ",
            "Youtube syndication": "ユーチューブシンジケーション",
            "Auto Categorization": "自動分類",
            "people": "ピープル",
            "Site access": "サイトへのアクセス",
            "Console": "コンソール",
            "File meta": "ファイルメタ",
            "Operator": "演算子",
            "Contains": "含む",
            "Duration range": "時間範囲",
            "Date range": "日付範囲",
            "Greater than": "より大きい",
            "Less than": "より小さい",
            "OverWrite": "上書き",
            "Overwrite": "上書き",
            "Skip": "スキップ",
            "OK": "確認",
            "Source name": "ソース名",
            "Partial {{type}} to completed.": "完了する部分 {{type}}。",
            "Folder Upload": "フォルダのアップロード",
            "Files Upload": "ファイルのアップロード",
            "New Folder": "新しいフォルダ",
            "Upload Files": "ファイルのアップロード",
            "References": "参考文献",
            "사용자 설정 위젯": "ユーザー設定ウィジェット",
            "팀 설정 위젯": "チーム設定ウィジェット",
            "프로젝트 설정 위젯": "プロジェクト設定ウィジェット",
            "전체 기간": "全体期間",
            "빠른 지정": "クイック指定",
            "사용자 지정": "カスタム指定",
            "이번주": "今週",
            "이번달": "今月",
            "올해": "今年",
            "지난 15분": "最近の15分",
            "지난 30분": "最近の30分",
            "지난 1시간": "最近の1時間",
            "지난 4시간": "最近の４時間",
            "선택됨": "選択",
            "에 업데이트됨": "に更新",
            "위젯 설정": "ウィゼット設定",
            "선택된 위젯": "選択されたウィゼット",
            "프로젝트 설정으로 적용": "プロジェクト設定に",
            "Empty Data": "データなし",
            "선 그래프": "線グラフ",
            "바 그래프": "バーグラフ",
            "동영상": "動画、ビデオ",
            "시청자 수": "視聴者",
            "시청 횟수": "視聴回数",
            "디바이스별 시청자 수 (기간)": "機器別視聴者（期間）",
            "디바이스별 시청자 수 (백분율)": "機器別視聴者（比率）",
            "현재 시청자 수": "現在視聴者",
            "누적 시청자 수": "視聴者合計",
            "누적 시청 횟수": "視聴回数合計",
            "누적 시청 시간": "視聴時間合計",
            "상위 지역": "人気視聴地域",
            "상위 디바이스": "人気視聴機器",
            "Every months on": "毎月",
            "PREPARING": "PREPARING",
            "Restrict bucket access": "アウトプットバケットアクセスを制限",
            "Active on creation": "作成時に自動活性",
            "ACTIVATING": "アクティブ化中",
            "INACTIVATING": "非アクティブ化中",
            "Archive": "アーカイブ",
            "Archving...": "アーカイブ中...",
            "Folder path": "フォルダパス",
            "No assets folder": "資産フォルダなし",
            "Restoring...": "復元中...",
            "Search in folder": "フォルダ内で検索",
            "Root": "ルート",
            "Search results": "検索結果",
            "Restoring": "復元しています",
            "Archiving": "アーカイブ",
            "days": "日",
            "Achived Assets": "アーカイブされた資産",
            "Archived": "アーカイブ済み",
            "Empty Archived": "アーカイブ済みの項目がありません。",
            "Archived by": "アーカイブ者",
            "Archived Period": "アーカイブ期間",
            "Archived Assets": "アーカイブされたアセット",
            "Restored": "復元",
            "Archive ID": "アーカイブID",
            "Multi Audio": "マルチオーディオ",
            "New folder": "新規フォルダ",
            "VIDEOS": "動画、ビデオ",
            "VIEWERS": "視聴者",
            "WATCH_COUNT": "視聴回数",
            "DEVICE_VIEWERS_ON_TERM": "機器別視聴者（期間）",
            "DEVICE_VIEWERS_ON_PERCENTAGE": "機器別視聴者（比率）",
            "COUNTRY_VIEWERS_ON_TERM": "国別の視聴者 ( 期間 )",
            "COUNTRY_VIEWERS_ON_PERCENTAGE": "国別の視聴者 (%)",
            "REGION_VIEWERS_ON_TERM": "地域別視聴者（期間）",
            "REGION_VIEWERS_ON_PERCENTAGE": "地域別視聴者（比率）",
            "CITY_VIEWERS_ON_TERM": "市別視聴者（期間）",
            "CITY_VIEWERS_ON_PERCENTAGE": "市別視聴者（比率）",
            "VIEWERS_PROGRESS": "動画区間別視聴者",
            "NOT_READY": "NOT_READY",
            "Reference": "参照",
            "Restore": "復元",
            "Search in {{name}}": "検索対象 {{name}}",
            "Folder": "フォルダ",
            "{{name}} View": "{{name}} 表示",
            "Hierarchy": "階層",
            "Folder search": "フォルダ セラッチ",
            "{{name}} Search": "{{name}} 検索",
            "Confirm": "確認",
            "All lineups": "全ラインナップ",
            "Repeat lineups": "ラインナップを繰り返す",
            "All Copy to": "すべてのコピー先",
            "Date to All copy to": "すべてをコピーする日付",
            "Daily Copy": "毎日のコピー",
            "Check date to all copy to": "すべてのコピー先の日付を確認してください",
            "Available": "利用可能",
            "No assets category": "資産カテゴリなし",
            "No videos folder": "ビデオフォルダがありません",
            "No videos category": "ビデオカテゴリなし",
            "No channels category": "チャネル カテゴリなし",
            "Create Auto Captions": "自動キャプションを作成する",
            "Creating Auto Caption": "自動キャプションを作成する",
            "Create Auto Caption": "自動キャプションを作成",
            "Default Language": "既定の言語",
            "Last login": "最終ログイン",
            "Change view": "見方を変える",
            "Of": "のうち",
            "All approval status": "すべての承認ステータス",
            "Action rules": "アクションルール",
            "Delete Constraints": "制約を削除",
            "Copy to Constraints": "制約にコピー",
            "Published History": "公開された履歴",
            "Channel Name": "チャンネル名",
            "Accounts": "アカウント",
            "Account settings": "アカウント設定",
            "Add Accounts": "アカウントを追加",
            "URL for Posting": "投稿用のURL",
            "Kakaotalk": "カカオトーク",
            "Select Accounts": "アカウント選択",
            "Go to": "移動",
            "Expired date :": "有効期限：",
            "Timeshift": "タイムシフト",
            "Sec": "秒",
            "DeleteFaceIndex": "顔インデックス削除",
            "ModifyFaceIndex": "顔インデックス修正",
            "EditFaces": "顔の編集",
            "FaceToIndex": "顔インデクシング",
            "FaceToUnindex": "顔アンインデクシング",
            "FacesIndexed": "インデックス付きの顔",
            "StorageClass": "ストレージクラス",
            "Last Modified": "最終更新日",
            "Objects": "オブジェクト",
            "View More": "もっと見る",
            "No buckets folder": "バケットフォルダなし",
            "Access": "アクセスする",
            "Manage": "管理する",
            "Source Buckets": "ソースバケット",
            "Bucket": "バケツ",
            "Custom": "カスタム",
            "Header": "ヘッダ",
            "Setting": "設定",
            "Theme": "テーマ",
            "White": "白い",
            "Black": "黒",
            "CI": "ロゴ",
            "BG": "背景",
            "Color": "色",
            "Text button": "テキストボタン",
            "Quick Select": "クイック選択",
            "User": "ユーザー",
            "Language Settings": "言語設定",
            "Specific Language": "特定の言語",
            "Auto Language": "自動言語",
            "Extension": "拡張子",
            "All extensions": "すべての拡張子",
            "Create FILE asset": "FILE資産生成",
            "Go analysis": "分析へ移動",
            "Copy to": "複写",
            "Copy": "複写",
            "Move": "移動",
            "All Storage Class": "すべてのストレージクラス",
            "Standard": "標準",
            "Reduced Redundancy": "低冗長化ストレージ",
            "Stanard-IA": "標準-IA",
            "One Zone-IA": "Oneゾーン-IA",
            "Intelligent Tiering": "Intelligent Tiering",
            "Glacier": "Glacier",
            "Deep Archive": "Deep Archive",
            "Outposts": "Outposts",
            "Channel Overview": "チャネル概要",
            "Meeting": "会議",
            "Rooms": "会議室",
            "Recent Schedule": "最近のスケジュール",
            "out of {{total}}": "全体{{total}}個のうち",
            "Lock": "ロック",
            "Disabled": "未使用",
            "Create Channel": "チャンネル作成",
            "Meetings": "ミーティング",
            "Unlock": "ロック解除",
            "Locked": "ロック",
            "All": "全体",
            "Megazone Accounts": "メガゾーンアカウント",
            "Megazone Login": "メガゾーンログイン",
            "Sign in with Megazone Login": "Megazoneログインでサインイン",
            "or": "または",
            "Basic": "ベーシック",
            "Analyze by timestamp": "タイムスタンプによる分析",
            "Usage Time": "使用時間",
            "Music": "ミュージック",
            "Photo": "写真",
            "Audio Sources": "オーディオソース",
            "Album Images": "アルバム画像",
            "Teaser Images": "ティーザー画像",
            "Music Videos": "ミュージックビデオ",
            "Teaser Videos": "ティーザービデオ",
            "Live Videos": "ライブビデオ",
            "Music Description": "音楽の説明",
            "No musics category": "音楽カテゴリなし",
            "INACTIVE": "非アクティブ",
            "Update {{name}}": "{{name}}の編集",
            "{{name}} Description": "{{name}}の説明",
            "Share": "共有",
            "Shared Box": "シェアボックス",
            "Share Box": "シェアボックス",
            "Shared Date": "共有日",
            "Share to me": "私に共有する",
            "Share by me": "私が共有する",
            "Add to Shared Box": "共有ボックスに追加",
            "Remove from Share Box": "共有ボックスから削除",
            "Shared {{name}}": "共有 {{name}}",
            "Share Management": "共有管理",
            "Shared with Me": "共有",
            "Requested to Share": "共有の要求",
            "Requester": "要請者",
            "Requested": "リクエスト済み",
            "Review Request": "レビューリクエスト",
            "Review Access Request": "アクセス要求の確認",
            "Please add {{name1}} and {{name2}}.": "{{name1}}と{{name2}}を追加してください。",
            "Phone Number": "電話番号",
            "Asset Sharer": "資産シェアラー",
            "Quick": "クイック",
            "Advanced": "高度な",
            "Show": "公演",
            "{{view}} Search fields": "{{view}} 検索フィールド",
            "Search for assets by all projects.": "すべてのプロジェクトで資産を検索します。",
            "<0>{{count}}</0> Results for your Search": "<0>{{count}}</0> 検索結果",
            "Management": "管理",
            "Assets to be shared": "共有する資産",
            "Please add {{name}}.": "追加してください {{name}}.",
            "Image Viewer": "画像ビューア",
            "Images Viewer": "画像ビューア",
            "Result of <0>{{name}}</0>": "<0>{{name}}</0> の結果",
            "Download Link": "ダウンロードリンク",
            "Elements": "要素",
            "This download link URL is only available for one week from now.": "このダウンロードリンクのURLは、今から1週間のみ利用できます。",
            "Preparing download link URL": "ダウンロードリンクURLの準備",
            "No Images List": "画像リストなし",
            "File Meta": "ファイルメタ",
            "Operation": "操作",
            "Versions": "バージョン",
            "Version": "バージョン",
            "Current Version": "現在のバージョン",
            "My Activity": "私の活動",
            "Share Management Rules": "共有管理ルール",
            "Users and teams belonging to the project for the selected asset are excluded from sharing.": "選択した資産のプロジェクトに属するユーザーとチームは、共有から除外されます。",
            "Search for assets in this project.": "このプロジェクトの資産を検索します。",
            "Recent People": "最近の人",
            "Recent Music": "最近の音楽",
            "Recent Photos": "最近の写真",
            "Recent Photo": "最近の写真",
            "Reason for sharing request (Optional)": "リクエストを共有する理由（オプション）",
            "Request Access": "アクセスをリクエストする",
            "Display Name": "表示名",
            "Department": "部門",
            "results": "結果",
            "Sharer": "共有者",
            "Shared": "共有",
            "Last Login": "前回のログイン",
            "Spec": "スペック",
            "Asset’s Project": "資産のプロジェクト",
            "All Projects": "すべてのプロジェクト",
            "All Users": "すべてのユーザー",
            "Only mine": "自分のみ",
            "Rename": "名前を変更",
            "Moving": "動く",
            "Copying to": "コピー先",
            "Deleting": "削除",
            "Renaming": "名前の変更",
            "{{type}} completed.": "{{type}} が完了しました。",
            "Partial {{type}} completed.": "部分的な{{type}}が完了しました。",
            "{{type}} canceled.": "{{type}} がキャンセルされました。",
            "{{type}} error.": "{{type}} エラー。.",
            "Overwrite or skip file": "ファイルを上書きまたはスキップする",
            "Pending {{type}}...": "{{type}} 保留中...",
            "Ask": "常に尋ねる",
            "Always Overwrite": "常に上書きする",
            "Always Skips": "常にスキップする",
            "Handling in case of duplicate files": "重複ファイルの場合の処理する",
            "Apply to all": "すべてに適用",
            "Shares": "共有",
            "Accessible Projects": "アクセシブルなプロジェクト",
            "Recent Videos": "最近のビデオ",
            "Recent Assets Shared with Me": "私と共有されている最近の資産",
            "Search all assets": "すべての資産を検索",
            "Search assets": "資産検索",
            "Add Users and Teams": "ユーザーとチームを追加",
            "Project Settings": "プロジェクト設定",
            "Back to Console": "コンソールに戻る",
            "No related assets": "関連する資産はありませんNo related assets",
            "No reference": "参照なし",
            "My Assets": "私の資産",
            "Group": "グループ",
            "Group ID": "グループID",
            "Groups": "グループ",
            "No Groups": "グループなし",
            "Add groups": "グループの追加",
            "Add Users and Groups": "ユーザーとグループの追加",
            "Enter Users and Groups": "ユーザーとグループを入力してください",
            "Assets shared with the group are not deleted": "グループと共有されている資産は削除されません",
            "Group overview": "グループの概要",
            "Selected files": "選択されたファイル",
            "Create by Transcoding": "トランスコーディングによる作成",
            "Create as Assets": "資産として作成",
            "ItemSet for Metadata": "メタデータのアイテムセット",
            "ItemSet": "アイテムセット",
            "Items": "アイテム",
            "Multiple": "複数",
            "Storage": "ストレージ",
            "CaptionSync": "キャプション同期",
            "Fast": "早く",
            "Slow": "遅い",
            "No Time Change": "時間変更なし",
            "Time Control": "時間制御",
            "No captions": "キャプションなし",
            "Edit Captions": "キャプションの編集",
            "sec": "秒",
            "Interactive Video": "インタラクティブビデオ",
            "Interactive Videos": "インタラクティブビデオ",
            "Open Chatting": "オープンチャット",
            "Group Chatting": "グループチャット",
            "Add Attendees": "参加者を追加する",
            "Recoding": "再コーディング",
            "Ending Video": "エンディングビデオ",
            "msec": "ミリ秒",
            "Enter Email Address": "メールアドレスを入力してください",
            "Intro Video URL": "イントロビデオURL",
            "Ending Video URL": "終了ビデオURL",
            "Empty Recording History": "空の録音履歴",
            "Recording History": "録音履歴",
            "Recording Time": "録音時間",
            "Intro Videos": "イントロビデオ",
            "Ending Videos": "エンディングビデオ",
            "No Schedule": "スケジュールなし",
            "Input file upload error": "入力ファイルのアップロードエラー",
            "Input file preprocessing error": "入力ファイルの前処理エラー",
            "MediaConvert transcoding error": "MediaConvertトランスコーディングエラー",
            "Input file post processing error": "入力ファイルの後処理エラー",
            "Console first entry screen": "コンソールの最初の入力画面",
            "Add attendees to join the Group Chatting": "グループチャットに参加する参加者を追加します",
            "Add attendees": "出席者を追加",
            "Schedule Name": "スケジュール名",
            "Schedule Time": "予定時刻",
            "Channel type": "チャネルタイプ",
            "Video latency": "ビデオの待ち時間",
            "Playback authorization": "再生認証",
            "Standard latency": "標準レイテンシ",
            "Ultra-low latency": "超低レイテンシー",
            "Amazon IVS": "Amazon IVS",
            "Amazon Chime": "Amazon Chime",
            "Playback": "再生",
            "Recordings": "録音",
            "Recorded Videos": "録画したビデオ",
            "Event Time": "イベント時間",
            "Storage Path": "ストレージパス",
            "Change after channel creation": "チャネル作成後に変更する",
            "Create Assets on creation": "作成時に資産を作成する",
            "Manage Access": "アクセスの管理",
            "Search with subcategories": "サブカテゴリで検索",
            "Service Provider": "サービスプロバイダー",
            "Sync complete": "同期が完了しました",
            "Sync failed": "同期に失敗しました",
            "Synchronizing": "同期",
            "Sync refresh": "同期の更新",
            "Projects Allowed To Use": "使用が許可されているプロジェクト",
            "SPACE ADMINISTRATION": "SPACE 管理",
            "CloudPlex Delivery": "CloudPlex デリバリー",
            "CloudPlex Start": "CloudPlex スタート",
            "Switch to Admin": "管理者に切り替えます",
            "Add User": "ユーザーの追加",
            "UserName": "ユーザー名",
            "Last Access": "最終アクセス",
            "out of": "合計 ",
            "Indexed Faces": " インデックス付き顔のうち",
            "Products": "製品",
            "Customer Service": "顧客サービス",
            "Invitation Pending": "招待保留中",
            "Has Space Access": "スペースアクセスがあります",
            "No Space Access": "スペースアクセスなし",
            "Member": "メンバー",
            "Trusted": "信頼できる",
            "No role": "役割なし",
            "Revoke space access": "スペースアクセスを取り消す",
            "Last Name": "苗字",
            "First Name": "ファーストネーム",
            "Phone number": "電話番号",
            "Company": "会社",
            "Position": "ポジション",
            "’s Detail": "の詳細",
            "Has access on Space": "宇宙にアクセスできます",
            "Administrator": "管理者",
            "Any role": "任意の役割",
            "Last Activity": "最後の活動",
            "Grant space access": "スペースアクセスを許可する",
            "Remove user": "ユーザーを削除する",
            "Add {{number}} users": "{{number}}ユーザーを追加",
            "Add user": "ユーザーを追加する",
            "Add attribute": "属性の追加",
            "Next": "次",
            "Photos": "写真",
            "Zoom in": "ズーム",
            "Zoom out": "縮小",
            "Previous": "以前",
            "Compressing": "圧縮中",
            "Ready to {{type}}": "{{type}}の準備ができました",
            "Select Files": "ファイル選択",
            "Edit Default Metadata": "基本的なメタデータの編集",
            "Edit and Create Assets": "資産の編集と作成",
            "Create assets": "資産の作成",
            "create assets": "資産の作成",
            "Create Assets": "資産の作成",
            "assets": "資産",
            "Asset creation": "資産の作成",
            "Create Assets Bulk": "資産の一括作成",
            "Selected Files": "選択したファイル",
            "Edit Metadata": "メタデータの編集",
            "APPLY ALL OVER Options": "オプション全体に適用",
            "Apply All Over": "完全適用",
            "Set as Options": "オプションとして設定",
            "Asset Name Alias": "資産名エイリアス",
            "Choose Bulk Operation": "一括操作の選択",
            "Asset Type": "資産タイプ",
            "Asset Composition Type": "資産構成タイプ",
            "Set to Default": "デフォルトに設定",
            "Preparing {{type}}...": "{{type}}を準備しています...",
            "Add Files to Bulk": "バルクファイルの追加",
            "Choose Files": "ファイル選択",
            "A total of <0> {{number}} </0> files can be added.": "合計<0> {{number}} </0>個のファイルを追加できます。",
            "Add All": "すべて追加",
            "If a file is changed or deleted from the storage list": "ストレージリストからファイルを変更および削除した場合",
            "Asset Composition Types": "資産構成タイプ",
            "Auto-apply language & labels": "言語とラベルの自動適用",
            "Ex": "はい",
            "Single Asset": "シングル資産",
            "Multiple Asset": "マルチ資産",
            "Filters": "フィルター",
            "Add Assets": "資産 追加",
            "No Files": "ファイルなし",
            "Caption Type Asset Creation Rules": "キャプションタイプ資産作成ルール",
            "Language & Label": "言語とラベル",
            "If there is a language code after the file name (_)": "ファイル名（_）の後に言語コードがある場合",
            "If there is no language code after the file name (_)": "ファイル名（_）の後に言語コードがない場合",
            "Add <0> {{number}} </0> file(s)": "<0> {{number}}</0>ファイルを追加します",
            "Ready": "準備",
            "In Progress": "進行中",
            "FAILED": "失敗",
            "NOT_SUPPORTED": "未対応",
            "PARTIAL_COMPLETED": "一部完了",
            "Video and image content analysis": "映像・画像コンテンツ解析",
            "Metadata analysis": "メタデータ解析",
            "AI search mode indexing": "AI検索モードインデックス",
            "AI search indexing status": "AI検索インデックス状態",
            "AI search mode": "AI検索モード",
            "Indexing status": "インデックス状態",
            "Request to Create Assets": "資産の作成リクエスト",
            "In Order of Accuracy": "正確さの順に",
            "Latest Order": "最新の注文",
            "Only Mine": "私の物のみ",
            "Other then Mine": "その他",
            "Detailed Filter": "詳細なフィルター",
            "Storage Class": "ストレージクラス",
            "Search for storage and assets by all projects.": "すべてのプロジェクトでストレージと資産を検索します。",
            "Please enter your search term": "検索語を入力してください",
            "Please check the search term you entered again.": "入力した検索語をもう一度確認してください。",
            "Only My Buckets": "私のバケットのみ",
            "Other Buckets": "その他のバケット",
            "Only My Projects": "私のプロジェクトのみ",
            "Other Projects": "その他のプロジェクト",
            "No results were found for your search.": "検索結果が見つかりませんでした。",
            "Please re-enter your search term.": "検索語を再入力してください。",
            "Please enter your search term.": "検索語を入力してください。",
            "Select Bucket": "バケットを選択",
            "Choose the bucket you want to use.": "使用するバケットを選択します。",
            "Current Project": "現在のプロジェクト",
            "Accessible": "アクセス可能",
            "Not Accessible": "アクセス不可能",
            "Current": "現在",
            "Project other than this one": "本プロジェクト以外のプロジェクト",
            "Use of features based on access": "アクセス可否に応じた機能の利用",
            "All functions available": "すべての機能が利用可能",
            "All functions unavailable": "すべての機能を無効にする",
            "Partial functions unavailable": "一部の機能が利用可能",
            "Folder path to check": "確認するフォルダのパス",
            "Current project": "現在のプロジェクト",
            "Switch Project": "プロジェクトの切り替え",
            "Project to switch to": "切り替えるプロジェクト",
            "Add users and teams to share": "共有するユーザーとチームを追加する",
            "Link Setting": "リンク設定",
            "Password": "パスワード",
            "Link": "リンク",
            "download link URL": "ダウンロードリンクURL",
            "Download Period": "ダウンロード期間",
            "Number of Downloads": "ダウンロード数",
            "Files to share": "共有するファイル",
            "The files to download are ready.": "ダウンロードするファイルの準備ができました。",
            "The number of password errors has been exceeded.": "パスワードエラーの数を超えました。",
            "The download period of times has expired.": "ダウンロード期間が終了しました。",
            "The download number of times has expired.": "ダウンロード回数が終了しました。",
            "The page not found.": "ページが見つかりません。",
            "Enter your Password": "パスワードを入力してください",
            "Show Password": "パスワードを表示",
            "Enter {{name}}": "{{name}}を入力",
            "Done": "完了",
            "Enter Name": "名前を入力",
            "Share Link": "共有リンク",
            "Share Request": "共有リクエスト",
            "Choose One Approver": "承認者を 1 人選択",
            "File to request": "依頼するファイル",
            "Send request": "リクエストを送信",
            "Expires At": "有効期限",
            "History of my request to share": "私の共有リクエストの履歴",
            "History of requests to share": "共有リクエストの履歴",
            "Previous Request": "前のリクエスト",
            "Linked Requests": "リンクされたリクエスト",
            "Shared History": "共有履歴",
            "Permission": "許可",
            "Reason for Approval (Optional)": "承認の理由（任意）",
            "Reason for Reject (Optional)": "拒否の理由 (オプション)",
            "Select User": "ユーザーを選択",
            "Canceled": "キャンセルされた",
            "Shared by me": "私が共有した",
            "Shared with me": "私と共有",
            "Shared with": "と共有",
            "Revoke": "取り消す",
            "Revoked": "取り消し済み",
            "Revoke access": "アクセス権の取り消し",
            "Revoke link": "取り消す",
            "File to be shared": "共有するファイル",
            "By last shared": "最終共有順",
            "By last modified": "最終更新日",
            "By name": "名前",
            "By type": "タイプ別",
            "Removed": "削除されました",
            "Manage shared with": "共有相手を管理",
            "Send email with password": "パスワード付きのメールを送信",
            "Include": "含む",
            "Not Include": "含まれていない",
            "Request expired": "リクエストの期限切れ",
            "Shared by": "共有者",
            "Create Videos": "ビデオ生成",
            "Create People": "ピープル生成",
            "Create Music": "ミュージック生成",
            "Create Photo": "写真生成",
            "Folder Path": "フォルダ パス",
            "Select Folder Path": "フォルダ パスを選択",
            "Folder View": "フォルダ ビュー",
            "Category View": "カテゴリ ビュー",
            "View All": "すべて見る",
            "Zendesk Widget": "Zendesk ウィジェット",
            "Widget": "ウィジェット",
            "Widget Settings": "ウィジェット設定",
            "Zendesk Settings": "Zendeskの設定",
            "Zendesk Domain": "Zendesk ドメイン",
            "API Token": "APIトークン",
            "Locale": "ロケール",
            "Page URL": "ページの URL",
            "Show API Token": "APIトークンを表示",
            "Section ID": "セクション ID",
            "Topic ID": "トピックID",
            "Minimum Image Size": "最小画像サイズ",
            "Metadata Template": "メタデータテンプレート",
            "Name Prefix": "名前の接頭語",
            "Metadata Preset": "メタデータプリセット",
            "Metadata Name Prefix": "メタデータ名前の接頭語",
            "Metadata Template Name": "メタデータテンプレートの名前",
            "Metadata Template Description": "メタデータテンプレートの説明",
            "Select Metadata Template": "メタデータテンプレート選択",
            "Asset to share": "共有する資産",
            "Message": "メッセージ",
            "Message (Optional)": "メッセージ（オプション）",
            "Send": "送信",
            "Add Users": "ユーザーの追加",
            "Pending changes": "保留中の変更",
            "Access Updated": "アクセス更新",
            "No Assets Folders": "資産 フォルダがありません",
            "Select Category Group": "カテゴリ グループを選択",
            "<0> {{number}} </0> days": "<0> {{number}} </0>日",
            "<0/> times": "<0/>回",
            "Discard": "破棄",
            "Asset Name Prefix": "資産名のプレフィックス",
            "Folder Path Option": "フォルダ経路設定",
            "Save assets to the top-level path on the drive": "ドライブのトップレベルフォルダに資産を保存",
            "Save assets according to the storage folder path": "ストレージフォルダのフォルダに従って資産を保存",
            "Save assets to the selected folder": "選択したフォルダに資産を保存",
            "share": "共有",
            "Search Category Group": "カテゴリグループの検索",
            "Clear All": "すべてクリア",
            "Grouping View mode": "グループビューモード",
            "View All mode": "リストモード",
            "In Use": "使用中",
            "Not Used": "未使用",
            "File to share": "共有するファイル",
            "Requested At": "リクエスト日",
            "Subject": "要求事項",
            "Share Expires Date": "共有有効期限",
            "Approval Status": "承認ステータス",
            "Status Updated": "ステータス更新日",
            "Shared History Action": "承認/拒否",
            "Approver": "承認者の選択",
            "Sharehistory": "共有履歴",
            "Sharebox": "シェアボックス",
            "Internal Share": "内部シェア",
            "External Share": "外部シェア",
            "asset creation": "資産の作成",
            "Creating asset...": "資産の作成中...",
            "No {{type}} Categories": "{{type}}カテゴリなし",
            "Delete the asset?": "資産を削除しますか?",
            "Apply All": "すべて適用",
            "Delete the item?": "アイテムを削除しますか?",
            "Location": "位置",
            "Specify Here": "ここで指定",
            "Move the item?": "このアイテムを移動しますか？",
            "Move these items?": "これらのアイテムを移動しますか？",
            "Asset Created": "資産が作成されました",
            "History of my internal share requests": "要求された内部共有履歴",
            "History of internal sharing requests to me": "要求された内部共有履歴",
            "History of my external sharing": "外部共有履歴",
            "No list": "リストなし",
            "Restore the item?": "アイテムを復元しますか？",
            "Change Restore Option": "復元オプションの変更",
            "Users shared with": "共有された人",
            "Status of ready": "準備状態",
            "Expiration Date": "満了日",
            "Items Shared": "共有アイテム",
            "Histories": "ヒストリー",
            "Shared Histories": "共有ヒストリー",
            "Search owner": "所有者の検索",
            "Search extension": "拡張機能の検索",
            "Search type": "タイプの検索",
            "Search filter": "フイルターの検索",
            "Search status": "状態の検索",
            "Mail Language Settings": "メール言語設定",
            "History of external share": "外部共有ヒストリー",
            "Calulating...": "計算中...",
            "Asset Search Results": "資産検索結果",
            "API Endpoint": "APIエンドポイント",
            "Information": "情報",
            "USED": "使用",
            "UNUSED": "未使用",
            "Archive after adding assets": "資産追加後にアーカイブする",
            "Moving to CloudPlex Assets": "CloudPlex 資産への移行",
            "Download All": "すべてダウンロード",
            "Starred": "スター付き",
            "Hi, {{name}}": "こんにちは！{{name}}",
            "Switch to": "切り替え先",
            "Add to Starred": "スターを付ける",
            "Remove from Starred": "スターを外す",
            "Column Settings": "列設定",
            "Sort in descending order": "降順ソート",
            "Sort in ascending order": "昇順ソート",
            "Project Name": "プロジェクトの名前",
            "Project Lead": "プロジェクトリーダー",
            "Sort by": "並び替え",
            "by name": "名前順",
            "by most recent": "最新の順",
            "by update": "アップデート順",
            "Last Updated": "最終修正日",
            "Hide all": "すべて隠す",
            "CPA_ARCHIVED": "アーカイブ済み",
            "CPA_ARCHIVING": "アーカイビ中",
            "CPA_RESTORING": "復元中",
            "CPA_ERROR": "エラー",
            "PUBLIC": "公開",
            "PRIVATE": "非公開",
            "Add Project": "プロジェクト追加",
            "Grid Layout": "グリッドレアウト",
            "List Layout": "リストレイアウト",
            "Lead": "リーダー",
            "New": "追加",
            "Project unassigned": "未割り当てのプロジェクト",
            "Replace Asset": "資産を置き換える",
            "Set lockout for other users": "他のユーザーのロック設定",
            "locked by": "ロック",
            "Me": "自分",
            "Locked by": "ロック",
            "locked by '{{name}}({{username}})'": "{{name}}（{{username}}）がロックされました",
            "locked by 'Me'": "私はロック",
            "Automatic Bucket Lock Options": "自動バケットロックオプション",
            "Auto-Lock Enabled": "自動ロックが有効になっています",
            "Size of files Option": "ファイルサイズ オプション",
            "Size of files": "ファイルのサイズ",
            "Number of files": "ファイル数",
            "Number of files Option": "ファイル数 オプション",
            "Default Archive Option": "デフォルトのアーカイブ オプション",
            "Allow customization when archiving": "アーカイブ時にカスタマイズを許可する",
            "Default Restore Options": "デフォルトの復元オプション",
            "Archive Option": "アーカイブオプション",
            "Restore Option": "復元オプション",
            "Back to Project": "プロジェクトに戻る",
            "Archive the item?": "アイテムをアーカイブしますか?",
            "Archive items?": "アイテムをアーカイブしますか?",
            "Restore items?": "アイテムを復元しますか？",
            "files": "ファイル",
            "CPD Integrations": "CPD 統合",
            "Credentials Information": "資格情報",
            "CloudPlex Delivery Information": "CloudPlex Delivery 情報",
            "Switch Admin": "スイッチ管理者",
            "Space List": "スペースリスト",
            "App Download": "アプリのダウンロード",
            "REQUEST_ARCHIVE": "アーカイブ要求",
            "REQUEST_RESTORE": "復元要求",
            "ARCHIVE_ERROR": "アーカイブエラー",
            "RESTORE_ERROR": "復元エラー",
            "RESTORED": "復元済み",
            "Add Collection": "コレクション追加",
            "Collections": "コレクションズ",
            "Assets Count": "資産の数",
            "Collection Details": "コレクション詳細",
            "Collection ID": "コレクションID",
            "Linked Collections": "リンクされたコレクション",
            "All Media Types": "すべてのメディアタイプ",
            "Specify the folder location?": "フォルダーの場所を指定しますか?",
            "Select assets through search": "検索による資産の選択",
            "Select assets in a specific folder?": "特定のフォルダー内の資産を選択する?",
            "Select assets in a specific folder": "特定のフォルダー内の資産を選択する",
            "Selected Assets": "選択された資産",
            "max": "最大",
            "Also include assets from subfolders": "サブフォルダーの資産も含める",
            "Only assets in that folder are selected": "そのフォルダの資産のみを含める",
            "Selected a Folder": "選択したフォルダ",
            "Selected Collections": "厳選されたコレクション",
            "Add assets?": "資産を追加しますか？",
            "Collections Search Results": "コレクションの検索結果",
            "Enter ID": "ID入力",
            "Enter the creator": "作成者を入力",
            "Enter the person who modified it": "編集した人を入力",
            "Enter name": "名前を入力",
            "Collection": "コレクション",
            "Specify the collection?": "コレクションを指定しますか?",
            "Assets to be created can be managed by applying them to a specific collection.": "作成する資産は、特定のコレクションに適用して管理できます。",
            "Specify the folder where the assets will be located. If not specified, it will be saved in the top path.": "資産を配置するフォルダーを指定します。指定しない場合は、先頭のパスに保存されます。",
            "Duplicate": "コピー",
            "Add Fields": "フィールドを追加",
            "Metadata Fields": "メタデータフィールド",
            "Reference Fields": "参照フィールド",
            "Hidden": "隠す",
            "Fields": "フィールド",
            "Enter default text": "基本テキストを入力してください。",
            "Enter default number": "基本数字を入力してください。",
            "Required": "必須",
            "Create Content Schema": "コンテンツスキーマを生成",
            "Content Schemas": "コンテンツスキーマ",
            "Details": "詳細",
            "Search for the project name.": "プロジェクト名を検索します。",
            "Fields Search": "フィールド検索",
            "No Metadata Fields yet.": "メタデータ フィールドはまだありません。",
            "No Reference Fields yet.": "まだ参照フィールドがありません。",
            "Custom Fields": "ユーザー定義フィールド",
            "No {{isReference}} Fields yet.": "{{isReference}}フィールドがありません。",
            "Enter field name": "フィールド名を入力してください。",
            "Select type": "タイプを選択",
            "Select status": "状態を選択",
            "Remove the item?": "アイテムを取り除きますか？",
            "Remove items?": "アイテムを取り除きますか？",
            "Delete items?": "アイテムを削除しますか？",
            "Archiving asset...": "資産をアーカイブしています...",
            "Restoring asset...": "資産を復元しています...",
            "Create {{schemaName}}": "{{schemaName}}の生成",
            "Selected Image": "選択した画像",
            "Selected {{referenceType}}": "選択した{{referenceType}}",
            "Enter text": "テキストを入力してください。",
            "Enter number": "数字を入力してください。",
            "No {{name}} yet.": "まだ{{name}}がありません。",
            "Enter description": "説明を入力してください。",
            "Engine to Use": "使用するエンジン",
            "Service Type": "サービスの種類",
            "Auto Language (<Strong>{{n}}</Strong>/max. {{max}})": "自動言語（<Strong> {{n}}</Strong> /最大{{max}}）",
            "Vocabulary Book": "単語帳",
            "Select Vocabulary Book": "単語帳の選択",
            "Not Selected": "選択されていない",
            "Select Default Language": "基本言語の選択",
            "Go to vocabulary book": "単語帳に移動",
            "Speaker Classification": "話者の分類",
            "Enter Label": "ラベルを入力してください",
            "Enter Asset name": "資産名を入力してください",
            "Sounds Like": "発音に似た単語",
            "Display As": "表示する単語",
            "Add Vocabulary": "単語を追加",
            "Enter Display As": "表示する単語を入力してください",
            "Enter Sounds Like (Enter after typing)": "発音に似た言語を入力してください (入力後Enterキー)",
            "Credentials": "資格情報",
            "Engines": "エンジン",
            "Available in Auto Captions.": "自動キャプションで利用できます。",
            "Before input": "入力前",
            "Typing": "入力中",
            "Editing": "修正中",
            "Input complete": "入力完了",
            "Assets > Video Asset Detail > Related Assets": "資産>ビデオ資産の詳細>リンク資産",
            "Contents > Videos Detail > Captions > Auto Captions": "コンテンツ>ビデオの詳細>キャプション>オートキャプション",
            "Additional informations": "追加情報",
            "Auto caption": "オートキャプション",
            "Console Default Language": "コンソールのデフォルト言語",
            "List Default Layout": "リストのデフォルトのレイアウト",
            "Additional AI analysis": "追加分析",
            "View timestamps": "タイムスタンプを見る",
            "Start AI analysis": "AI分析の開始",
            "AI analysis completed": "AI分析完了",
            "AI Analysis": "AI分析",
            "Added to Check timestamp": "「タイムスタンプの確認」に追加されました",
            "Removed from Check timestamp": "「タイムスタンプの確認」から削除されました",
            "Removed from Metadata tags": "「メタデータタグ」から削除されました",
            "Added to Metadata tags": "「メタデータタグ」に追加されました",
            "Engine": "エンジン",
            "Summary analysis result": "要約分析結果",
            "Original analysis result": "元の分析結果",
            "Top 10 most exposed labels": "露出の多いラベルトップ10",
            "Exposure Point (First / Last)": "露出点（最初/最後）",
            "Label detection in Video": "ビデオのラベルを検出します。",
            "Recognize Faces in Video": "ビデオでインデックス付きの顔を認識します。",
            "Recognize Celebrity in Video": "ビデオで有名人の顔を認識します。",
            "Content Moderation in Video": "ビデオの有害性検査を行います。",
            "Video transcription": "ビデオの音声を書き込む。",
            "Long audio transcription": "音声ファイルを文字として書き込む。",
            "Annotate Scenes in Video": "動画のシーンを分析する",
            "Recognize Texts in Video": "ビデオ内のテキストを認識します。",
            "Avg. Confidence (%)": "平均信頼(%)",
            "Timestamp - Start": "タイムスタンプ - 開始",
            "Timestamp - End": "タイムスタンプ - 終了",
            "Analysis result {{number}}": "分析結果 {{number}}",
            "Auto Detected": "自動検出",
            "Check timestamp for each label": "ラベルによるタイムスタンプの確認",
            "View Details": "詳細を見る",
            "Fold": "折り畳み",
            "Expand": "拡大する",
            "point of initial exposure": "最初の露出のポイント",
            "last exposure point": "最後の露出ポイント",
            "Update Asset": "資産更新",
            "Reply to thread": "スレッドに返信",
            "Edit message": "メッセージを編集する",
            "Add reaction": "リアクションを追加",
            "Delete message": "メッセージを削除する",
            "{{commentCount}} replies": "{{commentCount}} 件の返信",
            "See all replies": "すべての返信を見る",
            "replies": "返信",
            "Thread": "スレッド",
            "Reply": "返信",
            "Replied to :": "返信先 :",
            "Yesterday": "昨日",
            "member of comment": "コメントのメンバー",
            "Change name": "名前を変更する",
            "Private comment name (maximum <0>{{count}}</0> characters)": "プライベートコメント名 (最大 <0>{{count}}</0> 文字)",
            "Add member": "メンバーを追加する",
            "Delete private comment": "プライベートコメントを削除する",
            "All public": "全体公開",
            "member": "メンバー",
            "Check": "確認",
            "Private comment name": "プライベートコメント名",
            "Comments where I was mentioned": "私が言及されたコメント",
            "Comments written by me": "私が書いたコメント",
            "Comments in threads I belong to": "私が所属しているスレッドのコメント",
            "Reply to my comment": "私のコメントに返信してください",
            "My Comments": "私のコメント",
            "Waiting for invitation": "招待待機中",
            "User invitation": "ユーザーの招待",
            "Would you like to invite users?": "ユーザーを招待しますか?",
            "Invite": "招待",
            "Accessible project": "アクセシブルなプロジェクト",
            "Invitation date": "招待日",
            "Pending Invitation": "保留中の招待",
            "User waiting to be invited": "招待を待っているユーザー",
            "Projects you want to allow access to": "アクセスを許可したいプロジェクト",
            "Manual settings": "手動設定",
            "Auto settings": "自動設定",
            "ROLES_Read": "読み取り許可",
            "ROLES_Edit": "編集権限",
            "ROLES_Archive": "アーカイブ権限",
            "ROLES_Download": "ダウンロード許可",
            "ROLES_Internal": "内部シェア許可",
            "ROLES_External": "内・外部シェア許可",
            "ROLES_Publish": "公開許可",
            "ROLES_Internal Request": "内部リクエストの許可",
            "Create Roles": "役割作成",
            "No permission": "許可なし",
            "Custom Metadata": "カスタムメタデータ",
            "Select Content Schema": "コンテンツスキーマの選択",
            "Search by content schema name.": "コンテンツスキーマ名で検索します。",
            "Selected schema": "選択されたスキーマ",
            "CreatedAt": "作成日",
            "Accessed": "アクセス済み",
            "Add Users or Groups": "ユーザーまたはグループの追加",
            "Share Settings": "共有設定",
            "Add to Added Users": "追加されたユーザーに追加",
            "Maximum": "最大",
            "times": "回",
            "Current location": "現在位置",
            "Where to clone": "複製する場所",
            "Save to top path": "最上位パスに保存",
            "Parent folder": "親フォルダ",
            "Parent folder location": "親フォルダの場所",
            "Select file": "ファイル選択",
            "Unapply": "適用キャンセル",
            "Undo add": "追加キャンセル",
            "Clear": "クリア",
            "Choose one custom data.": "1つのカスタムデータを選択してください。",
            "Folder Duplication": "フォルダの複製",
            "Duplication target folder": "複製先フォルダ",
            "Asset to be duplicated": "複製する資産",
            "Request share": "共有要請",
            "Share link": "共有リンク",
            "Downloader Permission Settings": "ダウンローダの権限設定",
            "Sharing Period": "共有期限",
            "info": "情報",
            "Specify Folder Location": "フォルダーの場所を指定する",
            "Select by Recent Location": "最近の場所で選択",
            "Create a private comment": "プライベートコメントを作成する",
            "Open comment window": "コメントウィンドウを開く",
            "Close comment window": "コメントウィンドウを開く",
            "Specify Collection": "コレクションの指定",
            "Moving to CloudPlex Media…": "CloudPlex Mediaに移行中…",
            "Recent Assets Shared To Me": "私に共有された最近の資産",
            "edited": "編集済み",
            "Uploading files": "ファイルのアップロード",
            "Cancel Upload": "アップロードのキャンセル",
            "Attach Files": "ファイルを添付する",
            "Mention": "言及",
            "Attach Emoji": "絵文字",
            "Files cannot be attached.": "ファイルを添付できません。",
            "Select collections in a specific folder?": "特定のフォルダー内のコレクションを選択",
            "Asset Duplication": "資産の複製",
            "Added Users": "追加されたユーザーに追加",
            "Custom Content": "カスタムコンテンツ",
            "Storages": "ストレージ",
            "Custom Contents": "カスタムコンテンツ",
            "All categories": "すべてのカテゴリ",
            "Default Custom Metadata": "デフォルトのカスタムメタデータ",
            "Default View Mode": "デフォルトの表示モード",
            "List view": "リストビュー",
            "Folder view": "フォルダービュー",
            "Category view": "カテゴリビュー",
            "Select default metadata template": "デフォルトのメタデータ テンプレートを選択",
            "Select default custom metadata": "デフォルトのカスタムメタデータを選択",
            "Please enter a message for your request (Optional)": "ご要望のメッセージをご入力ください（任意）",
            "Enter name or email": "名前またはメールアドレスを入力してください",
            "Duplicate this role?": "この役割を複製しますか?",
            "Change Name": "名前を変更する",
            "Enter required values": "必須値を入力する",
            "Select Custom Metadata": "カスタムメタデータの選択",
            "Select custom metadata": "カスタムメタデータの選択",
            "Duplicate within a subfolder": "サブフォルダー内で複製する",
            "Duplication target assets": "複製対象資産",
            "Asset to be copied": "複製対象資産",
            "Create assets from all files individually": "すべてのファイルから資産を個別に作成する",
            "Creating image and caption files as one asset": "画像ファイルとキャプションファイルを 1 つの資産として作成する",
            "Please select files to add": "追加するファイルを選択してください",
            "Select all files": "ファイル全体の選択",
            "InteractiveVideos": "インタラクティブビデオ",
            "Change Menu Name": "メニュー名の変更",
            "Default menu name": "デフォルトのメニュー名",
            "Menu name to change": "変更するメニュー名",
            "Apply as default menu name": "デフォルトのメニュー名として適用",
            "History of share link": "共有リンクの歴史",
            "Delete Group": "グループの削除",
            "COPY_ASSETS": "資産のコピー",
            "UPLOAD_ASSET": "資産の作成",
            "CREATE_ASSETS": "資産の一括作成",
            "UPLOAD": "ストレージのアップロード",
            "ASSET_DOWNLOAD": "資産のダウンロード",
            "STORAGE_DOWNLOAD": "ストレージのダウンロード",
            "Create Asset": "資産の作成",
            "TRANSCODE": "トランスコード",
            "COPY": "コピー",
            "RENAME": "名前の変更",
            "MOVE": "移動",
            "DELETE": "削除",
            "Replication location": "レプリケーションの場所",
            "existing location": "既存の場所",
            "Copy assets": "資産のコピー",
            "Drag files here": "ここにファイルをドラッグしてください",
            "Browse": "検索",
            "drop your files to upload": "アップロードするファイルをドロップします",
            "Downloader": "ダウンローダー",
            "Viewer": "ビューア",
            "Adjust": "調整する",
            "Back to list": "リストに戻る",
            "Back to comments": "コメントに戻る",
            "View private comments": "非公開コメントを表示する",
            "Close private comments": "非公開コメントを閉じる",
            "Select project": "プロジェクトの選択",
            "Role settings": "ロールの設定",
            "All projects": "すべてのプロジェクト",
            "Comments": "コメント",
            "Folders": "フォルダー",
            "Integrated Search": "統合検索",
            "Users & Groups": "ユーザーとグループ",
            "Project In Use": "使用中のプロジェクト",
            "Manage Account": "アカウントの管理",
            "Log out": "ログアウト",
            "Sub menu": "サブメニュー",
            "Storage files": "ストレージファイル",
            "Please enter a description of the asset.": "資産の説明を入力してください。",
            "Create Role": "ロールの作成",
            "Create Workflow": "ワークフロー作成",
            "Comment": "コメント",
            "Specific": "特定の機能",
            "Go to space list": "スペースリストに移動",
            "Bold": "太字",
            "Underline": "下線",
            "Strikethrough": "取り消し線",
            "Share request": "共有リクエスト",
            "contents": "コンテンツ",
            "collections": "コレクション",
            "preview images": "プレビュー画像",
            "Add {{name}}?": "{{name}}を追加しますか?",
            "User invited to group": "ユーザーがグループに招待されました",
            "Space Admin": "スペースマネージャ",
            "Project Admin": "プロジェクトマネージャ",
            "Recent Assets": "最近の資産",
            "archive assets": "資産アーカイブ",
            "ARCHIVE_ASSETS": "資産アーカイブ",
            "An error occurred while preparing {{type}}.": "{{type}}の準備中にエラーが発生しました。",
            "Preparing {{type}}": "{{type}}の準備中",
            "{{type}} in progress": "{{type}} 進行中",
            "Metadata Export": "メタデータのエクスポート",
            "Completed At": "完了日時",
            "PROCESSING": "進行中",
            "search options": "検索のオプション",
            "Export": "エクスポート",
            "Asset creation period": "資産の作成期間",
            "COMPLETED": "完了",
            "Project count": "プロジェクトの数",
            "Additional items": "追加項目",
            "Created At": "作成日時",
            "Updated At": "修正日時",
            "Make": "作る",
            "Export metadata": "メタデータのエクスポート",
            "Selected projects": "選択されたプロジェクト",
            "Asset creation date": "資産の作成日",
            "metadata export": "メタデータのエクスポート",
            "Directly assigned": "直接割り当て",
            "Create Collection": "コレクションの作成",
            "Select scope": "スコープの選択",
            "METADATA_DOWNLOAD": "メタデータのダウンロード",
            "Metadata download": "メタデータのダウンロード",
            "Vocabulary": "単語",
            "Assets Name": "資産の名前",
            "Assets ID": "資産のID",
            "Preview Settings": "プレビュー設定",
            "Assets to share": "共有する資産",
            "Collections to share": "共有するコレクション",
            "Folder to share": "共有するフォルダー",
            "Archive assets": "資産のアーカイブ",
            "COLLECTION_DOWNLOAD": "コレクションのダウンロード",
            "collection download": "コレクションのダウンロード",
            "Event occurrence date and time": "イベント発生日時",
            "Domain": "ドメイン",
            "Admin Audit Logs": "管理監査ログ",
            "Audit log details": "監査ログの詳細",
            "User Agent": "ユーザーエージェント",
            "Select domain": "ドメインの選択",
            "Select action": "アクションの選択",
            "Select requestedBy": "ユーザーの選択",
            "Publishing options": "公開オプション",
            "Player ControlBar Control": "プレーヤー コントロールバー",
            "Start the Player Fullscreen": "プレーヤーを全画面で起動する",
            "Continue after Stopping the Player": "プレーヤーを停止してから続行する",
            "Video Download": "ビデオのダウンロード",
            "Embed code options": "コードの埋め込みオプション",
            "Player Width": "プレーヤーの幅",
            "Auto Play": "自動再生",
            "Loop Play": "ループプレイ",
            "Play directly with the player within the web page": "Web ページ内でプレーヤーを直接プレイする",
            "Copied": "コピーされました",
            "Add Vocabulary Book": "単語帳を追加する",
            "Vocabulary Book ID": "単語帳ID",
            "Shrink": "縮む",
            "Example": "例",
            "1024px or 100%": "1024ピクセルまたは100%",
            "Publishing": "公開中",
            "Reclaiming": "回収中",
            "Published": "公開済み",
            "Unpublished": "解除済み",
            "Enter ResourceId": "リソースIDの入力",
            "Enter ThreadResourceId": "リソースIDの入力",
            "Select projects": "プロジェクトの選択",
            "ResourceId": "リソースID",
            "ThreadResourceId": "リソースID",
            "Select user": "ユーザーの選択",
            "Report collection period": "レポートの収集期間",
            "Whether to send mail": "電子メール発信可",
            "SEND": "発信",
            "NOT SEND": "未発信",
            "Targets and actions": "対象と動作",
            "Email recipients": "電子メールの受信者",
            "Sending cycle": "発信サイクル",
            "REPORT_Create": "生成",
            "REPORT_Delete": "削除",
            "Reports": "レポート",
            "{{value}} people": "{{value}} 名",
            "Total asset count": "資産全体の数",
            "Total asset size": "資産全体の容量",
            "{{period}} {{condition}} tasks": "{{period}}の間{{condition}}作業の数",
            "A week ago": "先週と比較",
            "tasks": "作業",
            "{{period}} total": "{{period}}の間全体",
            "Top <emp>10</emp> projects by {{period}} tasks": "{{period}}作業の上位10個のプロジェクト",
            "Table": "テーブル",
            "Chart": "チャート",
            "{{period}} task count": "{{period}}作業数",
            "{{hour}}:{{minute}} {{period}}": "{{period}} {{hour}}:{{minute}}",
            "AM": "午前",
            "PM": "午後",
            "Pipeline during video creation": "ビデオ作成時のパイプライン",
            "Resource ID": "リソースID",
            "Video editing": "ビデオ編集",
            "Video image capture": "ビデオ画像キャプチャ",
            "Pan": "パン",
            "Zoom": "ズーム",
            "Cut": "カット",
            "Pull start marker": "プルスタートマーカー",
            "Pull end marker": "プルエンドマーカー",
            "Video name": "ビデオ名",
            "Create a video": "動画で作成する",
            "Create an edited video": "編集したビデオを作成する",
            "Edit and save images": "画像の編集と保存",
            "Save as asset": "資産として保存する",
            "Current video time": "現在の映像時間",
            "Aspect custom": "カスタマイズ",
            "Scale": "スケール",
            "Coordinate": "座標",
            "Incision": "カット",
            "frame {{id}}": "{{id}}フレーム",
            "Image size": "画像サイズ",
            "Folder location": "フォルダの場所",
            "Get instant download": "すぐにダウンロードする",
            "Auto-archive status": "自動アーカイブのステータス",
            "Auto-archive enabled": "自動アーカイブ適用中",
            "Auto-archive schedule date": "自動アーカイブのスケジュール日",
            "Date to automatically retain assets after creation or restoration": "作成または復元後に資産を自動的に保持する日付",
            "Prefix before asset name": "資産名の前にプレフィックスを付ける",
            "days later": "数日後",
            "or more": "以上",
            "days left": "残り日数",
            "Select content in a specific folder?": "特定のフォルダー内のコンテンツを選択しますか?",
            "Failure reason": "失敗理由",
            "Unsupported reason": "未対応理由",
            "Field description": "フィールドの説明",
            "Field default value": "フィールドのデフォルト値",
            "Enter field link": "フィールドリンクを入力してください",
            "Add link": "リンクを追加",
            "Add group": "グループ追加",
            "Enter your name": "グループ名を入力してください。",
            "Preparing to share": "共有準備中",
            "Send again": "再送信",
            "Cancel invitation": "招待をキャンセルする",
            "Total file size": "ファイル全体の容量",
            "Total Usage": "全体の容量",
            "Project Settings > Settings > Menu (e.g. Assets) > Category Groups": "プロジェクト設定 > 設定 > メニュー(例: 資産) > カテゴリグループ",
            "Setting location": "設置場所",
            "Category group settings": "カテゴリグループの設定",
            "Please select a custom metadata preset.": "カスタムメタデータプリセットを選択してください。",
            "Load custom metadata schema": "カスタムメタデータスキーマを呼び出す",
            "Load Metadata": "メタデータを読み込む",
            "PROJECT_RESOURCES_DOWNLOAD": "プロジェクトリソースのダウンロード",
            "Project resources download": "プロジェクトリソースのダウンロード",
            "Statistics period": "収集期間",
            "Weekly change": "週替わり",
            "Weekly Asset Count": "週間資産の更新",
            "Weekly File Size": "毎週のファイル使用量",
            "Asset count": "資産数",
            "Comment Room Option": "コメント設定",
            "Project Comment": "プロジェクトのコメント",
            "preview image": "プレビューイメージ",
            "Activity History": "活動履歴",
            "Activity": "活動",
            "Select location": "場所を選択してください",
            "item selected": "選択された項目",
            "Include subfolders": "サブフォルダーを含める",
            "Thumbnail": "サムネル",
            "Maintain image proportions": "画像の比率を維持する",
            "Crop": "トリムする",
            "Create asset": "資産の作成",
            "Menu": "メニュー",
            "Cusom settings": "カスタム設定",
            "Submenu": "サブメニュー",
            "Add menu": "メニューの追加",
            "Add submenu": "サブメニューを追加",
            "Library": "ライブラリ",
            "Menu item settings": "メニュー項目の設定",
            "Menu name": "メニュー名",
            "Add assets from folder": "フォルダーから資産を追加",
            "Downloads": "ダウンロード",
            "Select menu": "メニュー選択",
            "Default settings": "デフォルト設定",
            "Custom settings": "カスタム設定",
            "First entry screen": "最初の画面",
            "First entry screen(Create page)": "最初の画面（作成ページ）",
            "Edit menu": "編集",
            "Shared At": "共有日",
            "VIDEO": "ビデオ",
            "AUDIO": "オーディオ",
            "PEOPLE": "ピープル",
            "TEXT": "テキスト",
            "FILE": "ファイル",
            "Select media type": "メディアの種類を選択してください",
            "Widget Preference": "ウィゼット設定",
            "LastName/FirstName": "姓/名",
            "Site access permission": "サイトアクセス許可",
            "Person in charge": "担当者",
            "Request date": "リクエスト日",
            "Request I made": "私がしたリクエスト",
            "Request received": "受け取ったリクエスト",
            "Inquiry history": "お問い合わせ履歴",
            "In Review": "レビュー中",
            "Respond": "処理完了",
            "Attachment": "添付ファイル",
            "Request download": "ダウンロードリクエスト",
            "Setting download permissions": "ダウンロード権限の設定",
            "Unlimited": "無制限",
            "Unstarred": "スターなし",
            "Selected Categories": "選択されたカテゴリ",
            "Select requester": "要求者の選択",
            "Select person in charge": "担当者の選択",
            "Common": "一般",
            "Download permission": "ダウンロード許可",
            "Not assigned": "割り当てられていません",
            "Attached file": "添付ファイル",
            "Shared users": "共有ユーザー",
            "Shared management": "共有管理",
            "Share expiration date": "共有の有効期限",
            "Number of downloads remaining": "ダウンロード残り回数",
            "Share date": "共有日",
            "Asset Create": "資産の作成",
            "Asset Archive": "資産アーカイブ",
            "COMMENT_ATTACHMENT_DOWNLOAD": "コメント添付ファイルのダウンロード",
            "Metadata Download": "メタデータのダウンロード",
            "Comment Attachment Download": "コメント添付ファイルのダウンロード",
            "Asset Download": "資産のダウンロード",
            "Storage Download": "ストレージのダウンロード",
            "Collection Download": "コレクションのダウンロード",
            "My Jobs": "私の仕事",
            "Requests": "リクエスト",
            "Upload from My PC": "自分のPCからアップロード",
            "Upload from cloud": "クラウドからアップロード",
            "To Start Page": "開始ページへ移動",
            "Go to previous page": "前のページに戻る",
            "Go to first page": "最初のページに移動",
            "Go to next page": "次のページに進む",
            "Go to last page": "最後のページに移動",
            "Go to page {{page}}": "{{page}}ページに移動",
            "Go to start-ellipsis page": "前のページ群に移動",
            "Go to end-ellipsis page": "次のページ群に移動",
            "Open": "開く",
            "Asset Bulk Create": "資産の一括作成",
            "Asset Jobs": "資産の仕事",
            "Asset Duplicate": "資産のコピー",
            "REQUEST_ATTACHMENT_DOWNLOAD": "リクエスト添付ファイルのダウンロード",
            "Request Attachment Download": "リクエスト添付ファイルのダウンロード",
            "Partial": "一部",
            "Request attachment download": "リクエスト添付ファイルのダウンロード",
            "Reverse sort direction": "リバースソート",
            "Selected Attachment": "添付ファイル",
            "No Channel Categories": "チャンネルカテゴリなし",
            "Search Engine": "検索エンジン",
            "Create caption asset": "キャプション資産生成",
            "Create video asset": "ビデオ資産生成",
            "Create audio asset": "オデオ資産生成",
            "Create image asset": "イメージ資産生成",
            "Create file asset": "ファイル資産生成",
            "Caption asset": "キャプション資産",
            "Video asset": "ビデオ資産",
            "Audio asset": "オデオ資産",
            "Image asset": "イメージ資産",
            "File asset": "ファイル資産",
            "Caption kind": "キャプション種類",
            "Caption language": "キャプション言語",
            "Task": "作業",
            "TRIGGER": "トリガー",
            "CHOICE": "選択",
            "TASK": "作業",
            "Input Path": "入力パス",
            "Options": "オップション",
            "Enter key": "キーを入力してください",
            "Enter value": "値を入力してください",
            "Auto Language ({{n}}/max. {{max}})": "自動言語 ({{n}}/max. {{max}})",
            "Add Task": "作業追加",
            "Keep original folder structure": "元のフォルダパスを維持",
            "AI Analysis Settings": "AI分析設定",
            "Transcribe": "トランスクライブ",
            "STT": "STT",
            "Video annotation": "動画アノテーション",
            "OCR": "OCR",
            "Vocabulary book": "単語帳",
            "Speaker classification": "話者の分類",
            "Asset creation options": "アセット作成オプション",
            "Create per file": "ファイルごとに作成",
            "Create as a batch": "まとめて作成",
            "Create collection": "コレクションの作成",
            "Invited user": "招待されたユーザー",
            "Space admin permission": "スペース管理者権限",
            "Grant space admin": "管理者権限",
            "Please search by name": "名前で検索してください。",
            "Grant site access": "サイトへのアクセス",
            "Admin permission": "管理者権限",
            "Select admin": "権限を選択してください。",
            "Grant project admin": "プロジェクト管理者権限",
            "Bucket Settings": "バケット設定",
            "Essential": "不可欠",
            "AWS Account Connection": "AWS アカウント連携",
            "Create Project": "プロジェクト作成",
            "Use Service Account": "サービスアカウントを使用",
            "Connect External Account": "外部アカウント連携",
            "Region Settings": "リージョン設定",
            "AWS Account Connection Guide": "AWSアカウント連携ガイド",
            "Create IAM Permission": "IAM権限の作成",
            "Copy code": "コードをコピー",
            "Create IAM Role": "IAMロールの作成",
            "View Connection Guide": "接続ガイド ",
            "Group Access Management": "グループアクセス管理",
            "User Access Management": "ユーザーアクセス管理",
            "Change Owner": "所有者の変更",
            "Change": "変化",
            "Not locked": "安らぎ",
            "Locked state": "ロック状態",
            "Region": "地域",
            "AWS account connection": "AWSアカウント連携",
            "Retrieving analysis results...": "分析結果を取得中...",
            "AI Auto Tagging": "AI自動タグ付け",
            "Use": "使用する",
            "Don't Use": "使用しない",
            "Min. Confidence": "最低信頼度",
            "API Key": "APIキー",
            "Unique accessed users": "ユニーク訪問者数",
            "Transcoding jobs": "トランスコーディング作業",
            "Total assets": "総資産数",
            "Metadata registration rate": "メタデータ登録率",
            "AI jobs": "AI作業数",
            "A month ago": "前月比",
            "Usage Trend": "月間利用量のトレンド",
            "Asset count and storage usage by {{target}}": "{{target}}別の資産数およびストレージ使用量",
            "AI jobs by service type": "AI作業タイプ別分布",
            "AI jobs by engine": "エンジン別分布",
            "Assets by media type": "資産タイプ別分布",
            "Daily asset creation count": "日次の資産生成数",
            "All customers": "すべての顧客",
            "Segment detection": "セグメント検出",
            "Text detection": "テキスト検出",
            "Translate": "翻訳",
            "File size": "ストレージ",
            "{{target}} detail data": "{{target}}の詳細データ",
            "Customer name": "顧客名",
            "customer": "顧客",
            "project": "プロゼクト",
            "Grant role": "役割の割り当て",
            "Loading Data...": "データをロード中…",
            "MimeType": "MIME タイプ",
            "Inviter": "招待者",
            "Mark as read": "既読にする",
            "Mark as unread": "未読にする",
            "Mark all as read": "全て既読にする",
            "Notifications": "通知",
            "Show only unread items": "未読項目だけを表示する",
            "Subtitle generation basic settings": "字幕生成の基本設定",
            "Auto-delete input bucket": "入力バケットの自動削除",
            "Try again": "もう一度やり直してください",
            "Ask a new question": "新しい質問をする",
            "New Task": "新しいタスク",
            "Tasks": "タスク",
            "Go Back": "戻る",
            "Create Shortform": "ショートフォームの作成",
            "AI WorkSpace Preset": "AI WorkSpace プリセット",
            "Active presets": "アクティブなプリセット",
            "Creation location": "作成場所",
            "Create Prompt Presets": "プロンプトプリセットを作成",
            "Prompt": "プロンプト",
            "Response format": "応答形式",
            "Timeline for editing": "編集用のタイムライン",
            "AI Workspace": "AI Workspace",
            "Unsupported video file format": "サポートされていないビデオファイル形式",
            "Name ascending order": "名前昇順",
            "Name descending order": "名前降順",
            "Expiration date": "満了日",
            "Save Tags": "タグを保存",
            "Deleted after {{day}} day(s)": "{{day}}日後削除",
            "Single type": "シングルタイプ",
            "Chat type": "インタラクティブ",
            "Save description immediately": "説明をすぐに保存",
            "Save Description": "説明を保存する",
            "Start ingest": "インジェストの開始",
            "End ingest": "インジェストを終了する",
            "Start transcoding": "トランスコーディングの開始",
            "End transcoding": "トランスコーディングを終了する",
            "Copy description": "コピーする",
            "Whether transcoded assets are exposed": "トランスコードされた資産が公開されるかどうか",
            "Create original quality video only": "オリジナル品質のビデオのみを作成する",
            "Automatically activated": "自動的に有効化される",
            "Publish to YouTube": "YouTubeに公開",
            "Create and manage video URL": "動画URLの作成と管理",
            "Published channels": "公開されたチャンネル",
            "Delete URL": "URLを削除",
            "Create URL": "URLを作成",
            "You can create a URL for video sharing.": "動画の共有用のURLを作成できます。",
            "Creating video URL": "動画のURLを作成中",
            "MODAL_Publishing": "公開",
            "Archived ID": "アーカイブされたID",
            "Selected": "選択済み",
            "audit logs": "監査ログ",
            "Select description": "アクションの選択",
            "List View Settings": "リストビューの設定",
            "User Preference Widget": "ユーザー設定ウィジェット",
            "User Group Preference Widget": "チーム設定ウィジェット",
            "Project Preference Widget": "プロジェクト設定ウィジェット",
            "Entire Period": "全期間",
            "This Week": "今週",
            "This Month": "今月",
            "This Year": "今年",
            "Last 15 Minutes": "過去15分",
            "Last 30 Minutes": "過去30分",
            "Last 1 Hour": "過去1時間",
            "Last 4 Hours": "過去4時間",
            "Apply with Project Settings": "プロジェクト設定で適用",
            "Line Chart": "折れ線グラフ",
            "Bar Chart": "棒グラフ",
            "Notice": "注意事項",
            "Cancel Update": "更新キャンセル",
            "Widget Type": "ウィジェット形式",
            "Wide Type": "ワイド型",
            "Default Dashboard Exposure": "ダッシュボードに基本表示",
            "Widget Exposure Settings": "ウィジェット表示設定",
            "Not Entered": "未入力状態",
            "Show Search Options": "検索オプション表示",
            "Project Settings > Settings > Menu (e.g. Asset) > Category Group": "プロジェクト設定 > 設定 > メニュー（例：アセット） > カテゴリーグループ",
            "Category Group": "カテゴリーグループ",
            "Asset name 1": "資産名 1",
            "Empty notifications": "空の通知",
            "Unread only": "未読のみ",
            "Read only": "既読のみ",
            "Mixed read/unread": "既読/未読混在",
            "All comment types mixed": "すべてのコメントタイプ混在",
            "All domains mixed": "すべてのドメイン混在",
            "All asset media types mixed": "すべてのアセットメディアタイプ混在",
            "Turn off test mode": "テストモードをオフ",
            "Turn on test mode": "テストモードをオン",
            "Select a preset": "プリセットをお選びください",
            "Recommended": "おすすめ",
            "More": "もっと見る",
            "Hide Presets": "プリセットを非表示",
            "See More Presets": "プリセットをもっと見る",
            "Duplicate {{name}}": "{{name}} 複製",
            "Schedule ID": "スケジュールID",
            "Enter Owner": "所有者入力",
            "Search all Assets": "すべてのアセットを検索",
            "Add teaser images": "ティーザーイメージ追加",
            "Add Content Schema": "コンテンツスキーマを追加",
            "Add {{schemaName}}": "{{schemaName}} 追加",
            "Enter Sounds Like": "発音に似た言語を入力してください",
            "There are no analysis results for {{name}}.": "{{name}}の分析結果はありません。",
            "Recent Assets Shared to Me": "私に共有された最近の資産",
            "Change menu name": "メニュー名の変更",
            "Delete group": "グループの削除",
            "Users and groups belonging to the project for the selected asset are excluded from sharing.": "選択した資産のプロジェクトに属するユーザーとグループは、共有から除外されます。",
            "Recording": "レコーディング",
            "All Buckets": "全てのバケット",
            "Dimensions": "解像度",
            "Asset Details": "資産の詳細",
            "View all Projects": "全てのプロジェクトを表示",
            "ARCHIVING": "アーカイブ中",
            "ARCHIVED": "アーカイブ済み",
            "RESTORING": "復元中",
            " {{name}}": " {{name}}",
            " '{{name}}' and <emp>{{count}}</emp> others": " '{{name}}' 他<emp>{{count}}</emp>件",
            "Please enter your message.": "メッセージを入力してください。",
            "Related Assets": "関連資産",
            "Linked Assets": "リンクされた資産",
            "Remove Asset": "資産を削除",
            "Add Linked Assets?": "リンクされた資産を追加しますか？",
            "Menu Display": "メニュー表示",
            "Please search by folder name": "フォルダ名で検索してください。",
            "and <emp>{{count}}</emp> others": "他<emp>{{count}}</emp>件",
            "An error occurred while preparing the asset for {{type}}.": "{{type}}のための資産を準備中にエラーが発生しました。",
            "Transcode in progress": "トランスコード進行中",
            "Transcode has been cancelled.": "トランスコードがキャンセルされました。",
            "Transcode completed.": "トランスコードが完了しました。",
            "An error occurred while transcoding.": "トランスコード中にエラーが発生しました。",
            "Source Jobs": "ストレージジョブ",
            "REMOVE": "削除",
            "Name setting": "名前設定",
            "Automatic storage date after asset creation": "資産作成後の自動保存日",
            "role_Copy": "コピー",
            "Create Event Triggers": "イベントトリガーの作成",
            "Summary": "概要",
            "Usage Dashboard": "使用量ダッシュボード",
            "Selected {{referenceType}}s": "選択した{{referenceType}}",
            "Source Upload": "ストレージのアップロード",
            "This operation was not entirely successful.": "この操作は完全には成功しませんでした。",
            "View": "表示",
            "Unable to use AI-Workspace": "AI-Workspaceをご利用いただけません",
            "Read Only": "読み取り専用",
            "Switch": "切り替え",
            "Switching": "切り替え中",
            "S3_OBJECT_CREATED": "ファイルがアップロードされたら",
            "ASSET_CREATED": "アセットが作成されたら",
            "FILTER_BY_FILE_EXTENSION": "ファイル拡張子でフィルター",
            "FILTER_BY_FILE_SIZE": "ファイルサイズでフィルター",
            "FILTER_BY_ASSET_MEDIA_TYPE": "アセットをメディアタイプでフィルター",
            "FILTER_BY_ASSET_SIZE": "アセットをサイズでフィルター",
            "ATTACH_ASSET_METADATA": "メタデータを連携",
            "CREATE_ASSET": "アセットを作成",
            "CREATE_VIDEO": "ビデオを作成",
            "SUBMIT_AI_WORKSPACE_SINGLE_TYPE_JOB": "AIワークスペースジョブを送信",
            "ARCHIVE_ASSET": "アセットをアーカイブ",
            "PUBLISH_VIDEO": "ビデオを公開",
            "File URL": "ファイルURL",
            "File Extension": "ファイル拡張子",
            "File Size": "ファイルサイズ",
            "Asset Media Type": "アセットメディアタイプ",
            "Asset Size": "アセットサイズ",
            "Condition": "条件",
            "Flow Edit": "フロー編集",
            "Flow Details": "フロー詳細",
            "Auto": "自動",
            "Manual": "手動",
            "Select a step": "ステップを選択",
            "clippings": "クリッピング",
            "accountId": "アカウントID",
            "AiWorkspaceJob SingleTypeJob Output": "AIワークスペースジョブ出力",
            "AI Mode": "AIモード",
            "AI Mode OFF": "AIモード OFF",
            "Ask anything": "何でも聞いてください",
            "Hi, this is AI search mode": "こんにちは、AI検索モードです",
            "Describe a scene or feature in the video you are looking for!": "探している動画のシーンや特徴を説明してください！",
            "AI Search Preset Recently modified videos": "最近修正した動画",
            "AI Search Preset Golden sunset on the beach": "ビーチの黄金色の夕日",
            "AI Search Preset People in a meeting at the office": "オフィスで会議する人々",
            "AI Search Preset Cinematic mood videos": "シネマティックな雰囲気の動画",
            "AI Search Preset City night view by drone": "ドローンで撮影した都市の夜景",
            "AI Search Preset Children smiling brightly": "明るく笑う子供たち",
            "View indexing status": "インデックス状態を見る",
            "AI Analysis Plan and Usage": "AI分析プランと使用量",
            "Ai-billing": "AI分析プランと使用量",
            "Current subscription": "現在のサブスクリプション",
            "No active subscription": "有効なサブスクリプションがありません",
            "Concurrent sessions": "同時セッション",
            "Fees and usage": "料金と使用量",
            "Fees": "料金",
            "Usage": "使用量",
            "Aggregating": "集計中",
            "Settled": "精算完了",
            "Total so far": "現在までの合計",
            "Settled total": "精算合計",
            "Period subtotal": "区間小計",
            "Cumulative usage": "累計使用量",
            "Year option {{year}}": "{{year}}年",
            "Month option {{month}}": "{{month}}月",
            "Pay-as-you-go": "従量課金",
            "No change": "変動なし",
            "vs. last month": "前月比",
            "min": "分",
            "AI applied": "AI適用",
            "Apply all": "全体適用",
            "Cancel setting": "設定を取り消す",
            "Custom metadata": "カスタムメタデータ",
            "Differs from preset schema": "プリセットスキーマと異なる",
            "Not extracted": "未抽出",
            "Replace": "置き換え",
            "Replace with preset schema": "プリセットスキーマに置き換え",
            "Revert to existing schema": "既存スキーマに戻す",
            "Same as preset schema": "プリセットスキーマと同じ",
            "Save custom metadata directly": "カスタムメタデータを直接保存",
            "Set preset schema": "プリセットスキーマに設定",
            "Save metadata": "メタデータを保存",
            "Add publish": "公開追加",
            "Back to manage": "管理へ",
            "Copy public URL": "公開URLをコピー",
            "Last published": "最終公開",
            "Manage public URL": "公開URL管理",
            "Open public URL": "公開URLを開く",
            "Open URL": "URLを開く",
            "Publish ({{count}})": "公開 ({{count}})",
            "Publish and manage public URL": "公開URLの公開および管理",
            "Publish public URL": "公開URLの公開",
            "Publish target": "公開対象",
            "Unpublish": "公開解除",
            "Unpublish ({{count}})": "公開解除 ({{count}})",
            "{{count}} files": "{{count}}件のファイル",
            "English (en-US)": "英語 (en-US)",
            "Korean (ko-KR)": "韓国語 (ko-KR)",
            "Related Videos": "関連動画",
            "Minimap": "ミニマップ",
            "Go back": "戻る",
            "Use service account": "サービスアカウントを使用",
            "and <emp>{{count}}</emp> others' shared": "他<emp>{{count}}</emp>件を共有",
            "(<emp>{{count}}</emp> days left)": "(残り<emp>{{count}}</emp>日)",
            "Info": "情報",
            "Filter": "フィルター",
            "Create Highlights": "ハイライトを作成",
            "Create Description": "説明を作成",
            "Remove all Shares": "すべての共有を解除",
            "Create date": "作成日",
            "Complete date": "完了日",
            "Start Failure": "開始失敗",
            "Recording Started": "録画が開始されました",
            "Upload Cancel": "アップロードのキャンセル",
            "Select Content in a specific folder?": "特定のフォルダのコンテンツを選択しますか？",
            "Template preview": "テンプレートプレビュー",
            "Terms and Conditions": "利用規約",
            "toggle password visibility": "パスワード表示の切り替え",
            "{{type}} Asset Name": "{{type}} アセット名",
            "Enter {{type}} Asset Name": "{{type}} アセット名を入力",
            "' shared": "' 共有",
            "{{names}} and {{restCount}} more": "{{names}} ほか{{restCount}}件",
            "Proxy video": "プロキシ映像",
            "Proxy video status": "プロキシ抽出状態",
            "Auto generate proxy video": "プロキシ映像を自動生成",
            "Proxy video ready": "プロキシ準備完了",
            "Extracting proxy video": "プロキシ抽出中",
            "Best match": "最も一致する結果",
            "AI Search": "AI検索",
            "Proxy extraction failed": "プロキシ抽出失敗",
            "{{count}} errors": "エラー {{count}}",
            "View by country and referrer": "国・参照元を表示",
            "Countries (this URL)": "国 (この URL 基準)",
            "Referring domains (this URL)": "参照元ドメイン (この URL 基準)",
            "persons": "人",
            "and {{count}} more": "他 {{count}}件",
            "All URLs": "すべての URL",
            "All unpublished": "すべて解除",
            "View all URLs": "すべての URL を表示",
            "Search URL": "URL を検索",
            "Share of total": "割合",
            "Country": "国",
            "CF address": "CF アドレス"
        },
        "msg": {
            "How many times the asset was opened through its public URL. Downloads and on-screen views are counted together, and for video, starting playback counts as one - watching to the end is not measured. If there is no access for 30 minutes after the first view, the next view is counted separately.": "公開 URL からアセットが開かれた回数です。ダウンロードと画面での視聴をまとめて数え、動画は再生を開始した時点で 1 回として、最後まで見たかどうかは数えません。最初の閲覧から 30 分間アクセスがなく、その後再び閲覧された場合は 2 回として数えます。",
            "Total data sent out through this asset's public URLs. Opening the same file again adds to it.": "この資産が公開 URL で送出したデータの総量です。同じファイルをもう一度開くとその分増えます。",
            "An estimate, not a headcount. Several people in one company may count as one, and one person switching devices may count as several.": "人数ではなく推定値です。同じ会社の複数人が見ると1人として、1人が端末を変えると複数として数えます。",
            "The site the visitor came from right before opening this URL. Whether the asset was actually embedded in that page or reached by a link is not distinguished. Entries with no value are grouped as Unknown.": "この URL を開く直前にいたサイトです。そのページに実際に埋め込まれていたのか、リンクをたどって来たのかは区別できません。値がないものは「不明」にまとめます。",
            "Could not load statistics": "統計を読み込めませんでした。",
            "Could not update. Showing the previous result.": "更新できませんでした。以前の結果を表示しています。",
            "Data is aggregated hourly, not in real time.": "リアルタイムではなく、1 時間ごとにデータが集計されます。",
            "Aggregated hourly, so the most recent views may not be here yet. Do not decide whether a URL is still in use from this column alone.": "1 時間ごとに集計されるため、直近の閲覧はまだ反映されていない場合があります。この列だけで URL の利用有無を判断しないでください。",
            "The country the viewer was in.": "視聴者が所在していた国です。",
            "CDN logs are not real-time, so today and yesterday are still filling in. Downloads and on-screen views are counted together, and referring domains do not distinguish embedded pages from link clicks.": "CDN ログはリアルタイムではないため、本日・昨日の数値はまだ集計中です。ダウンロードと画面での閲覧は合わせて数え、参照元ドメインはページへの埋め込みかリンククリックかを区別しません。",
            "Please try again in a moment.": "しばらくしてからもう一度お試しください。",
            "No views recorded yet": "集計された閲覧はまだありません。",
            "Views appear here once someone opens the asset through its public URL.": "誰かが公開 URL から資産を開くとここに表示されます。",
            "Add request headers such as an authorization token if needed.": "認証トークンなど、リクエストに含めるヘッダーが必要な場合は追加してください。",
            "Only letters, numbers, and hyphens are allowed.": "英数字とハイフンのみ使用できます。",
            "This header cannot be used.": "使用できないヘッダーです。",
            "Line breaks are not allowed.": "改行は使用できません。",
            "Headers can be up to {{maxLength}} characters in total. (currently {{length}})": "ヘッダーは全体で{{maxLength}}文字まで入力できます。(現在{{length}}文字)",
            "The URL is too long.": "URLが長すぎます。",
            "Internal addresses (private, loopback, or link-local) cannot be used.": "内部アドレス(プライベート・ループバック・リンクローカル)は使用できません。",
            "\"{{name}}\" will be deleted forever and you won't be able to restore it.": "「{{name}}」は完全に削除され、復元できません。",
            "The webhook has been activated.": "Webhookが有効化されました。",
            "The webhook has been deactivated. Events will no longer be sent.": "Webhookが無効化されました。トリガーが発生しても送信されません。",
            "A webhook sends asset event data to an external endpoint whenever a selected trigger occurs.": "ウェブフックは、選択したトリガーが発生するたびに外部エンドポイントへアセットのイベントデータを送信します。",
            "Deliveries appear here once a selected trigger occurs.": "選択したトリガーが発生すると、送信履歴がここに表示されます。",
            "Are you sure you want to delete this webhook?": "このウェブフックを削除してもよろしいですか?",
            "HTTP method is fixed to POST and cannot be changed.": "HTTPメソッドはPOSTに固定されており、変更できません。",
            "https://example.com/webhooks": "https://example.com/webhooks",
            "Key is required.": "キーは必須です。",
            "Key must be unique.": "キーは一意である必要があります。",
            "Please enter a valid URL.": "有効なURLを入力してください。",
            "Please select at least one trigger.": "トリガーを1つ以上選択してください。",
            "Select a trigger to preview the request body.": "リクエストボディをプレビューするにはトリガーを選択してください。",
            "The request body is determined automatically by the system based on the trigger and cannot be edited.": "リクエストボディはトリガーに基づいてシステムが自動的に決定するため、編集できません。",
            "We recommend using https.": "httpsの使用を推奨します。",
            "'{{item}}' has been added.": "「{{item}}」が追加されました。",
            "'{{name}}' AI analysis has begun.": "「{{name}}」のAI分析が開始されました。",
            "'{{name}}' has been added.": "「{{name}}」が追加されました。",
            "AI Caption task failed.": "AIキャプション作業に失敗しました。",
            "Access has Expired": "アクセスの有効期限が切れました",
            "An error has occurred": "エラーが発生しました",
            "An error occured while changing Custom Metadata {type}": "カスタムメタデータ {type} の変更中にエラーが発生しました",
            "An error occured while changing collection name": "コレクション名の変更中にエラーが発生しました",
            "An error occured while changing collection {{type}}": "コレクション {{type}} の変更中にエラーが発生しました",
            "An error occured while changing custom content {{type}}": "カスタムコンテンツ {{type}} の変更中にエラーが発生しました",
            "An organizer can be selected.": "主催者を選択できます。",
            "Assets must only be in DRM-free MP4 video type.": "資産はDRMフリーのMP4ビデオ形式のみ可能です。",
            "Collection '{{name}}' has been created.": "コレクション「{{name}}」が作成されました。",
            "Content schema '{{name}}' has been duplicated.": "コンテンツスキーマ「{{name}}」が複製されました。",
            "Creating video URL.": "動画のURLを作成中です。",
            "Creation of new Metadata Export {{item}} is completed.": "新しいメタデータエクスポート {{item}} の作成が完了しました。",
            "Detach {{name}}": "{{name}} 解除",
            "Download request failed": "ダウンロードのリクエストに失敗しました",
            "Enter your name": "名前を入力してください。",
            "Error adding collection '{{name}}'. {{line}} Please refresh the page and try again.": "コレクション「{{name}}」の追加中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Expired date :": "有効期限 :",
            "Face collection is not registered. Please contact to admin.": "顔コレクションが登録されていません。管理者にお問い合わせください。",
            "Failed to configure AI analysis trigger.": "AI分析トリガーの設定に失敗しました。",
            "Failed to move.": "移動に失敗しました。",
            "File is empty.": "ファイルが空です。",
            "Group '{{name}}' has been added.": "グループ「{{name}}」が追加されました。",
            "I agree to the above terms and conditions": "上記の利用規約に同意します",
            "If you apply a different category group, those items can be found under ‘<NotClassified>Categories Not Classified into Assets</NotClassified>’ in the category view.": "別のカテゴリーグループを適用する場合、該当のアイテムはカテゴリービューの‘<NotClassified>アセットに分類されていないカテゴリー</NotClassified>’で確認できます。",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won't be able to revert this.<1/>Are you sure you want to delete?": "<0>{{name}}</0>を削除すると、参照からも削除され、元に戻すことはできません。<1/>本当に削除しますか？",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.<1/>Are you sure you want to delete?": "<0>{{name}}</0>を削除すると、元に戻すことはできません。<1/>本当に削除しますか？",
            "If you have issues with Space approval, please contact Megazone Cloud. ": "スペース承認に問題がある場合は、Megazone Cloudにお問い合わせください。 ",
            "Korean can not contain numbers.": "韓国語に数字を含めることはできません。",
            "Please enter title": "タイトルを入力してください",
            "Please search by collection name": "コレクション名で検索してください",
            "Please uncheck the items you wish to leave and try to delete them.": "残したいアイテムのチェックを外してから削除してください。",
            "Saving of changes to '{{tab}}' failed. - {{error}}": "「{{tab}}」の変更の保存に失敗しました。 - {{error}}",
            "Shortform creation has been requested.": "ショートフォームの作成がリクエストされました。",
            "Since this is a category group that is not used in {{name}}s, you can check the created {{name}} in 'categories not classified in {{name}}s'.": "{{name}}で使用されていないカテゴリグループであるため、作成された{{name}}は「{{name}}に分類されていないカテゴリ」で確認できます。",
            "The Key field be up to {{tag}} characters long.": "キーのフィールドは最大 {{tag}}字です。",
            "The Lineup Name field be up to {{name}} characters long.": "ラインナップ名のフィールドは最大 {{name}}字です。",
            "The Value field be up to {{tag}} characters long.": "値のフィールドは最大 {{tag}}字です。",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0> ": "プログラムのキャプションは <0> {{number}} </0> キャプションで編集できます。 ",
            "The language of the captions to be applied to the video must not be duplicated.": "動画に適用するキャプションの言語は重複できません。",
            "There is already a {{target}} with the same email. Please change it to a different email.": "同じメールアドレスの{{target}}が既に存在します。別のメールアドレスに変更してください。",
            "There is no Organizers to select.": "選択できる主催者がありません。",
            "There is no file to retry.": "再試行するファイルがありません。",
            "There was an error sharing asset {{item}}": "資産{{item}}の共有中にエラーが発生しました",
            "This field can be at least {{minByte}} bytes.": "このフィールドは最低 {{minByte}} バイトです。",
            "This field can be at least {{minLength}} characters.": "このフィールドは最低 {{minLength}} 文字です。",
            "This field must be in email address format.": "このフィールドはメールアドレス形式である必要があります。",
            "This listings has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "このリストには更新された情報があります。<0/>更新してから再度お試しください。今すぐ更新しますか？",
            "Try another search to find an vocabulary.": "単語を見つけるには、もう一度検索してください。",
            "User invitation has been completed.": "ユーザーの招待が完了しました。",
            "Video '{{name}}' has been requested.": "「{{name}}」ビデオがリクエストされました。",
            "Videos must only be in DRM-free MP4 video type among the sources.": "ソースの中で、ビデオはDRMフリーのMP4ビデオ形式のみ可能です。",
            "Words to display - Enter Korean, English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) You can.": "表示する単語 - 韓国語、英語、数字、スペース、特殊文字(~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?)を入力できます。",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) there is.": "表示する単語 - 英語、数字、スペース、特殊文字(~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?)を入力できます。",
            "You can create a URL for video sharing.": "動画の共有用のURLを作成できます。",
            "You can enter up to 30 whitelist rules.": "ホワイトリストの規則は30個まで入力できます。",
            "You can see all your current assets. You can find the asset you are looking for using the search option.": "現在のすべての資産を確認できます。検索オプションを使用して、お探しの資産を見つけることができます。",
            "You cannot upload files to this list.": "このリストにはファイルをアップロードできません。",
            "You must leave at least one entry in your vocabulary book.": "単語帳には少なくとも1つの項目を残す必要があります。",
            "You will receive an email letting you know that <0/>  the asset has been shared with you.": "資産があなたと共有されたことを <0/>  メールでお知らせします。",
            "Your folder name is too long including parent folders, you can shorten the folder name and try again.": "親フォルダを含むフォルダ名が長すぎます。フォルダ名を短くして再度お試しください。",
            "{{resourceName}} '{{name}}' has been updated.": "{{resourceName}}「{{name}}」が更新されました。",
            "{{schemaName}} '{{name}}' has been created.": "{{schemaName}}「{{name}}」が作成されました。",
            "No labels": "ラベルなし",
            "This user does not exist.": "存在しないユーザーです。",
            "No Sharer.": "共有者がいません。",
            "No Users.": "ユーザーがいません。",
            "No Groups.": "グループがありません。",
            "Please manage your assets by adding the new folder.": "新しいフォルダーを追加して資産を管理してください。",
            "The video list is missing.": "ビデオリストがありません。",
            "Delete completely from Music": "ミュージックから完全に削除する",
            "You have selected <0>{{count}}</0> other than <1>{{name}}</1>": "<1>{{name}}</1>以外に<0>{{count}}</0>個を選択しました",
            "Remove from category <0>{{name}}</0> only": "<0>{{name}}</0> カテゴリからのみ削除",
            "You won’t be able to revert this.": "元に戻せません。",
            "If you delete <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>を削除すると<0>参照</0>からも削除され、元に戻せません。<1/>本当に<0>{{name}}</0>を削除しますか？",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>以外に<0>{{count}}</0>個を削除すると<0>参照</0>からも削除され、元に戻せません。<1/>本当に<0>{{name}}</0>を削除しますか？",
            "{{verb}} <0>{{count}}</0> files from <1>{{path}}</1> to <2>{{to}}</2>": "<1>{{path}}</1>から<2>{{to}}</2>へ<0>{{count}}</0>個のファイルを{{verb}}",
            "An item with the name <0>{{name}}</0> is already in this location.<1/>Do you want to overwrite it with the target file?": "<0>{{name}}</0>という名前の項目がすでにこの場所にあります。<1/>対象ファイルで上書きしますか？",
            "Delete completely from Photo": "写真から完全に削除する",
            "Upload Failed.": "アップロードに失敗しました。",
            "Upload failed.": "アップロードに失敗しました。",
            "<0>{{date}} (24 hours) </0> schedule is complete, or there is not enough<br />blank time than video duration.<br />If you want to add a schedule, please manual schedule it.": "<0>{{date}} (24時間) </0> スケジュールがすべて完了しているか、動画の長さに対して空き時間が不足しています。<br />スケジュールを追加するには、手動で編成してください。",
            "{{count}} fields auto-filled": "フィールド{{count}}個を自動入力",
            "The current workflow can be saved as a draft, but some connection structures are invalid, which may cause issues when running.": "現在のワークフローは下書きとして保存できますが、一部の接続構造が正しくないため、実行時に問題が発生する可能性があります。",
            "The current workflow has items that need to be resolved and cannot be saved. Please fix the items below and save again.": "現在のワークフローには解決が必要な項目があるため保存できません。\n以下の項目を修正してから再度保存してください。",
            "Add at least one task.": "タスクを1つ以上追加します。",
            "Please select a step.": "ステップを選択してください。",
            "Please select {{type}}.": "{{type}}を選択してください。",
            "Input conditions are not satisfied by upstream steps.": "上位ステップの出力では入力条件が満たされていません。",
            "Select a step node.": "ステップノードを選択してください。",
            "No available step": "利用可能なステップがありません。",
            "Up to 5 parallel steps.": "並列ステップは最大5つまで追加できます。",
            "Drag anywhere to move the canvas.": "キャンバスを移動するには、任意の場所をドラッグしてください。",
            "The step tree for workflow \"{{name}}\" has been updated.": "ワークフロー「{{name}}」のステップツリーが更新されました。",
            "You can save the current workflow, but saving your changes will cancel <0>{{queuedCount}} queued executions</0>.": "現在のワークフローは保存できますが、変更すると実行を待っている<0>待機中の{{queuedCount}}件の作業</0>がすべてキャンセルされます。",
            "This may take some time to apply, depending on the amount of data.": "データ量によっては、適用までに時間がかかる場合があります。",
            "User list export has been requested.": "ユーザーリストのエクスポートをリクエストしました。",
            "Failed to export the user list.": "ユーザーリストのエクスポートに失敗しました。",
            "This setting may take some time to take effect after being changed, and the status cannot be changed again while it is being applied.": "この設定は変更後、実際に適用されるまで時間がかかることがあり、適用中は状態を再度変更できません。",
            "This setting is currently being applied. You can change it again after it takes effect.": "現在、設定を適用中です。適用が完了した後に、再度変更できます。",
            "You have no permission to view this page.": "このページを表示する権限がありません。",
            "Attribution cannot be empty.<0/>Please enter a valid attribution.": "＼\"アトリビューション＼\"は空の値ではありません<0/>有効なアトリビューションを入力してください。",
            "\"Tags\" can be up to 30.": "30個まで\"タグ\"を入力できます。",
            "\"Tags\" can be up to {{count}}.": "{{count}}個まで\"タグ\"を入力できます。",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍ改行により分割される",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\n ㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR : xxx.xxx.xxx.xxx/yy\n ㆍSeparate by newlines": "ㆍ 単一IP : xxx.xxx.xxx.xxx \n  ㆍ IP 範囲 : xxx.xxx.xxx.xxx ~ zzz.zzz.zzz.zzz \n  ㆍ CIDR : xxx.xxx.xxx.xxx/yy\n  ㆍ 改行により分割される",
            "Add file by drag and drop or double-clicking in the select sources.": "選択したソースをドラッグアンドドロップまたはダブルクリックしてファイルを追加します。",
            "A maximum of 2 streams can be selected.": "最大2個まで選択できます。",
            "A one schedules can be selected.": "1つのリスティングを選択できます。",
            "Access denied.": "アクセスが拒否されました。",
            "An error occured while trying to analyze the asset": "資産分析中、エラーが発生",
            "Analyzed automatically labels objects, concepts and scenes in video.": "ビデオからオブジェクト、コンセプト、場面を自動に分析し、ラベリングします。",
            "And {{count}} Other - Total {{total}}": "他 {{count}} - 合計 {{total}}",
            "Approve the channel after creation": "生成後チャンネル承認",
            "Are you sure ? You won't be able to revert this!": "よろしいですか?戻すことはできません。",
            "Are you sure you delete the selected lineups?": "選択されたラインナップを除去しますか？",
            "Are you sure you want to approve the selected?": "選択した項目を承認しますか？",
            "Are you sure you want to cancel the request the selected?": "選択された申請をキャンセルしますか？",
            "Are you sure you want to cancel the return the selected?": "選択された返還をキャンセルしますか？",
            "Are you sure you want to delete": "削除しますか？",
            "Are you sure you want to delete <0>{{name}} ({{id}})</0>?": "本当に<0>{{name}} ({{id}})</0>を削除しますか？",
            "Are you sure you want to delete <0>{{name}}</0>?": "確実に <0>{{name}}</0>を削除しますか？",
            "Are you sure you want to reclaim the selected?": "選択した項目を改修しますか？",
            "Are you sure you want to reject the request?": "申請を拒否しますか？",
            "Are you sure you want to request the selected?": "選択された項目を申請しますか？",
            "Are you sure you want to return the selected?": "選択された項目を戻しますか？",
            "Automatically detects explicit adult content in video.": "自動でビデオの露骨なアダルトコンテンツを感知します。",
            "Automatically recognizes celebrities in video.": "自動でビデオから有名人を認識します。",
            "Base video file can be set only for english without special characters and spaces.": "基本ビデオのファイル名は特殊文字と空白ではない英字のみ可能です。",
            "Base video file to be used for the channel can be set only for English without special characters and spaces. (Allowed special characters: ~! () _-.)": "基本ビデオファイル名は特殊文字と空白ではない英字のみ可能です。(使用可能な特殊文字: ~! () _-.)",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "バケットの名は必ず3～63字以内でなければならなく、アルファベットや数字で開始され、 -, _, 。の特殊文字のみ使用できます。",
            "Cannot apply because no schema is set": "スキーマが設定されていないため適用できません",
            "Cannot apply because the schema is different": "スキーマが異なるため適用できません",
            "Cannot create a job": "作業を生成できません。",
            "CloudPlex Media subtitle editor works with the platform to provide flexible workflows from subtitle registration to publishing.<0/>Quickly create subtitles with user experience-based UI.": "CloudPlex Media字幕編集機はプラットフォームと共に字幕登録からパブリッシングに至るまで柔軟なワークフローを提供します。<0/>使用環境基盤のUIと共に迅速に字幕を生成してみましょう。",
            "Deleted output assets will be kept for the specified days": "削除されたアウトプット資産は指定された期間の間、保管されます。",
            "Do not have an account yet?": "まだアカウントをお持ちではないですか?",
            "Do you really want to change?": "本当に変更しますか?",
            "Do you really want to delete it?": "本当に削除しますか?",
            "Drag and drop a file here": "ファイルをここにドラッグアンドドロップしてください。",
            "Drag your files to upload": "アップロードするファイルをドラッグしてください。",
            "Duplicate key. The key must be unique.": "重複されたキーがあります。",
            "Duplicate values. This field must be unique.": "重複された値。このフィールドは固有で指定となります。",
            "Every month on the": "毎月",
            "Every month on the {{interval}} days": "毎月 {{interval}} 日",
            "Every weeks on": "毎週",
            "Failed to get file information from the url.": "URLからファイル情報の読み込みができませんでした。",
            "Reindexing has been requested.": "再インデックスをリクエストしました。",
            "AI search indexing failed.": "AI検索インデックスに失敗しました。",
            "AI search indexing is not supported for this asset.": "このアセットはAI検索インデックスに対応していません。",
            "This is an unsupported media type.": "サポートされていないメディアタイプです。",
            "This is an unsupported source format.": "サポートされていないソースフォーマットです。",
            "This image is smaller than the minimum size (128x128 pixels).": "この画像は最小サイズ（128x128ピクセル）未満です。",
            "This image exceeds the maximum file size (5 MiB).": "この画像は最大ファイルサイズ（5 MiB）を超えています。",
            "This video exceeds the maximum file size (6 GB).": "このビデオは最大ファイルサイズ（6 GB）を超えています。",
            "This video exceeds the maximum duration (4 hours).": "このビデオは最大再生時間（4時間）を超えています。",
            "Failed to prepare indexing.": "インデックスの準備に失敗しました。",
            "Failed to extract metadata.": "メタデータの抽出に失敗しました。",
            "Failed to create the source.": "ソースの作成に失敗しました。",
            "Failed to check source support.": "ソースのサポート確認に失敗しました。",
            "Failed to analyze the source.": "ソースの分析に失敗しました。",
            "Failed to analyze metadata.": "メタデータの分析に失敗しました。",
            "Failed to create the search index.": "検索インデックスの作成に失敗しました。",
            "An internal error occurred.": "内部エラーが発生しました。",
            "AI search indexing is in progress.": "AI検索インデックスを処理中です。",
            "This analysis failed.": "この解析に失敗しました。",
            "This analysis is outside the supported range.": "この解析は対応範囲外です。",
            "This analysis was only partially indexed.": "この解析は一部のみインデックスされました。",
            "Only part of the source was analyzed.": "ソースの一部のみ分析されました。",
            "Only some index entries were created.": "インデックス項目の一部のみ作成されました。",
            "Some parts were not indexed, so this asset may not appear in all AI search results.": "一部がインデックスされていないため、AI 検索結果にすべて表示されない場合があります。",
            "Click the button on the badge to retry.": "バッジのボタンをクリックすると再試行できます。",
            "You can find this asset in AI search.": "AI検索でこのアセットを見つけることができます。",
            "Assets that have not finished indexing may not appear in AI search results.": "インデックスが完了していない資産はAI検索結果に表示されない場合があります。",
            "No results for \"{{keyword}}\".": "「{{keyword}}」に対する結果がありません。",
            "Depending on indexing status, some assets may not appear in AI search results.": "インデックスの状態によっては、一部の資産が検索結果に表示されない場合があります。",
            "The index is already up to date.": "インデックスは既に最新の状態です。",
            "Failed to request reindexing.": "再インデックスのリクエストに失敗しました。",
            "Granted roles will be deleted.": "承認された役割が削除されます。",
            "Has scheduled lineups.": "スケジュールされたラインナップがあります。",
            "Hi, {{name}}": "こんにちは、 {{name}}",
            "http(s)://~ or s3://~": "http(s)://~ または s3://~",
            "Hyper Browser is an enterprise cloud storage client.<0/>Accelerate a variety of workloads with a multi-CDN integration environment and powerful features such as multi-part upload/download, purge and pre-patch.": "ハイパーブラウザはエンタープライズクラウドストレージのクライアントです。マルチCDN統合環境とワークロード及びマルチパートのアップロード / ダウンロード、パージ及び事前パッチのような強力で多様な機能を利用できます。 <0/>。",
            "If \\\"program duration\\\" is more than \\\"24 hours\\\", you can not repeat the schedule.": "\"プログラム再生時間\"が24時間を超過すると繰り返し再生ができません。",
            "If it is not the scheduled time, it automatically changes the state of the channel to 'Idle'.": "予約された時間でない場合、チャンネルの状態を自動的に'アイドル'として変更します。",
            "If the value is the same, next event has the highest priority": "値が同一であれば、次のイベントが最も高い優先順位となります。",
            "If you are not a member yet, please sign up and use.": "まだメンバーではない場合、加入後に使用してください。",
            "If you delete <0>{{name}}</0>, it will also be removed from Related the videos.": "<0>{{name}}</0> 削除時、連関されたビデオが除去されます。",
            "If you delete <0>{{deleteLineupTargetName}}</0>, only future events including this one will be deleted.": "<0>{{deleteLineupTargetName}}</0>削除時、将来のイベントが除去されます。",
            "If you delete <0>{{name}}</0>, only future events including this one will be deleted.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>を削除するとここに含まれた予約済みのイベントのみ削除されます。 <1/><0>{{name}}</0>を削除しますか？",
            "If you delete <0>{{name}}</0>, the scheduled lineups will be deleted together.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>を削除しようとすると予約されたラインナップが一緒に削除されます。 <1/><0>{{name}}</0>を削除しますか？",
            "If you delete a lineup that is set to repeat, all future schedule will be deleted.": "繰り返しラインナップの削除時、全ての将来のスケジュールが削除されます。",
            "If you have a problem with your account, or would like to use the cloud <0/>Platform, please contact our sales team. We'll assist you with more details.": "アカウントやクラウドプラットフォーム使用中、問題が発生した場合、<0/>セールスチームへご連絡を願い致します。さらに詳細な状況を調査致します。",
            "If you have any problem using the stage,<0/> please contact Megazone.": "Stageの使用中、問題発生時 <0/>Megazoneへ連絡をお願いします。",
            "If you have any problem using this space,<0/> please contact Megazone Cloud.": "このスペースの使用に問題がある場合は、<0/>Megazone Cloudにお問い合わせください。",
            "If you want to access this page, please contact your administrator.": "このページにアクセスするには管理者へ問い合わせをお願いします。",
            "Indexing faces and get a complete analysis of facial attributes, <0/>including confidence scores.": "顔のインデックス進行時、<0/>信頼度点数を含めた<0/>顔の属性分析を得ることができます。",
            "Ingest path setting for pipeline is required. Please contact your manager.": "パイプラインにインジェスト経路が必須です。管理者に連絡してください。",
            "Input assets will be automatically deleted after specified days": "インプット資産が指定された日以降に自動で削除されます。",
            "Input name is required.": "インプットの名前が必要です。",
            "Internal server error": "内部サーバのエラー",
            "Invalid CIDR. It must be in pattern of xxx.xxx.xxx.xxx/zz.": "CIDRが有効ではありません。 xxx.xxx.xxx.xxx/zzのパターンの形でなければなりません。",
            "Invalid upload path": "有効ではないアップロードの経路",
            "Multiple image files can be selected.": "様々なイメージファイルを選択できます。",
            "No {{name}} is set.<0/>Please set the {{name}} and try again.": "設定された {{name}}がありません。<br/>{{name}} 設定後、もう一度やり直してください。",
            "No {{name}} searched.": "検索された{{name}}がありません。",
            "No members is granted": "承認された構成員ではありません。",
            "No aduits is granted.": "監査は認められません",
            "No role is granted": "付与された役割がありません。",
            "One stream can be selected.": "1つのストリームを選択できます。",
            "Page not found": "ページが見つかりません。",
            "This page is not supported on mobile.": "モバイルでサポートされていないページです。",
            "Please use the button below to go back to the previous page.": "下のボタンから前のページに戻ってください。",
            "Path was not created. Please set again.": "経路が生成されませんでした。改めて設定してください。",
            "Pending to upload...": "アップロードの待機中…",
            "Please add a caption to use.": "使用するためのキャプション資産を追加してください。",
            "Please add a custom field to use.": "使用するカスタムフィールドを追加してください。",
            "Please add a poster assets to use.": "使用するポスター資産を追加してください。",
            "Please add images to use.": "イメージを追加してください。",
            "Please add people images.": "ピープルのイメージを追加してください。",
            "Please check and try again": "確認後、もう一度やり直してください。",
            "Please check the support format and try again.": "支援フォーマットを確認し、もう一度やり直してください。",
            "Please check valid single IP, IP range or CIDR.": "有効な単一IP、IP範囲またはCIDRを確認してください。",
            "Please contact your stage administrator to access the project.": "プロジェクトにアクセスするため、ステージ管理者に問い合わせしてください。",
            "Please go back to the main with the button below.": "下のボタンを通し、メインページへ移動してください。",
            "Please select a file to add": "追加するファイルを選択してください。",
            "Please select a file to add.": "追加するファイルを選択してください。",
            "Please select a valid file.": "正しいファイルを選択してください。",
            "Please select the project of the stage you want to access.": "アクセスしようとするステージのプロジェクトを選択してください。",
            "Please try again.": "もう一度やり直してください。",
            "Prefix cannot be empty": "接頭語は空にしてはいけません。",
            "Prefix must begin with s3://": "接頭語は必ず s3:// として始まらなければならないです。",
            "Remove connected medialive input.": "連結されたMediaLiveインプットを除去してください。",
            "Request a channel approval after creation": "生成後、チャンネル承認の申請",
            "Save the origin source as an asset": "原本ソースを資産として保存",
            "Schedule repeat can not be modified after setting. (Repeated lineups can only be deleted)": "設定後、スケジュールの繰り返しを修正できません。(繰り返されたラインナップは削除できます。)",
            "Search for faces in the video using saved face information.": "保存された顔の情報でビデオから顔を検索してください。",
            "Select a metadata": "メタデータを選択してください。",
            "Select AI analysis item": "AI分析項目を選択",
            "Select an face to analyze <0/>From the list of registered images on the left.": "左に登録されたイメージリストから<0/>分析を行いたい顔を選択してください。",
            "Select an face to index <0/>From the list of registered images on the left.": "左の登録されたイメージのリストから<0/>インデックスする顔を選択してください。",
            "Select files from the image type of assets.": "イメージタイプ資産からファイルを選択してください。",
            "Select one caption file.": "キャプションファイルを選択してください。",
            "Source must be selected in order to request a channel approval.": "チャンネルの承認を申請するにはソースを必ず選択する必要があります。",
            "Source selection is done after channel creation": "ソースの選択はチャネル作成後に行われます。",
            "Special chacters are not allowed": "特殊文字は使用できません。",
            "Special chacters can not be entered.": "特殊文字は入力できません。",
            "The \\\"End time\\\" must be later than \\\"Start time\\\"": "＼\"終了時間＼\"は ＼\"スタート時間＼\"より後でなければならないです。",
            "The \\\"Loop To Fill Lineup Duration\\\" setting applies only when the duration of the video is more than \\\"1 minute\\\".": "ビデオの再生時間が1分以上の時のみ ＼\"ラインナップ時間繰り返し埋める＼\" 設定が適用されます。",
            "The asset list is missing.": "資産リストがありません。",
            "The asset is only MP4 type video.": "資産はMP4タイプのビデオでなければならないです。",
            "The base video is applied only when the source type is schedules": "ソースタイプがリスティングの場合のみ基本ビデオを使用できます。",
            "The begin date time can not be past time.": "スタート時間は今より過去にはならないです。",
            "The begin date time must be registered after 2 minutes on the current time basis.": "スタート時間は現在時間を基準に2分後に登録しなければならないです。",
            "The changed roles will be applied to users below.": "変更された役割は次のユーザーに適用されます。",
            "The comment field can be up to {{byte}} byte long.": "コメントフィールドは最大{{byte}}byte です。",
            "The description can be up to {{byte}} byte": "説明フィールドは最大{{byte}}byteです。",
            "The description field can be up to {{limit}} byte long.": "説明フィールドは最大{{limit}}byte です。",
            "The file is not valid.": "ファイルが有効ではありません。",
            "The file source list is missing.": "ファイルのソースがありません。",
            "The key field be up to {{tag}} byte long.": "キーフィールドは最大{{tag}}byte です。",
            "The lineup Name field be up to {{name}} byte long.": "ラインナップの名前フィールドの最大の長さは{{name}}バイトです。",
            "The lineup priority field is greater than 0 and less than 100.": "ラインナップの優先順位のフィールドは0以上100未満です。",
            "The name field be up to {{title}} byte long.": "名前のフィールドは最大 {{title}}byte です。",
            "The name field can be up to {{limit}} byte long.": "名前のフィールドは最大 {{limit}}byte です。",
            "The name field is required": "名前フィールドは必須です。",
            "The page you requested could not be found.": "要求されたページを見つけることができます。",
            "The same file could not be found": "ファイルが見つかりません。",
            "The selected Whitelist rules can be modified.": "選択したホワイトリストの規則を修正できます。",
            "The team has no members.": "チームにメンバーがいません。",
            "The value field be up to {{tag}} byte long.": "値フィールの最大の長さは{{tag}}byteです。",
            "There is an event in the listing or a linked channel, so you can not delete that stream": "リスティングやチャンネルに連結されたイベントがあり、このストリームは削除できません。",
            "There is no analyzable item. Only non-DRM MP4 types are supported for analysis.": "分析可能な項目がありません。non-DRM MP4タイプのみ分析できます。",
            "There is no input to select.": "選択するインプットがありません。",
            "There is no schedules to select.": "選択可能なリスティングがありません。",
            "There is no project available to access.": "アクセス可能なプロジェクトがありません。",
            "There is work in progress. Would you really go out?": "進行中である作業があります。本当に退出しますか？",
            "{{count}} upload(s) transferring — do not close or reload this page": "転送中 {{count}} 件 — このページを閉じたり再読み込みしないでください",
            "Processing continues on the server.": "以降の処理はサーバー側で続行されます。",
            "Moving between menus or closing this panel is fine.": "メニューの移動やこのパネルを閉じることは問題ありません。",
            "{{count}} upload(s) transferred — you can close this page": "アップロード {{count}} 件の転送が完了 — このページを閉じても大丈夫です",
            "Uploading. Do not close or refresh this page.": "アップロード中です。このページを閉じたり再読み込みしないでください。",
            "There is work in progress. Would you really leave the page?": "進行中である作業があります。本当に退出しますか？",
            "There was either CORS or network error.": "CORSやネットワークのエラーが発生しました。",
            "This field can be up to {{maxByte}} bytes.": "このフィールドは最大 {{maxByte}} バイトまで可能です。",
            "This field must pass today's datetime.": "このフィールドは本日のデータ時間を超過しなければならないです。",
            "This file format is not supported.": "利用できないファイルのフォーマットです。",
            "This is not a valid URL pattern": "URLのパターンが有効ではありません。",
            "This schedules has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "このリスティング情報をアップデートしました。 <0/> リロードし、やり直してください。今リロードしますか？",
            "This stage is not accessible.": "このステージはアクセスできません。",
            "This space is not accessible.": "このスペースにはアクセスできません。",
            "This whitelist field is required.": "ホワイトリストのフィールドは必須です。",
            "To request a channel approval, you must select a source.": "チャンネル承認を申請するソースを選択してください。",
            "View only <0>requested channels</0>": "<0>申請されたチャンネルのみ</0>見る",
            "We're sorry!": "申し訳ございません!",
            "You can enter up to {{count}} whitelist rules": "ホワイトリストの規則は最大{{count}}個まで入力できます。",
            "You can only enter {{count}} whitelist rules": "最大{{count}}個までホワイトリストの規則を入力できます。",
            "You can upload files up to 500KB in size.": "500KBサイズまでアップロードできます。",
            "You can watch preview for 1 minute": "1分間プレビューを見ることができます。",
            "You do not have permission to access.": "アクセスの権限がありません。",
            "You don't have any {{name}} to select.": "選択できる{{name}}がありません。",
            "You don't have permission to view this page.": "このページを閲覧する権限がありません。",
            "You need to sign in a Megazone Accounts account to get started.": "開始するためにはMegazoneアカウントに加入する必要があります。",
            "Please select a project you want to access.": "アクセスしたいプロジェクトを選択してください。",
            "You have no site access.": "サイトにアクセスできません。",
            "There is already a folder with the same name. Please change it to a different name.": "同じ名前のフォルダが既に存在します。 別の名前に変更してください。",
            "{{target}} names can’t contain “/”.": "{{target}}名前に “/”を含めることはできません。",
            "There is already a {{target}} with the same name. Please change it to a different name.": "同じ名前の{{target}}がすでにあります。 他の名前に変えてください。",
            "deleteModalReferenceNesting1": "$t(common::msg::deleteModalReferenceKey1)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceNesting2": "$t(common::msg::deleteModalReferenceKey2)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceKey1": "<0>{{name}}</0>を削除すると、それも参照から削除され、これを元に戻すことはできなくなります{{dot}}",
            "deleteModalReferenceKey2": "<0>{{name}}</0>を削除すると、元に戻すことはできません{{dot}}",
            "deleteModalReferenceKey3": "確実に <0>{{name}}</0>を削除しますか？",
            "Don’t ask again": "二度と聞かないで",
            "If you delete <0>{{name}}</0>, You won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>を削除すると、元に戻すことはできません.<1/><0>{{name}}</0>を削除してもよろしいですか？",
            "Deleting {{currentIndex}} of {{deleteItemLength}}": "{{deleteItemLength}}つのうち{{currentIndex}}つを削除する",
            "You have selected <0>{{name}}</0>": "<0>{{name}}</0>を選択しました",
            "Remove from category <0>{{name}}</0>": "カテゴリから削除<0>{{name}}</0>",
            "Delete completely from Assets": "資産から完全に削除する",
            "It will also be removed from Reference and you won’t be able to revert this.": "また、リファレンスから削除され、これを元に戻すことはできません.",
            "Inactivated by error": "ステータス変更中のエラーにより無効化されました。",
            "Error while inactivating": "無効化中にエラーが発生しました。再度お試しください。",
            "Error while activating": "有効化中にエラーが発生しました。再度お試しください。",
            "An attempt to 'Archive' failed.": "「アーカイブ」の試みが失敗しました。",
            "An attempt to 'Restore' failed. Please try again.": "「復元」の試みが失敗しました。もう一度お試しください。",
            "An attempt to 'Archive' failed. Please try again.": "「アーカイブ」の試行に失敗しました。再度お試しください。",
            "An attempts to change the status from 'Active' to 'Inactive' failed. Please try again.": "ステータスを「Active」から「Inactive」に変更できませんでした。再度お試しください。",
            "If you archive the asset, you will be charged <0>the {{n}}-day</0> archive amount immediately.": "資産をアーカイブすると、<0> {{n}}日間</ 0>のアーカイブ料金がすぐに請求されます。",
            "Are you sure you want to archive?": "アーカイブしてもよろしいですか？",
            "If you restore the Archived Asset, You will be charged for the <0>remaining {{remainingDays}} days.</0>": "アーカイブされた資産を復元すると、<0>残りの{{remainingDays}}日間が請求されます。</ 0>",
            "Are you sure you want to restore?": "復元してもよろしいですか？",
            "Of the <0>{{currentDate}}</0> schedule, <0>only {{lineupCount}}</0> excluding the repeat lineup will be a all Copy to. Lineups with repeat lineups are excluded from the all copy to.": "<0> {{currentDate}} </ 0>スケジュールのうち、リピートラインナップを除く<0> {{lineupCount}} </ 0>のみがすべてコピー先になります。リピートラインナップを持つラインナップは、すべてのコピー先から除外されます。",
            "Are you sure you all copy to?": "すべてコピーしますか？",
            "There is a schedule on that date and it cannot be selected.<0/>Please delete the schedule for the selected date or select a different date.": "その日付にはスケジュールがあり、選択できません。<0 />選択した日付のスケジュールを削除するか、別の日付を選択してください。",
            "The <0> {{lineupCount}} lineups </0> included in the <0>{{currentDate}}</0> schedule will be all Copy to. <1/>However, the repeat lineups of the selected lineup will stop repeating this and future schedules.": "<0> {{currentDate}} </ 0>スケジュールに含まれる<0> {{lineupCount}}ラインナップ</ 0>は、すべてコピー先になります。 <1 />ただし、選択したラインナップの繰り返しラインナップは、このスケジュールと今後のスケジュールの繰り返しを停止します。",
            "<0>{{x}}</0> day(s) remaining": "残り<0>{{x}}</0>日",
            "Past broadcast lineup cannot be deleted.": "過去の放送ラインナップは削除できません。",
            "Lineup currently being broadcast cannot be delete.": "現在放送中のラインナップは削除できません。",
            "Schedules within 1 minute from the current time cannot be deleted.": "現在時刻から1分以内のスケジュールは削除できません。",
            "If you want All Copy to, lineups with the repeat schedule will stop repeating this and future schedules.": "All Copy toを使用する場合、繰り返しスケジュールを持つラインナップは、このスケジュールと今後のスケジュールの繰り返しを停止します。",
            "If you want to delete lineups with repeat schedule, you cannot delete the past lineup that was broadcast, but you can delete future Lineups including this one will be deleted.": "繰り返しスケジュールがあるラインナップを削除する場合、放送済みの過去のラインナップは削除できませんが、このラインナップを含む今後のラインナップは削除されます。",
            "Set up a YouTube account to publish.": "公開するにはYouTubeアカウントを設定してください。",
            "To add the channels of the account you want to publish, sign in to Youtube with that account.": "公開したいアカウントのチャンネルを追加するには、そのアカウントでYouTubeにサインインしてください。",
            "Duplicate login status.": "ログインステータスが重複しています。",
            "You are currently logged in from another web browser with your information, the connection is terminated and you are directed to the welcome page.": "現在、情報を使用して別のWebブラウザーからログインしています。接続が終了し、ウェルカムページに移動します。",
            "Your account has been expired.": "アカウントの有効期限が切れています。",
            "Your account has been inactivated.": "アカウントは無効になっています。",
            "Your account has been deleted.": "あなたのアカウントは削除されました。",
            "You cannot access the project.<0/>The connection is terminated and you are directed to the welcome page.": "プロジェクトにアクセスできません。<0 />接続が終了し、ウェルカムページが表示されます。",
            "Please contact your space manager.": "スペースマネージャに連絡してください。",
            "After starting the channel, you can watch past broadcasts by changing the playback position for up to 14 days.": "チャンネル開始後、最大14日間再生位置を変更することで過去の放送を見ることができます。",
            "Find objects by prefix": "プレフィックスでオブジェクトを検索",
            "A total of <0>{{type}}</0> participants can be invited per account, and participants must be divided into the schedule of the channels to be created.": "アカウントごとに合計<0>{{type}}</0>名の参加者を招待でき、参加者は作成するチャンネルのスケジュールに分けて割り当てる必要があります。",
            "Megazone Accounts members, please sign in through the button below.": "Megazone Accountsのメンバーは、下のボタンからサインインしてください。",
            "Megazone Login users, please sign in through the button below.": "Megazoneログインユーザーは、下のボタンからサインインしてください。",
            "If you do not have an account yet, please sign up through": "まだアカウントをお持ちでない場合は、からサインアップしてください。",
            "If you don’t have an account yet, please ask your Organization Administrator.": "まだアカウントをお持ちでない場合は、組織の管理者にお問い合わせください。",
            "Go to log in with": "でログインする",
            "You need to sign in a {{Megazone Accounts}} {{or}} {{Megazone Login}} account to get started.": "開始するには、{{Megazone Accounts}} {{or}} {{Megazone Login}}アカウントにサインインする必要があります。",
            "You do not have permission to Show Hidden Metadata.": "非表示のメタデータを表示する権限がありません。",
            "If you to Show Hidden Metadata, please ask your administration.": "非表示のメタデータを表示する場合は、管理者に問い合わせてください。",
            "Select a one file from the audio type of assets.": "オーディオタイプの資産から1つのファイルを選択してください。",
            "Select a one file from the image type of assets.": "イメージタイプの資産から1つのファイルを選択してください。",
            "Please add a {{name}} assets to use.": "使用するには{{name}}資産を追加してください。",
            "You can't access the space.": "スペースにアクセスできない。",
            "The space is inaccessible because your account has expired or has been deleted.": "あなたのアカウントが期限切れまたは削除されたため、スペースにアクセスできません。",
            "If you have issues with Space approval, please contact Megazone Cloud.": "スペース承認に問題がある場合は、Megazone Cloudに連絡してください。",
            "If you want to site access, please contact your space manager.": "アクセスをサイトにアクセスしたい場合は、Space Managerに連絡してください",
            "You need access": "アクセスが必要です",
            "If you want to check the assets you have selected, <0/> please ask for access.": "選択した資産を確認したい場合は、<0 />アクセスを依頼してください。",
            "Request sent": "リクエストが送信されました",
            "You will receive an email letting you know that <0/> the asset has been shared with you.": "資産が共有されたことを通知するメールが届きます。",
            "Enter Display Name or Username": "表示名またはユーザー名を入力します",
            "This asset has been deleted.": "この資産は削除されました。",
            "The deleted asset is removed from the Requested to Share.": "削除された資産は、共有のリクエストから削除されます。",
            "If necessary, contact the administrator.": "必要に応じて、管理者に連絡してください。",
            "Reason for rejection of sharing request (optional)": "共有リクエストの拒否理由（任意）",
            "There is no analytics data.": "分析データはありません.",
            "Detailed view of <0> {{number}} </0> tasks": "<0> {{number}} </0> のタスクの詳細ビュー",
            "files to the <0>{{name}}</0>": "ファイルを <0>{{name}}</0> へ",
            "An item with the name '<0>{{name}}</0>' is already in this location.": "「<0>{{name}}</0>」という名前の項目はすでにこの場所に存在します。",
            "Do you want to overwrite it with the target file?": "対象のファイルで上書きしますか？",
            "Renaming in <0>{{name}}</0>": "<0>{{name}}</0> の名前を変更中",
            "Moving <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "<0>{{totalCount}}</0>個のファイルを<0>{{sourceFolderName}}</0>から<0>{{distFolderName}}</0>へ移動中",
            "Copying <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "<0>{{totalCount}}</0>個のファイルを<0>{{sourceFolderName}}</0>から<0>{{distFolderName}}</0>へコピー中",
            "All linked video source assets have been deleted, <0/> so the video preview cannot be seen.": "すべてのリンクされたビデオソース資産が削除されたため、<0 />ビデオプレビューが表示されません。",
            "There are no items for video AI analysis.": "ビデオAI分析の項目はありません。",
            "Please add music file.": "音楽ファイルを追加してください。",
            "Select files from the Audio type of assets.": "オーディオタイプの資産からファイルを選択してください。",
            "Cannot change settings from Project Settings.": "プロジェクトマネージャーから設定を変更できない.",
            "Cannot change settings from Console.": "コンソールから設定を変更できない.",
            "Add one caption asset to use.<0/>The kind of caption can only select subtitles.": "使用するキャプション資産を1つ追加します。<0/>キャプションの種類では、字幕のみを選択できます。",
            "Select files from the video type of assets.": "ビデオタイプの資産からファイルを選択します",
            "Please add itemSet for metadata.": "メタデータのitemSetを追加してください。",
            "There is no ItemSet to select. Please add a ItemSet.": "選択するItemSetはありません。 ItemSetを追加してください。",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0>": "プログラムのキャプションは、<0> {{number}} </0> のキャプションで編集できます。",
            "There is a duplicate language among the captions applied to the <0> {{name}} </0>": "<0> {{name}}</0> に適用されるキャプションの中に重複する言語があります",
            "Please create a lineup after editing in the video as it is difficult to create a lineup if there are duplicate languages.": "言語が重複しているとラインナップが難しいので、動画編集後にラインナップを作成してください。",
            "Changed data exists. Are you sure you want to escape?": "変更されたデータが存在します。脱出してもよろしいですか？",
            "Add attendees to join the Group Chatting": "グループチャットに参加する参加者を追加します",
            "Enter Email Address": "メールアドレスを入力してください",
            "Saving of changes to '{{tab}}' failed.": "'{{tab}}' への変更の保存に失敗しました。",
            "Changes to the '{{tab}}' have been saved.": "'{{tab}}' への変更が保存されました。",
            "File upload failed.": "ファイルのアップロードに失敗しました。",
            "An invalid input file was selected.": "無効な入力ファイルが選択されました。",
            "Asset creation failed.": "資産の作成に失敗しました。",
            "The input file is in an unsupported format.": "入力ファイルはサポートされていない形式です。",
            "The transcoding operation failed due to an unexpected problem.": "予期しない問題が発生したため、トランスコーディング操作が失敗しました。",
            "If the problem persists, please contact the management.": "それでも問題が解決しない場合は、管理者に連絡してください。",
            "Please use a different file after checking the file upload rules.": "ファイルのアップロードルールを確認した後、別のファイルを使用してください。",
            "The media information may not be queried, or an invalid file may have been entered.": "メディア情報が照会されないか、無効なファイルが入力された可能性があります。",
            "Use streaming software to send live streams to Amazon IVS, providing users with low-latency live stream services and interactive video experiences.": "ストリーミングソフトウェアを使用してライブストリームをAmazonIVSに送信し、ユーザーに低遅延のライブストリームサービスとインタラクティブなビデオ体験を提供します。",
            "Provides real-time communication components such as online conferencing services by leveraging messaging, audio, video and screen sharing capabilities to web or mobile applications.": "メッセージング、オーディオ、ビデオ、および画面共有機能をWebまたはモバイルアプリケーションに活用することにより、オンライン会議サービスなどのリアルタイム通信コンポーネントを提供します。",
            "Broadcast and deliver live video in up to Full HD.": "最大フルHDでライブビデオをブロードキャストおよび配信します。",
            "Broadcast and deliver live video in up to SD.": "最大SDでライブビデオをブロードキャストおよび配信します。",
            "Best for near real-time interactions with viewers.": "視聴者とのリアルタイムの双方向性が必要な場合に有効にします。",
            "Enable if real-time interactivity with viewers is not required. May improve reliability in certain regions.": "視聴者とのリアルタイムの双方向性が必要ない場合に有効にします。 特定の地域で信頼性が向上する可能性があります。",
            "Enable token-authorization requirement for video playback.": "ビデオ再生のトークン認証要件を有効にする。",
            "Channel’s live stream is automatically recorded and created as Videos and Assets.": "チャンネルのライブストリームは自動的に記録され、動画と資産として作成されます。",
            "A chat where all attendees on the channel can join the chat.": "チャネルのすべての参加者がチャットに参加できるチャット。",
            "A chat that allows for close interaction between invited attendees.": "招待された参加者間の緊密な相互作用を可能にするチャット。",
            "If the chat type is modified after channel creation, all previously set values are initialized.": "チャネルの作成後にチャットタイプが変更されると、以前に設定されたすべての値が初期化されます。",
            "Failed to save changes": "変更の保存に失敗しました",
            "Search for files in Assets.": "資産でファイルを検索します。",
            "You are about to revoke site access for <0>{{name}}</0>.<1/>This user won’t be able to use your space. You can give them access at any time.<1/>Are you sure you want to revoke site access for this user?": "<0> {{name}} </ 0>のサイトアクセスを取り消そうとしています。<1 />このユーザーはあなたのスペースを使用できなくなります。 いつでもアクセスを許可できます。<1 />このユーザーのサイトアクセスを取り消してもよろしいですか？",
            "You are about to remove  <0>{{name}}</0> from space.<1/>This user will no longer have access to the space. Your space will still keep all of this user’s contributions.<1/>Are you sure you want to remove user from space?": "スペースから<0> {{name}} </ 0>を削除しようとしています。<1 />このユーザーはスペースにアクセスできなくなります。 スペースには、このユーザーの投稿がすべて保持されます。<1 />ユーザーをスペースから削除してもよろしいですか？",
            "Bucket names must be between 3 and 63 characters long.": "バケット名は 3～63 文字の長さにする必要があります。",
            "Bucket names can consist only of lowercase letters, numbers, dots (.), and hyphens (-).": "バケット名は、小文字、数字、ドット (.)、およびハイフン (-) のみで構成できます。",
            "Bucket names must begin and end with a letter or number.": "バケット名は、文字または数字で開始および終了する必要があります。",
            "Bucket names must not be formatted as an IP address (for example, 192.168.5.4).": "バケット名は IP アドレスの形式 (192.168.5.4 など) にはできません。",
            "Bucket names must not start with the prefix xn--.": "バケット名のプレフィックスは xn-- で始まってはいけません。",
            "Bucket names must not end with the suffix -s3alias.": "バケット名のサフィックスは -s3alias で終わってはいけません。",
            "Bucket names cannot have consecutive periods.": "バケット名にピリオドを連続させることはできません。",
            "You can enter up to 10 users.": "最大10人のユーザーを入力できます。",
            "Of the selected assets, {{createItemLength}} out of {{selectedItemLength}} can be created as photos. <1/>Choose whether you want <0>the {{createItemLength}} assets</0> to be multiple photos or a single photo.": "選択した資産のうち、{{selectedItemLength}}のうち{{createItemLength}}を写真として作成できます。 <1 /> <0> {{createItemLength}}資産</ 0>を複数の写真にするか単一の写真にするかを選択します。",
            "The {{createItemLength}} selected assets have been selected to be created as multiple photos.<0/>Would you like to create a photo now?": "{{createItemLength}}で選択した資産が、複数の写真として作成するように選択されました。<0 />今すぐ写真を作成しますか？",
            "The photo name is applied to the name being used in the asset, and metadata can be edited in the created photo.": "写真の名前は資産で使用されている名前に適用され、作成された写真のメタデータを編集できます。",
            "Would you like to log out from the account service as well?": "アカウントサービスからもログアウトしますか？",
            "Conveniently apply to asset types through the Apply All Over option.": "[すべて適用]オプションを使用して、資産タイプに便利に適用できます。",
            "There is a history of individual modification of some metadata among assets of this asset type.": "この資産タイプの資産には、一部のメタデータを個別に変更した履歴があります。",
            "If you save, all the changed metadata will be applied.": "保存すると、変更されたすべてのメタデータが適用されます。",
            "Are you sure you want to fix it though?": "でも修正してもよろしいですか？",
            "When applied, all default metadata is applied.": "適用すると、すべてのデフォルトのメタデータが適用されます。",
            "Do you still want to apply?": "それでも応募しますか？",
            "Changes made to files in the storage list are not updated here.": "ストレージリストでファイルを変更しても、ここでは更新されません。",
            "If you want to change the file, you must close the ‘Create Asset Bulk’ screen and re-enter after making changes in the storage list.": "もしファイルを変更したい場合は、「資産バルク作成」画面を閉じて、ストレージリストから変更後に再入力する必要があります。",
            "If the asset contains only one single file": "資産内に1つの単一ファイルしか含まれていない場合",
            "If the asset contains multiple files": "資産内に多数のファイルが含まれている場合",
            "If the language code for the file is appended after the file name (_), the language and label are automatically applied.": "ファイル名（_）の後にファイルに合った言語コードを付けると、自動的に言語とラベルが適用されます。",
            "If the language code is not applied after the file name (_), the language and label are applied in English (United States).": "ファイル名（_）の後に言語コードを適用しない場合、言語とラベルは英語（Unitied States）で適用されます。",
            "Add files in the first step, Add Files to Bulk.": "最初のステップであるバルクファイルの追加でファイルを追加します。",
            "Language and label are automatically applied language and label.": "言語とラベルは自動的に言語とラベルが適用されます。",
            "Language and labels apply in English (United States).": "言語とラベルは英語（United States）として適用されます。",
            "Kind default is applied as caption type.": "キャプションタイプには種類のデフォルトが適用されます。",
            "Creation for {{count}} assets requested.": "{{count}}個の資産の作成が要求されました。",
            "It may take some time for stable processing because it is downloading a file from a location far away from the current location (overseas) or a large file.": "現在の場所から離れた場所（海外）からファイルをダウンロードするか、大容量ファイルをダウンロードするため、安定した処理に時間がかかることがあります。",
            "If you want to check the file you have selected, <0/> Please contact your space administrator.": "選択したファイルを確認するには管理者へ問い合わせをお願いします。",
            "If it is an item in the 'Current Project', all functions can be used.": "「現在のプロジェクト」内のアイテムの場合、すべての機能を使用できます。",
            "If it is an accessible 'Not Accessible' item, all functions cannot be used.": "「アクセス不可」のアイテムの場合、すべての機能は使用できません。",
            "If it is an accessible 'other project' item, you can use the download function.": "アクセス可能な「他のプロジェクト」のアイテムであれば、ダウンロード機能を使用できます。",
            "To check the folder, select the project to which the bucket the folder<0/>belongs to, and then switch the site to the selected project.": "そのフォルダを確認するには、フォルダが属するバケットが割り当てられているプロジェクトを選択したら、<0/>選択したプロジェクトにサイトを切り替える必要があります。",
            "Are you sure you want to check the folder<0/>after switching to the selected project?": "選択したプロジェクトに切り替えたら、<0/>該当するフォルダを確認しますか？",
            "Download period is up to <0>{{totalCount}}</0> days, and the number of downloads is up to <0>{{sourceFolderName}}</0> times.": "ダウンロード期間は最大<0>{{totalCount}}</ 0>日で、ダウンロード数は最大<0> {{sourceFolderName}}</0>回です。",
            "The download period is up to <0> {{number}} </0> days.": "ダウンロード期間は最大<0>{{number}}</0>日です。",
            "The number of downloads is up to <0/> times.": "ダウンロード回数は最大<0/>回です。",
            "The download period is up to <0>{{period}}</0> days,<1/>and the number of downloads is up to <0>{{count}}</0> times left.": "ダウンロード期間は最大<0>{{period}}</ 0>日、ダウンロード数は最大<0> {{count}}</0>回です。",
            "The password is wrong <0>{{count}}</0> times. Please check the password.": "パスワードが<0>{{count}}</0>回間違っています。 パスワードを確認してください。",
            "In case of error <0>{{count}}</0> times, the download link URL is no longer available.": "エラーが<0>{{count}}</ 0>回発生した場合、ダウンロードリンクのURLは利用できなくなります。",
            "If you want to continue downloading,<0/>please get the download link URL back.": "ダウンロードを続行する場合は、<0/>ダウンロードリンクのURLを取得してください。",
            "The requested page may have disappeared or the path may be incorrect.<0/>Please check and try again.": "要求されたページが消えたか、パスが正しくない可能性があります。<0/>確認して再試行してください。",
            "The download period is up to <0>{{period}}</0> days.": "ダウンロード期間は最大<0>{{period}}</ 0>日です。",
            "up to <0> {{number}} </0> days.": "最大<0>{{number}}</0>日。",
            "up to <0/> times.": "最大<0/>回。",
            "Are you sure you want to approval the selected<0/><1>{{name}}</1>?": "選択した<0/><1>{{name}}</1>を承認してもよろしいですか?",
            "Are you sure you want to reject the selected<0/><1>{{name}}</1>?": "選択した<0/><1>{{name}}</1>を拒否してもよろしいですか?",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.": "<0>{{name}}</0> を削除すると、アイテムはビューから削除されます。",
            "Other users will still have access.": "他のユーザーは引き続きアクセスできます。",
            "Are you sure you want to remove the item?": "アイテムを削除してもよろしいですか?",
            "If you remove <0>{{number}}</0> other then <0>{{name}}</0>, the items is deleted from the view.": "<0>{{name}}</0> 以外の <0>{{number}}</0> を削除すると、アイテムはビューから削除されます。",
            "Are you sure you want to remove the items?": "アイテムを削除してもよろしいですか?",
            "Also, all shared users will no longer have access and will be removed from the shared list.": "また、すべての共有ユーザーはアクセスできなくなり、共有リストから削除されます。",
            "Select the folder path. If not specified, it is stored in the top-level path.": "フォルダパスを選択してください。 指定しない場合は、最上位パスに保存されます。",
            "The folder path of the asset is a virtual path specified by the user and is different from the actual S3 folder path.": "資産のフォルダパスは、ユーザーが直接指定した仮想パスで、実際のS3フォルダパスとは異なります。",
            "Deleting {{currentIndex}} of <0>{{deleteItemLength}}</0> assets": "資産 <0>{{deleteItemLength}}</0> 個のうち {{currentIndex}} を削除中",
            "If you delete <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete?": "<0> {{name}} </0>を削除すると、元に戻すことはできません。<1/>本当に削除しますか？",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won’t be able to revert this.<1/>Are you sure you want to delete?": "<0> {{name}} </0>を削除すると、参照からも削除され、元に戻すことはできません。<1/>本当に削除しますか？",
            "The download period is up to <0>{{period}}</0> days left.": "ダウンロード期間は残り<0>{{period}}</0>日までです。",
            "File {{item}} has been shared": "ファイル{{item}}が共有されました",
            "Asset {{item}} has been shared": "資産{{item}}が共有されました",
            "There was an error removing file {{item}}": "ファイル{{item}}の削除中にエラーが発生しました",
            "There was an error removing asset {{item}}": "資産{{item}}の削除中にエラーが発生しました",
            "Asset {{item}} and {{length}} other items have been removed.": "資産{{item}}と{{length}}個の他のアイテムが削除されました。",
            "File {{item}} and {{length}} other items have been removed.": "ファイル{{item}}と{{length}}個の他のアイテムが削除されました。",
            "Asset {{item}} has been removed.": "資産{{item}}が削除されました。",
            "File {{item}} has been removed.": "ファイル{{item}}が削除されました。",
            "There was an error removing file {{item}} and {{length}} other items.": "ファイル{{item}}と{{length}}個の他のアイテムの削除中にエラーが発生しました。",
            "There was an error removing asset {{item}} and {{length}} other items.": "資産{{item}}と{{length}}個の他のアイテムの削除中にエラーが発生しました。",
            "There was an error removing file {{item}}.": "ファイル{{item}}の削除中にエラーが発生しました。",
            "There was an error removing asset {{item}}.": "資産{{item}}の削除中にエラーが発生しました。",
            "There was an error sharing file {{item}}.": "ファイル{{item}}の共有中にエラーが発生しました。",
            "There was an error sharing asset {{item}}.": "資産{{item}}の共有中にエラーが発生しました。",
            "Since this is a category group that is not used in assets, you can check the created assets in 'categories not classified in assets'.": "資産で使用されていないカテゴリグループであるため、生成された資産は「資産に分類されていないカテゴリ」で確認できます。",
            "There was an error deleting folder {{item}}.": "フォルダ {{item}} の削除中にエラーが発生しました。",
            "Deletion of folder {{item}} has been completed.": "フォルダ {{item}} の削除が完了しました。",
            "Creation of new folder {{item}} is completed.": "新しいフォルダ {{item}} の作成が完了しました。",
            "There was an error creating the new folder {{item}}.": "新しいフォルダ {{item}} の作成中にエラーが発生しました。",
            "Discard unsaved changes?": "保存されていない変更を破棄しますか?",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.": "<0>{{name}}</0>を削除すると、元に戻すことができません。",
            "Sync requested.": "同期が完了しました。",
            "Move completed from {{item1}} to {{item2}}.": "{{item1}} から {{item2}} への移動が完了しました。",
            "Moved '{{item1}}' into '{{item2}}'.": "「{{item1}}」を「{{item2}}」の中に移動しました。",
            "Failed to save the folder order change. Reverted to the original state.": "フォルダーの順序変更の保存に失敗しました。元の状態に戻しました。",
            "Failed to save the folder move. Reverted to the original state.": "フォルダーの移動の保存に失敗しました。元の状態に戻しました。",
            "Refreshing the folder tree. Please try again.": "フォルダーツリーを最新の情報に更新します。もう一度お試しください。",
            "Error moving from {{item1}} to {{item2}}.": "{{item1}} から {{item2}} への移動中にエラーが発生しました。",
            "Error renaming from {{item1}} to {{item2}}.": "{{item1}} から {{item2}} への名前変更中にエラーが発生しました。",
            "This folder contains assets.": "このフォルダーには資産が含まれています。",
            "Rename completed from {{item1}} to {{item2}}.": "{{item1}} から {{item2}} への名前変更が完了しました。",
            "The sharing period for this file has expired. <0/> If you want to check the file you have selected, <0/> Please ask the sharer to share.": "このファイルの共有期間は終了しました。 <0/> 選択したファイルを確認したい場合は、 <0/> 共有者に共有を依頼してください。",
            "There was an error creating event trigger.": "イベントトリガーの作成中にエラーが発生しました。",
            "Creation of event trigger has been completed.": "イベントトリガーの作成が完了しました。",
            "If you delete \"<0>{{name}}</0>\", you won’t be able to revert this.<1/>Are you sure you want to delete?": "「<0>{{name}}</0>」を削除すると、元に戻せなくなります。<1/>本当に削除しますか?",
            "Deleting <0>{{currentIndex}}</0>  of <0>{{deleteItemLength}}</0> assets": "<0>{{deleteItemLength}}</0> 個の資産の <0>{{currentIndex}}</0> 個を削除しています",
            "\"<0>{{name}}</0>\" will be deleted forever and you won’t be abled to restore it.": "「<0>{{name}}</0>」は完全に削除され、元に戻すことはできません。",
            "“{{name}}” will be deleted forever and you won’t be abled to restore it.": "「{{name}}」は完全に削除され、元に戻すことはできません。",
            "It can only be deleted if there are no assets in the folder.": "フォルダに資産がない場合にのみ削除できます。",
            "Specify the folder location?": "フォルダの場所を指定しますか?",
            "It may take time to send mail when there are {{count}} or more shared files or folders. (Approximately 3 minutes per 1GB)": "共有ファイルやフォルダーが{{count}}個以上ある場合、メールの送信に時間がかかる場合があります。 (1GBあたり約3分)",
            "Depending on the size of the shared file, it may take time to send the email. (Approximately 3 minutes per 1GB)": "共有ファイルのサイズによっては、メールの送信に時間がかかる場合があります。(1GBあたり約3分)",
            "If you restore this item now, you will also be charged for the <NewLine>remaining <Strong>{{n}} days.</Strong></NewLine>": "今すぐ復元すると、残りの<Strong>{{n}}日</Strong>の費用も請求されます。",
            "No search results found.": "検索結果が見つかりませんでした。",
            "Search for the owner of the asset.": "資産の所有者を検索してください。",
            "Enter after typing": "入力後Enterキー",
            "Enter the extension in lowercase without a dot. (e.g. mp4)": "拡張子はドット(.)なしの小文字で入力してください。(例: mp4)",
            "The download of asset '{{name}}' and {{count}} other have been requested.": "資産'{{name}}'と他{{count}}個のダウンロードがリクエストされました。",
            "The download of asset '{{name}}' has been requested.": "資産'{{name}}'のダウンロードがリクエストされました。",
            "Please select the project you wish to access.": "アクセスしたいプロジェクトを選択してください。",
            "Error saving changes to {{resource}} settings. {{line}} Please refresh the page and try again.": "{{resource}} 設定への変更を保存中にエラーが発生しました。 {{line}} ページを更新して、もう一度お試しください。",
            "Changes to your {{resource}} settings have been saved.": "{{resource}} 設定への変更が保存されました。",
            "Please search by asset name.": "資産名で検索してください。",
            "Please enter the name.": "名前を入力してください。",
            "Please enter the description.": "説明を入力してください。",
            "Error saving changes to project details. {{line}} Please refresh the page and try again.": "プロジェクトの詳細への変更を保存中にエラーが発生しました。 {{line}} ページを更新してもう一度やり直してください。",
            "Changes to your project details settings have been saved.": "プロジェクトの詳細設定への変更が保存されました。",
            "Error adding project '{{name}}'. {{line}} Please refresh the page and try again.": "プロジェクト'{{name}}'の追加中にエラーが発生しました。 {{line}} ページを更新して、もう一度お試しください。",
            "Project '{{name}}' has been added.": "プロジェクト'{{name}}'が追加されました。",
            "The project lead has been updated.": "プロジェクトリーダーが更新されました。",
            "Error updating the project lead. {{line}} Please refresh the page and try again.": "プロジェクト リーダーの更新中にエラーが発生しました。 {{line}} ページを更新してもう一度やり直してください。",
            "Asset '{{name}}' has been archived.": "資産'{{name}}'がアーカイブされました。",
            "Bucket '{{name}}' is feature locked for other users.": "バケット「{{name}}」が他のユーザーの機能ロックを設定しました。",
            "Bucket '{{name}}' is feature unlocked for another user.": "バケット「{{name}}」が他のユーザーの機能ロックを解除しました。",
            "Error occurred while feature-locking bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "バケット '{{name}}' を他のユーザーの機能ロック中にエラーが発生しました。 {{line}}ページを更新してもう一度やり直してください。",
            "Error occurred while attempting to feature unlock bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "バケット '{{name}}' を他のユーザーの機能のロック解除中にエラーが発生しました。 {{line}}ページを更新してもう一度やり直してください",
            "This setting can lock the bucket so that other users cannot use the storage’s features (Copy, Move, Rename, Delete).": "この設定により、他のユーザーがストレージの機能 (コピー、移動、名前変更、削除) を使用できないようにバケットをロックできます。",
            "This bucket is locked by another user and can only be downloaded.": "このバケットは他のユーザーによってロックされており、ダウンロードのみ可能です。",
            "No items match this filter": "このフィルタに一致する項目がありません",
            "None of achives matched this search": "この検索に一致するアーカイブがありません",
            "Find items using another filter option.": "別のフィルタオプションを使用して項目を検索します。",
            "Try another search, <br/> or use the search option to find an asset.": "別の検索を試みるか、<br/>または、検索オプションを使用して資産を検索します。",
            "You can archive by selecting the items you want to <br/> archive under “Assets”.": "「資産」の下で<br/>アーカイブするアイテムを選択するとアーカイブできます。",
            "No items have been archived yet.": "まだアーカイブされたアイテムがありません。",
            "Enter Asset Name": "資産の名を入力してください。",
            "Enter Archived ID": "アーカイブのIDを入力してください。",
            "Enter Asset ID": "資産のIDを入力してください。",
            "Enter Archived by": "アーカイブ者を入力してください",
            "Enter Owner": "所有者を入力してください。",
            "Welcome": "ようこそ",
            "You need to log in to your Megazone account to start CloudPlex.": "CloudPlexを起動するには、Megazoneアカウントにログインする必要があります。",
            "Login with your Megazone account": "Megazoneアカウントでログイン",
            "Size of files Option : Number of files option is required. <NewLine/> Number of files option : Can be set without checking size of files.": "ファイルサイズオプション : ファイル数オプションは必須です。 <NewLine/> ファイル数オプション : ファイルのサイズを確認せずに設定できます。",
            "If you archive the assets, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "資産をアーカイブすると、<0>{{n}} 日間</0>のアーカイブ<1/>金額がすぐに請求されます。",
            "If you archive the asset, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "資産をアーカイブすると、<0>{{n}} 日</0>のアーカイブ<1/>金額がすぐに請求されます。",
            "If you restore this item now, you will also be charged for the <NewLine/>remaining days per asset.": "このアイテムを今復元すると、資産ごとの <NewLine/>残り日数も請求されます。",
            "Getting Access Token...": "アクセストークンを取得しています...",
            "Get Access Token": "アクセストークンを取得する",
            "To use CloudPlex Delivery's CDN, an Access Token must be issued.": "CloudPlex Delivery の CDN を使用するには、アクセス トークンを発行する必要があります。",
            "Please search by asset name or ID.": "資産名またはIDで検索してください。",
            "No collection items yet.": "コレクションアイテムはまだありません。",
            "Add it using the “Create” button.": "「生成」ボタンを使用して追加してください。",
            "No linked collection yet.": "リンクされたコレクションはまだありません。",
            "No assets yet.": "資産はまだありません。",
            "Add it using the “+” button.": "「＋」ボタンで追加してください。",
            "Please search by collection name.": "コレクション名で検索してください。",
            "Selected assets can be archived by selecting the storage <NewLine/> class to be archived.": "アーカイブするストレージ クラスを選択することで、<NewLine/> 選択した資産をアーカイブできます。",
            "Selected assets can be restored by selecting a restore <NewLine/>option based on how they were archived.": "選択した資産は、アーカイブ方法に基づいて復元 <NewLine/> オプションを選択することで復元できます。",
            "“{{name}}” and {{count}} others will be deleted forever and you won’t be abled to restore it.": "「{{name}}」と他{{count}}は永久に削除され、復元することはできません。",
            "However, assets included in the collection are not deleted.": "ただし、コレクションに含まれる資産は削除されません。",
            "Deletion of collection {{item}} has been completed.": "コレクション{{item}}の削除が完了しました。",
            "Partial deletion of collection {{item}} and {{count}} others have been completed.": "コレクション{{item}}とその他の{{count}}個の部分的な削除が完了しました。",
            "Deletion of collection {{item}} and {{count}} others have been completed.": "コレクション{{item}}とその他の{{count}}個の削除が完了しました。",
            "There was an error deleting collection": "コレクションの削除中にエラーが発生しました",
            "There was an error deleting collections": "コレクションの削除中にエラーが発生しました",
            "Size of files Option : If you choose your own assets, you can have up to {{maxAssets}}. <NewLine/> Keep the number of selected assets under {{maxAssets}}.": "ファイルのサイズ オプション: 独自の資産を選択した場合は、最大 {{maxAssets}} を含めることができます。 <NewLine/> 選択した資産の数を {{maxAssets}} 未満に保ちます。",
            "Select assets through search to put them in your collection.": "検索を通じて資産を選択し、コレクションに追加します。",
            "Select the folder containing the assets you want to put in your collection.": "コレクションに入れたい資産が含まれるフォルダーを選択します。",
            "Select collections through search to put them in your collection.": "検索を通じてコレクションを選択し、コレクションに追加します。",
            "The maximum number of tags, {{maxCount}}, has been exceeded.": "タグの最大数 {{maxCount}} を超えました。",
            "Please search by collection name or ID.": "コレクション名またはIDで検索してください。",
            "Deletion of content schema {{item}} has been completed.": "コンテンツスキーマ{{item}}の削除が完了しました。",
            "There was an error deleting content schema.": "コンテンツスキーマの削除中にエラーが発生しました。",
            "Content schema '{{name}}' has been added.": "コンテンツスキーマ'{{name}}'が追加されました。",
            "Up to 50 {{referenceType}} can be registered": "{{referenceType}}は50件まで登録可能です。",
            "You can activate a fortress field right away, and you can additionally turn the field into a user camp.": "要塞フィールドをすぐにアクティブにすることができ、さらにフィールドをユーザーキャンプにすることもできます。",
            "No projects are in use yet.": "まだ使用中のプロジェクトはありません。",
            "You must add at least 1 field for “Reference Fields”.<NewLine/> Only then can the schema status be changed to “active” and used in the project.": "「参照フィールド」に少なくとも 1 つのフィールドを追加する必要があります。<NewLine/> これでのみ、スキーマのステータスを「アクティブ」に変更し、プロジェクトで使用できるようになります。",
            "After opening the Fields panel via the “Add Fields” button,<NewLine/> add fields by dragging them to the “{{isReference}} Fields” layout.": "「フィールドの追加」ボタンでフィールドパネルを開いた後、<NewLine/> フィールドを「{{isReference}} フィールド」レイアウトにドラッグして追加します。",
            "The name starts with English, contains at least 2 letters, and can only contain English, spaces, and numbers.": "名前は英語で始まり、少なくとも 2 文字を含み、英語、スペース、数字のみを含めることができます。",
            "No items yet.": "まだアイテムがありません。",
            "Add it using the “Add {{name}}” button.": "「{{name}} 追加」ボタンを使用して追加してください。",
            "“{{name}}” will be removed.": "\"{{name}}\"は削除されます。",
            "“{{name}}” and {{count}} others will be removed.": "\"{{name}}\"と{{count}}の他は削除されます。",
            "None of collection matched this search. {{line}} Try another search.": "この検索に一致するコレクションはありませんでした。 {{line}} 別の検索を試してください。",
            "Delete the item?": "アイテムを削除しますか？",
            "Delete these items?": "アイテムを削除しますか？",
            "However, assets and content contained in {{schemaName}} are not deleted.": "ただし、{{schemaName}}に含まれる資産とコンテンツは削除されません。",
            "Select preview image through search to put them in your content.": "検索を通じてプレビュー画像を選択し、コンテンツに挿入します。",
            "Deletion of custom content {{item}} and {{count}} others has been completed.": "カスタム コンテンツ{{item}}とその他 {{count}}個の削除が完了しました。",
            "Deletion of custom content {{item}} has been completed.": "カスタム コンテンツ{{item}}の削除が完了しました。",
            "Please search by name or ID.": "名前またはIDで検索してください。",
            "Please search by {{resourceType}} name or ID.": "{{resourceType}}の名前またはIDで検索してください。",
            "Try another search to find an content.": "もう一度検索してコンテンツを見つけてください。",
            "You must enter your authentication information to use the engine.": "エンジンを使用するには、認証情報を入力する必要があります。",
            "Delete message?": "メッセージを削除しますか?",
            "Deleting a message cannot be canceled.": "メッセージの削除はキャンセルできません。",
            "This message was deleted.": "このメッセージは削除されました。",
            "Please enter your message.": "メッセージを入力してください。",
            "Would you like to make a private comment?": "プライベートコメントを作りますか？",
            "Please enter a private comment name.": "プライベートコメント名を入力してください。",
            "Add users to participate in private comments.": "プライベートコメントのユーザーを追加してください。",
            "you can add users of the project to communicate with them.": "プロジェクトのユーザーを追加してコミュニケーションを取ることができます。",
            "Would you like to change your private comment name?": "プライベートコメント名を変更えますか？",
            "Are you sure you want to delete the private comment?": "プライベートコメントを削除してもよろしいですか?",
            "If you delete <0>\"{{name}}\"</0>, all messages will be deleted and cannot be restored after deletion.": "<0>「{{name}}」</0> を削除すると、すべてのメッセージが削除され、削除後に復元することはできません。",
            "This is a message window where all the basics of the project can be seen.": "これは、プロジェクトの基本をすべて確認できるメッセージ ウィンドウです。",
            "By entering @mention, you can send a comment to the designated member.": "@mentionを入力すると指定したメンバーにコメントを送ることができます。",
            "This is a message window that only added members can see.": "これは、追加されたメンバーのみが表示できるメッセージ ウィンドウです。",
            "Please enter your user email.": "ユーザーのメールアドレスを入力して Enter キーを押してください。",
            "Projects you want to allow access to": "アクセスを許可したいプロジェクト",
            "Select the project you want to allow access to.": "アクセスを許可したいプロジェクトを選択します。",
            "Select the role you want to grant.": "付与する役割を選択します。",
            "Search by user email.": "ユーザーのメールアドレスで検索します。",
            "Deletion of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} の削除が完了しました。",
            "Duplication of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} の複製が完了しました。",
            "Creation of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} の作成が完了しました。",
            "Delete this role?": "この役割を削除しますか?",
            "Please enter a message. (Optional)": "メッセージを入力してください。 (オプション)",
            "Please enter user's name.": "ユーザー名を入力してください。",
            "Select assets.": "資産を選択します。",
            "If you change the applied custom metadata, all data entered will be lost.": "適用されたカスタム メタデータを変更すると、入力されたすべてのデータが失われます。",
            "After AI analyzes the content, the field values of the selected content schema are automatically filled in. Only one schema can be selected.": "AIがコンテンツを分析した後、選択したコンテンツスキーマのフィールド値を自動的に入力します。スキーマは1つだけ選択できます。",
            "Search by custom metadata name.": "カスタムメタデータ名で検索してください。",
            "There are no private comments.": "プライベートなコメントはありません。",
            "Use the \"Create private comment\" button Make it.": "「非公開コメントを作成」ボタンを使用して作成します。",
            "Enter name or email": "名前またはメールアドレスを入力してください。",
            "Please enter a message for your request (Optional)": "ご要望のメッセージをご入力ください（任意）",
            "Folder can only be deleted if there are no assets in the folder.": "フォルダーは、フォルダー内に資産が存在しない場合にのみ削除できます。",
            "Select collections in a specific folder?": "特定のフォルダー内のコレクションを選択しますか?",
            "This field is required.": "このフィールドは必須です。",
            "Invalid invitation code or Your invitation link may have expired.": "招待コードが無効であるか、招待リンクの有効期限が切れている可能性があります。",
            "Please contact your administrator to request a new invitation link.": "管理者に連絡して、新しい招待リンクをリクエストしてください。",
            "Hello,<NewLine/>Welcome to LX Hausys Design Library.": "LX Hausys デザイン ライブラリへようこそ。",
            "Up to <strong>{{number}}</strong> attachments are allowed.": "最大 <strong>{{number}}</strong> 個の添付ファイルが許可されます。",
            "Please select up to <strong>{{number}}</strong> files and try again.": "最大 <strong>{{number}}</strong> 個のファイルを選択して、もう一度お試しください。",
            "You are currently planning to upload <strong>{{added}}</strong> files. If you would like to attach another file, please remove the file and try again.": "現在、<strong>{{added}}</strong> ファイルのアップロードを計画しています。別のファイルを添付したい場合は、ファイルを削除して再度お試しください。",
            "You are currently planning to upload <strong>{{added}}</strong> files. Please select and attach up to <strong>{{remaining}}</strong> additional files.": "現在、<strong>{{added}}</strong> ファイルのアップロードを計画しています。最大 <strong>{{remaining}}</strong> 個の追加ファイルを選択して添付してください。",
            "The maximum capacity per attachment is up to <strong>{{maxSize}}</strong>.": "添付ファイルごとの最大容量は最大 <strong>{{maxSize}}</strong> です。",
            "The current file has exceeded its capacity. Please check the file to attach and try again.": "現在のファイルが容量を超えています。添付するファイルを確認して、もう一度試してください。",
            "Asset {{item}} duplication completed.": "資産{{item}}の複製が完了しました。",
            "Please search by folder name": "フォルダ名で検索してください。",
            "Folder": "フォルダ",
            "\"Custom Metadata\" can be applied to an asset’s custom metadata and is available when its status is enabled.": "「カスタム メタデータ」は資産のカスタム メタデータに適用でき、ステータスが有効な場合に使用できます。",
            "Enter required fields for “{{name}}” <0>{{count}}</0>/{{total}}": "「{{name}}」の必須項目を入力 <0>{{count}}</0>/{{total}}",
            "and <0>{{count}}</0> more": "他 <0>{{count}}</0> 件",
            "There is no data for this widget.": "このウィジェットにはデータがありません。",
            "Failed to load preview image. Please again.": "プレビュー画像の読み込みに失敗しました。もう一度お願いします。",
            "Preview image Creating...": "プレビュー画像作成中...",
            "Failed to load preview image. <NewLine/>please try again.": "プレビュー画像の読み込みに失敗しました。 <NewLine/>もう一度試してください。",
            "Some assets are missing required metadata for electronic payment.<NewLine/> Please change the metadata type to Roll or Artwork and submit.": "電子決済のための必須メタデータが欠落している資産があります。<NewLine/> メタデータタイプをRollもしくはArtworkに変更後、上信してください。",
            "Attribution cannot be empty. Please enter a valid attribution.": "帰属を空にすることはできません。有効な帰属を入力してください。",
            "If you turn off Custom Apply All Data, your input data is gone and cannot be recovered.": "[カスタム すべてのデータを適用] をオフにすると、入力データが失われ、復元できなくなります。",
            "There is no custom metadata yet.": "カスタム メタデータはまだありません。",
            "To enter metadata, select one of the custom metadata options.": "メタデータを入力するには、カスタム メタデータ オプションのいずれかを選択します。",
            "Please search by role name": "ロール名で検索してください",
            "Deleting the role “{{roleName}}” removes all permissions for users and groups set by that role.": "ロール「{{roleName}}」を削除すると、そのロールによって設定されたユーザーとグループのすべての権限が削除されます。",
            "The corresponding menu is selected in the project first entry screen settings above. If you do not want to display the menu, turn off the above settings.": "対応するメニューは、上記のプロジェクト最初の入力画面の設定で選択されています。メニューを表示したくない場合は、上記の設定をオフにしてください。",
            "Creating access token.": "アクセストークンを作成します。",
            "Sucessfully created access token. Please check from the requested client.": "アクセストークンが正常に作成されました。ご依頼のお客様よりご確認ください。",
            "Failed to create access token. Please try again from the requested client.": "アクセストークンの作成に失敗しました。要求されたクライアントから再試行してください。",
            "Please select files to add": "追加するファイルを選択してください",
            "“{{name}}’ is in use in projects.<0/> If you wish to delete it, please disable the schema in the project you are using.": "「{{name}}」はプロジェクトで使用されています。<0/>削除したい場合は、使用しているプロジェクトのスキーマを無効にしてください。",
            "Select {{resourceType}} through search to put them in your custom content.": "検索で {{resourceType}} を選択し、カスタム コンテンツに追加します。",
            "The selected item is rejected": "選択した項目は拒否されました",
            "The selected item is approved": "選択した項目は承認されました",
            "The private comment is deleted.": "非公開コメントが削除されました。",
            "There is no data": "データが存在しません",
            "The selected item has been requested to be archived.": "選択したアイテムがアーカイブ要求されました。",
            "Please search by name": "名前で検索してください",
            "Are you sure you want to delete that export file?": "このエクスポート ファイルを削除してもよろしいですか?",
            "If you delete a exported metadata, all settings and downloadable files will be deleted.": "メタデータのエクスポートを削除すると、設定ファイルとダウンロード可能ファイルの両方が削除されます。",
            "Contains an overview of all selected assets.<NewLine/> The contents of hidden fields are revealed in the exported file.": "選択したすべての資産の概要が含まれます。<NewLine/> 非表示フィールドの内容は、エクスポートされたファイルに表示されます。",
            "There are no projects selected.": "プロジェクトが選択されていません。",
            "Search for a project.": "プロジェクトを検索してください。",
            "Creation of new Metadata Export {{item}} is completed": "新しいメタデータ エクスポート {{item}} の作成が完了しました",
            "No {{name}} items yet.": "{{name}}のアイテムはまだありません。",
            "The selected items have been requested to be archived.": "選択したアイテムがアーカイブ要求されました。",
            "You can choose a storage class to store your assets.": "資産を保存するストレージ クラスを選択できます。",
            "Please search by content schema name": "コンテンツスキーマ名で検索してください",
            "Please search by DisplayAs or SoundsLike.": "表示する単語または発音に似た単語で検索してください。",
            "A preview setting of '{{name}}' have been requested.": "「{{name}}」のプレビュー設定がリクエストされました。",
            "This file size can be up to {{maxByte}} bytes.": "このファイル サイズは最大 {{maxByte}} バイトになります。",
            "Things to keep in mind when entering words": "単語を入力する際の注意点",
            "Words similar to spoken sounds - Only Korean characters can be entered.": "音声に似た単語 - 韓国語文字のみ入力可能です。",
            "If you want to create a URL, please change the status to Published.": "URLを作成したい場合は、ステータスを公開済みに変更してください。",
            "The changed options is applied when it is ‘ACTIVE’, and if it is ‘INACTIVE’, the options is reset when the pop-up is closed.": "変更したオプションは「ACTIVE」の場合に適用され、「INACTIVE」の場合はポップアップを閉じるとオプションがリセットされます。",
            "Please search by audit log resourceId.": "監査ログの資源IDで検索してください。",
            "Please search by vocabulary book name.": "単語帳名で検索してください。",
            "You can enter English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "英語、数字、スペース、特殊文字 (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?) を入力できます。",
            "Only English, -(Hyphen) can be entered.": "英語、-(ハイフン)のみ入力可能です。",
            "You can enter Korean, English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "韓国語、英語、数字、スペース、特殊文字 (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?) を入力できます。",
            "Only Korean can be entered.": "韓国語のみ入力可能です。",
            "An email will be sent to users with space admin permission.": "スペース管理者権限を持つユーザーに電子メールが送信されます。",
            "No reports have been sent yet.": "まだレポートは送信されていません。",
            "{{action}} completed.": "{{action}}が完了しました。",
            "When you enable automatic archiving, <0>you will be billed immediately for 90 or 180 days</0>, depending on the storage class option you select.": "自動アーカイブを有効にすると、選択したストレージ クラス オプションに応じて、<0>すぐに 90 日または 180 日分の料金が請求されます</0>。",
            "This storage class is billed for <0>180 days</0> immediately after archiving.": "このストレージ クラスは、アーカイブ直後から <0>180 日間</0> 分の料金が請求されます。",
            "Video images cannot be captured.": "ビデオ画像をキャプチャすることはできません。",
            "To capture video images, the original source must contain an <0>mp4 or mov</0> file. <1/> Try capturing from a video or asset that has an mp4 or mov file.": "ビデオ画像をキャプチャするには、元のソースに <0>mp4 または mov</0> ファイルが含まれている必要があります。 <1/> mp4 または mov ファイルを含むビデオまたは資産からキャプチャしてみてください。",
            "Are you sure you want to delete the link??": "リンクを削除してもよろしいですか??",
            "Deleted links cannot be restored.": "削除されたリンクは復元できません。",
            "This recipient will no longer be able to download from this link. Revoked access cannot be restored.": "この受信者はこのリンクからダウンロードできなくなります。取り消したアクセス権は復元できません。",
            "Access has been revoked.": "アクセス権が取り消されました。",
            "Revoke this download link?": "このダウンロードリンクを取り消しますか？",
            "'{{subject}}' shared with {{sharedWith}} will no longer be downloadable.": "{{sharedWith}} に共有した「{{subject}}」はダウンロードできなくなります。",
            "A revoked link cannot be restored. Share again to send a new link.": "取り消したリンクは元に戻せません。新しいリンクは再共有で発行されます。",
            "Download link revoked.": "ダウンロードリンクを取り消しました。",
            "Please add a link.": "リンクを追加してください。",
            "This field must be in URL format.": "このフィールドは URL 形式である必要があります。",
            "Are you sure you want to delete this group?": "このグループを削除してもよろしいですか?",
            "Deleting the {{groupName}} group removes all permissions from users and roles set by that group.": "{{groupName}} グループを削除すると、そのグループによって設定されたユーザーとロールからすべての権限が削除されます。",
            "If the problem persists, <0/> please contact the administrator.": "問題が解決しない場合は、<0/> 管理者に問い合わせてください。",
            "Up to {{limit}} {{referenceType}} can be registered": "最大{{limit}}個の{{referenceType}}を登録できます",
            "Select Category Group": "カテゴリグループを選択してください。",
            "Each menu (e.g. Assets) can be categorized into one category group.": "各メニュー(例: 資産)は1 つのカテゴリグループに分類できます。",
            "Make sure the category group is in use <label>In use</label> status.": "カテゴリグループが使用中<label>使用中</label>状態であることを確認してください。",
            "If you apply a different category group, you can check the items in the <strong>'Uncategorized'</strong> in the category view.": "別のカテゴリグループを適用すると、カテゴリビューの<strong>「未分類」</strong>で項目を確認できます。",
            "There are no assets selected.": "資産が選択されていません。",
            "Please select an item to enter the menu": "メニューに入るには項目を選択してください",
            "Search by category name": "カテゴリ名で検索",
            "There are no menus configured.": "設定されたメニューはありません。",
            "Use the \"Add Menu\" button to add it.": "「メニューを追加」ボタンを使用して追加します。",
            "'{{item}}' has been created.": "「{{item}}」が作成されました。",
            "This menu is set as the first entry screen of the project and cannot be hidden.": "このメニューはプロジェクトの最初のエントリ画面として設定されており、非表示にすることはできません。",
            "Please enter the menu name.": "メニュー名を入力してください。",
            "Menu name can be up to {{maxByte}} bytes.": "メニュー名は最大 {{maxByte}} バイトまで可能です。",
            "Please search by name.": "名前で検索してください。",
            "Deletion of vocabulary book {{item}} has been completed.": "語彙集 {{item}} の削除が完了しました。",
            "Deletion of vocabulary book {{item}} and {{count}} others has been completed.": "語彙集 {{item}} とその他 {{count}} の削除が完了しました。",
            "Content schema '{{name}}' has been created.": "コンテンツ スキーマ '{{name}}' が作成されました。",
            "Content schema '{{name}}' has been updated.": "コンテンツ スキーマ '{{name}}' が更新されました。",
            "Enter last name": "姓を入力してください。",
            "Enter first name": "名を入力してください。",
            "It's not possible to proceed as the archived menu isn't being used.": "アーカイブメニューが使用されていないため、移動することができません。",
            "Asset lock has been disabled.": "資産ロックが解除されました。",
            "Asset lock has been enabled.": "資産ロックが有効になりました。",
            "Lock this asset": "この資産をロックします",
            "Select a category from the category group.": "カテゴリグループからカテゴリを選択します。",
            "Sharing Period and Number of Downloads have expired. You can reset it.": "共有期間とダウンロード回数の期限が切れました。リセットすることができます。",
            "Number of Downloads has expired. You can reset it.": "ダウンロード回数の期限が切れました。リセットすることができます。",
            "Sharing Period has expired. You can reset it.": "共有期間が終了しました。リセットすることができます。",
            "There are no shared users.": "共有ユーザーはいません。",
            "Processing download request...": "ダウンロードのリクエスト中…",
            "There are no jobs yet.": "まだ仕事はありません。",
            "If you delete “{{name}}”, this property will be removed from all assets using this content schema, and it cannot be recovered.": "{{name}}を削除すると、このコンテンツスキーマを使用しているすべての資産から該当プロパティが削除され、復元できなくなります。",
            "Drag and drop your file here, or upload a file from your PC or cloud.": "ファイルをここにドラッグ＆ドロップするか、PCまたはクラウドストレージからアップロードしてください。",
            "Go to the start page and select a project you have access to.": "開始ページに移動し、アクセス権のあるプロジェクトを選択してください。",
            "If you don’t have access to any projects, please contact your administrator.": "アクセス可能なプロジェクトがない場合は、管理者にお問い合わせください。",
            "Please use the button below to go to the start page.": "以下のボタンから開始ページへ移動してください。",
            "There is no page available for this comment.": "このコメントに対応するページが存在しません。",
            "You do not have permission to access the page.": "このページにアクセスする権限がありません。",
            "The custom metadata used in the asset is disabled.": "資産で使用されているカスタムメタデータは無効になっています。",
            "Selecting Use will make your project assets visible in the full asset search results. This may take some time to apply, depending on the amount of data.": "「使用」を選択すると、プロジェクトアセットがフルアセット検索結果に表示されます。データ量によっては、適用に時間がかかる場合があります。",
            "Data accessed through expedited retrieval for all objects except the largest archive objects (250MB or larger) is typically available within 1-5 minutes.": "最大のアーカイブオブジェクト（250MB以上）を除くすべてのオブジェクトについて、迅速なリトリーバルでアクセスされたデータは通常1〜5分以内に利用可能になります。",
            "When restoring, Deep Archive storage will be charged for a minimum of 180 days, and other storage classes will be charged for a minimum of 90 days.": "復元時には、Deep Archiveストレージは最低180日分、その他のストレージクラスは最低90日分の料金が請求されます。",
            "You will be charged when restoring an asset.": "資産を復元する際に料金が請求されます。",
            "AI analysis identifies people, actions, and risk factors in videos and can automatically generate subtitles and text.": "AI分析は、動画内の人物、動作、リスク要因を識別し、自動的に字幕やテキストを生成できます。",
            "Please save or cancel your changes before adding a new task.": "新しいタスクを追加する前に、変更内容を保存またはキャンセルしてください。",
            "Please set the Input Path.": "入力パスを設定してください。",
            "Are you sure you want to delete the task?": "このタスクを削除してもよろしいですか？",
            "Deleting a task will cause all entered information to disappear and cannot be recovered.": "タスクを削除すると、入力されたすべての情報が消去され、元に戻すことはできません。",
            "Please enter your email address and press Enter.": "メールアドレスを入力してEnterキーを押してください。",
            "Share request to {{userName}}": "{{userName}}への共有リクエスト",
            "Changed share options to {{permission}} permission": "共有オプションが{{permission}}権限に変更",
            "Changed share options to {{permission}} permission until {{expireDate}}": "共有オプションが{{expireDate}}まで{{permission}} 権限に変更",
            "Changed share options to {{permission}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "共有オプションが{{expireDate}}まで{{permission}} 権限に変更され、最大 {{maxDownloads}} 回のダウンロードが可能に変更",
            "Changed share options to {{permission}} permission with max {{maxDownloads}} downloads": "共有オプションが {{permission}}権限に変更され、最大 {{maxDownloads}}回のダウンロードが可能に変更",
            "Sharing with {{user}} was updated": "{{user}}との共有が更新",
            "Sharing with {{user}} was removed": "{{user}}との共有が解除",
            "Shared with {{user}}": "{{user}}と共有",
            "Shared with {{grantees}} permission": "{{grantees}} 権限で共有済み",
            "Shared with {{grantees}} permission until {{expireDate}}": "{{expireDate}}まで{{grantees}}権限で共有",
            "Shared with {{grantees}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "{{expireDate}}まで{{grantees}}権限で共有され、最大{{maxDownloads}}回のダウンロードが可能な設定で共有",
            "Shared with {{grantees}} permission with max {{maxDownloads}} downloads": "{{grantees}} 権限で共有され、最大 {{maxDownloads}} 回のダウンロードが可能な設定で共有",
            "Shared link to {{names}}": "{{names}} への共有リンク",
            "It's not possible to proceed as the {{menuName}} menu isn't being used.": "{{menuName}}メニューが使用されていないため、移動することができません。",
            "No users have been registered yet.": "まだ登録されているユーザーがいません。",
            "Click the User invitation button at the top to add a user.": "上部の「ユーザー招待」ボタンをクリックして、ユーザーを追加してください。",
            "Please search by name or email": "名前またはメールアドレスで検索してください。",
            "Search by project name": "プロジェクト名で検索",
            "Search by bucket name": "バケット名で検索する",
            "\"{{name}}\" will be deleted forever and you won't be abled to restore it.": "「{{name}}」は完全に削除され、復元することはできません。",
            "\"{{name}}\" and {{count}} others will be deleted forever and you won't be abled to restore it.": "「{{name}}」とその他{{count}}件は完全に削除され、復元することはできません。",
            "The service is located in {{region}}.": "サービスは {{region}} にあります。",
            "Please select a region.": "リージョンを選択してください。",
            "Please copy the JSON below to create an IAM Permission.": "以下のJSONをコピーして、IAM Permission を作成してください。",
            "Please apply the role trust relationship by replacing {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} in the JSON below with the account ID you want to use.": "以下のJSONで{REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID}を使用するアカウントIDに置き換えて、Roleの信頼関係に適用してください。",
            "Please copy the Role ARN and paste it into the external account input field for <0>AWS account connection</0>.": "Role ARNをコピーし、**<0>AWSアカウント連携</0>**用の外部アカウント入力欄に貼り付けてください。",
            "Please enter the AWS Role ARN.": "AWS Role ARNを入力してください。",
            "Please search by user name.": "ユーザー名で検索してください。",
            "Please search by group name.": "グループ名で検索してください。",
            "Please select a new owner": "新しい所有者を選択してください",
            "Changing the owner may result in the existing owner losing permissions and some features being restricted.": "所有者を変更すると、既存の所有者の権限が失われ、一部の機能が制限される可能性があります。",
            "Are you sure you want to delete this?": "本当に削除しますか？",
            "Please click Add roles button to grant roles to this user.": "このユーザーにロールを付与するには「役割の追加」ボタンをクリックしてください。",
            "No group is granted": "付与されているグループはありません。",
            "There are no groups yet.": "まだグループがありません。",
            "Please click Manage Access button to add group to this project.": "このプロジェクトにグループを追加するには「アクセスの管理」ボタンをクリックしてください。",
            "There are no users yet.": "まだユザーがありません。",
            "Please click Manage Access button to add user to this project.": "このプロジェクトにユザーを追加するには「アクセスの管理」ボタンをクリックしてください。",
            "You can create up to {{n}} tags.": "{{n}}個までタグを作成できます。",
            "Update owner to {{name}}": "{{name}}に所有者変更",
            "URL not found": "URLが見つかりません",
            "The URL has been deleted or the menu does not exist.": "URL が削除されたか、メニューが存在しません。",
            "You must enter your credentials to use the engine.": "エンジンを使用するには資格情報を入力する必要があります。",
            "When uploading via pop-up, empty folders are excluded.<NewLine/> To upload empty folders as well, please drag the folders directly into the asset list.": "ポップアップ経由でアップロードする場合、空のフォルダーは除外されます。<NewLine/> 空のフォルダもアップロードするには、フォルダをアセット リストに直接ドラッグしてください。",
            "If the capacity is more than {{limit}}, the print file will be automatically extracted and automatic captions will be generated.": "容量が{{limit}}を超える場合、印刷ファイルが自動的に抽出され、自動キャプションが生成されます。",
            "It is only available at the all project level.": "全体のプロジェクト単位でのみ確認可能です。",
            "There is no data available.": "データがありません。",
            "The maximum upload size is {{size}}.": "最大規模は{{size}}です。",
            "Please select a repository.": "リポジトリを選択してください。",
            "There is no file.": "ファイルがありません。",
            "mentioned you in a comment": "がコメントであなたを言及しました",
            "replied to your comment": "があなたのコメントに返信しました",
            "invited you to a thread": "がプライベートコメントにあなたを招待しました",
            "There are no notifications yet.": "まだ通知はありません。",
            "Notifications will be deleted after 7 days.": "通知は7日後に削除されます",
            "The item does not exist": "アイテムが存在していません。",
            "Analysis completed, but there are no results for {{name}}.": "分析は完了しましたが、{{name}} の結果はありません。",
            "An error occurred during analysis and the operation could not be completed.": "分析中にエラーが発生し、操作を完了できませんでした。",
            "Analyzing now uses the proxy video.": "今すぐ分析するとプロキシ映像で処理されます。",
            "The proxy video is still being created, so analyzing now uses the original and takes longer.": "プロキシ映像を作成中のため、今すぐ分析するとオリジナルで処理され、より時間がかかります。",
            "The proxy video could not be created, so it is analyzed with the original.": "プロキシ映像を作成できなかったため、オリジナルで分析されます。",
            "There is no proxy video, so it is analyzed with the original.": "プロキシ映像がないため、オリジナルで分析されます。",
            "Proxy videos are only created for assets registered after auto generation is turned on.": "プロキシ映像は、自動生成をオンにした後に登録された映像にのみ作成されます。",
            "There was a problem for a moment.": "ちょっと問題がありました。",
            "There was a problem processing your request. Please try again later.": "リクエストの処理中に問題が発生しました。しばらくしてからもう一度お試しください。",
            "AI usage quota has been exceeded.": "AI使用量の上限を超えました。",
            "You have reached the AI usage limit. Please contact your administrator to increase the quota.": "AI使用量の上限に達しました。利用枠の増加が必要な場合は管理者にお問い合わせください。",
            "No values were extracted.": "抽出された値がありません。",
            "The analysis finished, but no values matching the schema fields were returned. Retrying may produce the same result.": "分析は完了しましたが、スキーマ項目に一致する値を取得できませんでした。再試行しても同じ結果になる場合があります。",
            "I recommend the video highlights.": "ハイライト動画をおすすめします。",
            "Enter a prompt for AI": "AIのプロンプトを入力してください",
            "What can I help with?": "何をお手伝いすればいいでしょうか?",
            "Please enter the prompt.": "プロンプトを入力してください。",
            "Preset status has been updated.": "プリセットの状態が更新されました。",
            "Deletion of preset {{item}} has been completed.": "プリセット「{{item}}」の削除が完了しました。",
            "Preset has been duplicated successfully.": "プリセットが正常に複製されました。",
            "Failed to send the prompt preset.": "プロンプトプリセットの送信に失敗しました。",
            "'{{name}}' will be deleted forever and you won't be able to restore it.": "「{{name}}」は完全に削除され、元に戻すことはできません。",
            "No preset items yet.": "まだプリセット項目がありません。",
            "Create it using the “Create” button.": "「生成」ボタンを使用して追加してください。",
            "To use the AI-Workspace, the original source must contain an <0>mp4 or mov</0> file.": "AI ワークスペースを使用するには、元のソースに <0>mp4 または mov</0> ファイルが含まれている必要があります。",
            "Name is required.": "名前は必須です。",
            "Prompt is required.": "プロンプトは必須です。",
            "The selected tags have been saved to the metadata.": "おすすめのタグの中から、必要な項目を選択してください。",
            "Please select the required items from the recommended tags.": "選択されたタグはメタデータに保存されました。",
            "Please select a template.": "テンプレートを選択してください。",
            "Your session has expired. Please start a new conversation.": "セッションが終了しました。新しい会話を開始してください。",
            "Generating results": "結果を生成しています",
            "There is no description yet. Bring an AI description or enter it directly.": "まだ説明がありません。AIの説明を持参するか、直接入力してください。",
            "Please write a description.": "説明を書いてください。",
            "To capture video images, it must be an <0>mp4 or mov</0> file. <1/> Try capturing from mp4 or mov assets.": "ビデオ画像をキャプチャするには、<0>mp4 または mov</0> ファイルである必要があります。 <1/> mp4 または mov アセットでキャプチャしてみてください。",
            "The video cannot be edited.": "ビデオを編集できません。",
            "To edit a video, it must be an <0>mp4 or mov</0> file. <1/> Edit in mp4 or mov assets.": "ビデオを編集するには、<0>mp4 または mov</0> ファイルである必要があります。 <1/> mp4 または mov アセットで編集してください。",
            "To edit a video, the original source must contain an <0>mp4 or mov</0> file. <1/> Edit videos or assets that contain mp4 or mov files.": "ビデオを編集するには、元のソースに <0>mp4 または mov</0> ファイルが含まれている必要があります。 <1/> mp4 または mov ファイルを含む動画またはアセットで編集してください。",
            "You can play it directly on mobile with the QR code.": "モバイルでQRコードから直接再生できます。",
            "Analyze videos with AI": "動画をAIで分析して",
            "to easily manage your videos.": "ビデオを簡単に管理しましょう。",
            "Video AI analysis can extract labels for specific people, objects, patterns, and actions in videos, and manage inappropriate or dangerous content.": "動画AI分析は、動画内の特定の人物、物体、パターン、行動などをラベルとして抽出でき、不適切または危険なコンテンツを管理できます。",
            "Additionally, it can automatically convert video audio to text and automatically generate captions to easily manage videos.": "また、自動的に動画の音声をテキストに変換でき、字幕を自動生成してビデオを簡単に管理できます。",
            "{{resourceName}} '{{name}}' has been added.": "{{resourceName}}「{{name}}」を追加しました。",
            "{{resourceName}} '{{name}}' and {{count}} others have been added.": "{{resourceName}}「{{name}}」ほか{{count}}件を追加しました。",
            "This field can be up to {{maxLength}} characters.": "このフィールドは最大 {{maxLength}} 字まで可能です。",
            "The description can be up to {{maxLength}} characters long.": "説明は最大 {{maxLength}} 字まで可能です。",
            "The comment field can be up to {{maxLength}} characters long.": "コメントは最大 {{maxLength}} 字まで可能です。",
            "Menu name can be up to {{maxLength}} bytes.": "メニュー名は最大 {{maxLength}} バイトまで可能です。",
            "The description can be up to {{maxLength}} characters": "説明は最大 {{maxLength}} 字まで可能です。",
            "Request to create download link successfully": "ダウンロードリンクを無事共有しました。",
            "Auto set by {{name}}": "{{name}}によって自動設定されました。",
            "request completed": "リクエストが完了しました",
            "Each menu (e.g. Asset) can categorize items by setting one category group.": "各メニュー（例：アセット）は、1つのカテゴリーグループを設定してアイテムを分類できます。",
            "Make sure the category group is currently <InUse>In Use</InUse> for the target menu (e.g. Asset).": "対象のメニュー（例：アセット）で現在<InUse>使用中</InUse>のカテゴリーグループであることを確認してください。",
            "If you apply a different category group, those items can be found under '<NotClassified>Categories Not Classified into Assets</NotClassified>' in the category view.": "別のカテゴリーグループを適用する場合、該当のアイテムはカテゴリービューの「<NotClassified>アセットに分類されていないカテゴリー</NotClassified>」で確認できます。",
            "The name field be up to {{title}} characters long.": "名前のフィールドは最大 {{title}}字 です。",
            "The selected {{type}} has been saved to the metadata.": "選択された{{type}}はメタデータに保存されました。",
            "No Collection items yet.": "コレクションアイテムはまだありません。",
            "Add it using the “Add Collection” button.": "「コレクション追加」ボタンを使用して追加してください。",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍ改行により分割される",
            "Every months on": "毎月",
            "This is not a valid URL pattern.": "URLパターンが有効ではありません。",
            "If you archive the asset, you will be charged <0>the 90-day</0> archive amount immediately.": "資産をアーカイブすると、<0>90日間</0>のアーカイブ料金がすぐに請求されます。",
            "Are you sure you want to reject sharing request for <0>{{name}}</0>?": "<0>{{name}}</0>の共有リクエストを拒否してもよろしいですか？",
            "Please use a different file after checking the 'Supported File Formats' of the file upload rules.": "ファイルアップロードルールの「サポートされているファイル形式」を確認した後、別のファイルを使用してください。",
            "If you archive the asset, you will be charged the <0>90-day</0> archive<1/> amount immediately.<1/>Are you sure you want to archive?": "資産をアーカイブすると、<0>90日間</0>のアーカイブ<1/>料金がすぐに請求されます。<1/>アーカイブしてもよろしいですか？",
            "Error deleting asset '{{name}}'. {{line}} Please refresh the page and try again.": "資産'{{name}}'の削除中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Asset '{{name}}' has been deleted.": "資産'{{name}}'が削除されました。",
            "Error deleting asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "資産'{{name}}'他{{count}}件の削除中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Asset '{{name}}' and {{count}} other assets have been deleted.": "資産'{{name}}'他{{count}}件の資産が削除されました。",
            "Error archiving asset '{{name}}'. {{line}} Please refresh the page and try again.": "資産'{{name}}'のアーカイブ中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Asset '{{name}}' has been restored.": "資産'{{name}}'が復元されました。",
            "Error restoring asset '{{name}}'. {{line}} Please refresh the page and try again.": "資産'{{name}}'の復元中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Event trigger '{{name}}' has been added.": "イベントトリガー'{{name}}'が追加されました。",
            "You don't have access. {{line}} Please contact the manager.": "アクセス権限がありません。{{line}} 管理者にお問い合わせください。",
            "Error adding asset '{{name}}'. {{line}} Please refresh the page and try again.": "資産'{{name}}'の追加中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error adding asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "資産'{{name}}'他{{count}}件の追加中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Asset '{{name}}' has been added.": "資産'{{name}}'が追加されました。",
            "Asset '{{name}}' and {{count}} other assets have been added.": "資産'{{name}}'他{{count}}件の資産が追加されました。",
            "The access of asset '{{name}}' has been updated to private.": "資産'{{name}}'のアクセス権限が非公開に更新されました。",
            "The access of asset '{{name}}' has been updated to public.": "資産'{{name}}'のアクセス権限が公開に更新されました。",
            "Error updating asset '{{name}}' with access to private. {{line}} Please refresh the page and try again.": "資産'{{name}}'のアクセス権限を非公開に更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating asset '{{name}}' with access to public. {{line}} Please refresh the page and try again.": "資産'{{name}}'のアクセス権限を公開に更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Event trigger '{{name}}' has been deleted.": "イベントトリガー'{{name}}'が削除されました。",
            "Error deleting event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "イベントトリガー'{{name}}'の削除中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "The name has been updated.": "名前が更新されました。",
            "Attributions has been updated.": "属性が更新されました。",
            "Tags has been updated.": "タグが更新されました。",
            "Error updating the name. {{line}} Please refresh the page and try again.": "名前の更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating the description. {{line}} Please refresh the page and try again.": "説明の更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating attributions. {{line}} Please refresh the page and try again.": "属性の更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating Tags. {{line}} Please refresh the page and try again.": "タグの更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating status to active. {{line}} Please refresh the page and try again.": "ステータスを有効に更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating status to inactive. {{line}} Please refresh the page and try again.": "ステータスを無効に更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating conditions. {{line}} Please refresh the page and try again.": "条件の更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error updating Actions. {{line}} Please refresh the page and try again.": "アクションの更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Status updated to active.": "ステータスが有効に更新されました。",
            "Status updated to inactive.": "ステータスが無効に更新されました。",
            "Conditions has been updated.": "条件が更新されました。",
            "Actions has been updated.": "アクションが更新されました。",
            "You don't have permission to access this item.": "この項目にアクセスする権限がありません。",
            "Page not found. {{line}} The page you are looking for doesn't exist or an other error occurred.": "ページが見つかりません。{{line}} お探しのページは存在しないか、別のエラーが発生しました。",
            "That's an error. {{line}} Please try again later.": "エラーが発生しました。{{line}} 後でもう一度お試しください。",
            "Your request resulted in an error. {{line}} please try again.": "リクエストによりエラーが発生しました。{{line}} もう一度お試しください。",
            "Error requesting download of asset '{{name}}'. {{line}} Please refresh the page and try again.": "資産'{{name}}'のダウンロードリクエスト中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "The file has been updated.": "ファイルが更新されました。",
            "Error updating the file. {{line}} Please refresh the page and try again.": "ファイルの更新中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "Error adding event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "イベントトリガー'{{name}}'の追加中にエラーが発生しました。{{line}} ページを更新して再度お試しください。",
            "If you navigate away from this page,<1/>your changes cannot be saved.": "このページから移動すると、<1/>変更内容を保存できません。",
            "Asset '{{name}}' has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "資産'{{name}}'が'{{fromFolder}}'からフォルダ'{{toFolder}}'に移動されました。",
            "Asset '{{name}}' and {{count}} other has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "資産'{{name}}'他{{count}}件が'{{fromFolder}}'からフォルダ'{{toFolder}}'に移動されました。",
            "This operation was not entirely successful.": "この操作は完全には成功しませんでした。",
            "Asset '{{name}}' has been requested.": "資産'{{name}}'がリクエストされました。",
            "Asset '{{name}}' and {{count}} other assets have been requested.": "資産'{{name}}'他{{count}}件の資産がリクエストされました。",
            "Are you sure you want to turn off applying custom metadata?": "カスタムメタデータの適用をオフにしてもよろしいですか？",
            "Remove user from role?": "ユーザーを役割から削除しますか？",
            "If you remove the user {{userName}}, assigned permission will be removed.": "ユーザー{{userName}}を削除すると、割り当てられた権限が削除されます。",
            "Remove group from role?": "グループを役割から削除しますか？",
            "If you remove the group {{groupName}}, assigned permission will be removed.": "グループ{{groupName}}を削除すると、割り当てられた権限が削除されます。",
            "invited you to a private comment": "がプライベートコメントにあなたを招待しました",
            "No content schema items yet.": "まだコンテンツスキーマ項目がありません。",
            "Category groups allow you to classify and manage items conveniently.": "カテゴリグループを使用すると、項目を分類して便利に管理できます。",
            "Assets can be created successfully only when no values are empty. If not used, please delete.": "空の値がない場合にのみ資産を正常に作成できます。使用しない場合は削除してください。",
            "You will be notified by email <0/> whether the asset has been shared.": "資産が共有されたかどうかを<0/>メールでお知らせします。",
            "The description has been updated.": "説明が更新されました。",
            "Up to 50 {{referenceType}}s can be registered": "最大50件の{{referenceType}}を登録できます",
            "The status has been changed.": "ステータスが変更されました。",
            "Are you sure you want to delete this workflow?": "このワークフローを削除しますか？",
            "If you delete this workflow, it cannot be recovered.": "ワークフローを削除すると復元できません。",
            "An event that triggers the workflow to run.": "ワークフローの実行をトリガーするイベントです。",
            "Branches the workflow based on conditions.": "条件に基づいてワークフローを分岐します。",
            "Proceeds to the next step when the task is completed.": "タスクが完了すると次のステップに進みます。",
            "When the created asset's media type is {{values}}": "作成されたアセットのメディアタイプが{{values}}のとき",
            "When the file extension is {{values}}": "ファイル拡張子が{{values}}のとき",
            "Branch files based on file extension": "ファイルを拡張子基準で分岐",
            "Branch files based on file size": "ファイルをサイズ基準で分岐",
            "Branch files based on media type": "アセットをメディアタイプ基準で分岐",
            "Branch files based on asset size": "アセットをサイズ基準で分岐",
            "When an object is created in the S3 bucket": "S3バケットにオブジェクトが作成されたとき",
            "When an asset is created in the current project": "現在のプロジェクトでアセットが作成されたとき",
            "Submit transcode task to pipeline": "パイプラインにトランスコードタスクを送信します",
            "Create an asset from a file (waits until preview extraction completes)": "ファイルからアセットを作成します（プレビュー抽出完了まで待機）",
            "Attach metadata to asset": "アセットにメタデータを添付します",
            "System preset-based single type job": "システムプリセットベースのシングルタイプジョブ",
            "Archive to the specified storage class": "指定したストレージクラスにアーカイブします",
            "Publish a video to SNS": "動画をSNSに公開します",
            "This trigger has no additional conditions.": "このトリガーには追加条件がありません。",
            "Exactly one of {{keys}} is required": "{{keys}} のうち正確に1つが必要です",
            "One of {{keys}} is required": "{{keys}} のうち1つが必要です",
            "{{keys}} cannot be used together": "{{keys}} は同時に使用できません",
            "Use AI workspace metadata.": "AIワークスペースのメタデータを使用します。",
            "Enter manually.": "手動で入力します。",
            "Data updated at {{timestamp}} ({{offset}})": "データ更新日時 : {{timestamp}} ({{offset}}) 基準",
            "Based on {{start}} ~ {{end}} ({{offset}})": "{{start}} ~ {{end}} ({{offset}}) 基準",
            "{{month}} settlement confirmed": "{{month}} 精算確定",
            "{{percent}}% in use": "{{percent}}% 使用中",
            "Concurrent session limit {{max}}": "最大同時セッション上限 {{max}}",
            "Monthly base fee {{fee}}": "月額基本料 {{fee}}",
            "Monthly base fee none": "月額基本料なし",
            "Base fee : {{fee}}": "月額基本料 : {{fee}}",
            "Base fee : none": "月額基本料 : なし",
            "Usage fee : {{minutes}} min × {{rate}}": "従量料金 : {{minutes}}分 × {{rate}}",
            "Usage fee : {{minutes}} min": "従量料金 : {{minutes}}分",
            "{{days}} days": "{{days}}日",
            "Failed to load billing information.": "課金情報の読み込みに失敗しました。",
            "There is no active subscription for this tenant.": "このテナントには有効なサブスクリプションがありません。",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\nㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparate by newlines": "ㆍシングルIP : xxx.xxx.xxx.xxx\nㆍIP範囲 : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍ改行で区切る",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍ改行で区切る",
            "Clicking apply replaces the matching field of the custom metadata below the video with the extracted value.": "適用をクリックすると、動画下部のカスタムメタデータの一致するフィールドが抽出値に置き換えられます。",
            "This segment has no duration, so it cannot be added.": "再生区間がないため追加できません。",
            "Replaces the current metadata with the selected preset schema's metadata and saves it. Changes cannot be undone.": "現在のメタデータを選択したプリセットスキーマのメタデータに置き換えて保存します。変更した内容は元に戻せません。",
            "The current metadata is replaced with the metadata from the selected preset schema. You can revert to the previous state until the metadata is saved.": "現在のメタデータが選択したプリセットスキーマのメタデータに置き換えられます。メタデータを保存するまでは以前の状態に戻すことができます。",
            "Replaces the current metadata with the selected preset schema's metadata. You cannot save if required fields are empty. Enter the required values and then save.": "現在のメタデータを選択したプリセットスキーマのメタデータに置き換えます。必須項目が入力されていない場合はメタデータを保存できません。必須値を入力してから保存してください。",
            "Saving deletes the existing custom metadata and replaces it with the AI-extracted metadata. Changes cannot be undone. Do you want to continue?": "保存すると既存のカスタムメタデータが削除され、AIが抽出したメタデータに変更されます。変更した内容は元に戻せません。続けて保存しますか？",
            "Saving deletes the existing custom metadata and replaces it with the current settings. Changes cannot be undone. Do you want to continue?": "保存すると既存のカスタムメタデータが削除され、現在設定した情報に変更されます。変更した内容は元に戻せません。続けて保存しますか？",
            "Select the items to save as custom metadata from the extracted values. You can edit the values before saving.": "抽出された値の中からカスタムメタデータに保存する項目を選択してください。保存前に値を編集できます。",
            "The metadata has been saved.": "メタデータが保存されました。",
            "This asset uses the <0>'{{current}}'</0> schema, which differs from the preset schema({{preset}}). Field-level replacement is not available; replacing the schema applies all extracted values and clears the existing input data.": "このアセットには <0>'{{current}}'</0> スキーマが適用されており、プリセットスキーマ({{preset}}) と異なります。フィールド単位の置き換えはできず、スキーマを置き換えると抽出値がすべて適用され、既存の入力データは消去されます。",
            "Setting the preset schema({{preset}}) applies all extracted values.": "プリセットスキーマ({{preset}})に設定すると、抽出値がすべて適用されます。",
            "Set the preset schema to show it here.": "プリセットスキーマに設定すると、ここに表示されます。",
            "Do you want to unpublish the public URL?": "公開URLを解除しますか？",
            "Due to CDN cache, it may take up to a few minutes to actually block access.": "CDNキャッシュにより、実際に遮断されるまで最大数分かかる場合があります。",
            "Each URL stays the same even if you update the file.": "ファイルを更新しても各URLは同一に維持されます。",
            "Failed to copy the URL.": "URLのコピーに失敗しました。",
            "Failed to open the URL.": "URLを開くのに失敗しました。",
            "Failed to publish. Please try again later.": "公開に失敗しました。しばらくしてからもう一度お試しください。",
            "Failed to publish. Unpublish and try publishing again.": "公開に失敗しました。公開解除後、再度公開してください。",
            "Failed to unpublish. Please try again later.": "公開解除に失敗しました。しばらくしてからもう一度お試しください。",
            "Publishing the public URL has been requested.": "公開URLの公開をリクエストしました。",
            "Publishing {{count}} captions has been requested.": "字幕{{count}}件の公開をリクエストしました。",
            "Publishing {{count}} images has been requested.": "画像{{count}}件の公開をリクエストしました。",
            "The public URL has been copied.": "公開URLがコピーされました。",
            "The public URL has been unpublished.": "公開URLの公開が解除されました。",
            "The public URL of <0>{{target}}</0> will no longer be accessible.": "<0>{{target}}</0>の公開URLにこれ以上アクセスできなくなります。",
            "There is no published asset.": "公開中の資産がありません。",
            "This asset is published via CDN. The issued URL stays the same even if you update the file.": "この資産をCDNを通じて公開します。発行されたURLはファイルを更新しても同一に維持されます。",
            "To share privately with specific users, use <0>Actions → Share link</0>.": "特定のユーザーに非公開で一時共有するには<0>アクション → リンク</0>共有をご利用ください。",
            "Failed to load the public URL list.": "公開URLリストの読み込みに失敗しました。",
            "You do not have permission to publish this asset.": "この資産を公開する権限がありません。",
            "{{count}} captions have been unpublished.": "字幕{{count}}件の公開が解除されました。",
            "{{count}} images have been unpublished.": "画像{{count}}件の公開が解除されました。",
            "Invalid pattern.": "形式が正しくありません。",
            "This field should be a number.": "このフィールドは数字である必要があります。",
            "This field can be from {{min}} characters.": "このフィールドは {{min}} 字から入力できます。",
            "This field can be up to {{max}}.": "このフィールドは最大 {{max}} まで入力できます。",
            "This field can be at least {{min}}.": "このフィールドは最小 {{min}} 以上である必要があります。",
            "Duplicate value.": "重複した値です。",
            "Already exists. Try something else.": "すでに存在します。別の値を使用してください。",
            "If you detach <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to detach <0>{{name}}</0>?": "<0>{{name}}</0>を切り離すと、元に戻すことはできません。<1/>本当に<0>{{name}}</0>を切り離しますか？",
            "The asset has <0>{{count}}</0> elements attached.<1/>If the asset is detached, the elements are also detached.": "このアセットには<0>{{count}}</0>個の要素が紐づいています。<1/>アセットを切り離すと、要素も一緒に切り離されます。",
            "Remove connected MediaLive input.": "接続された MediaLive 入力を削除します。",
            "<0>{{name}}</0> is in use.<1/> If you delete this template, you won’t be able to revert this.<1/> Are you sure you want to delete?": "<0>{{name}}</0>は使用中です。<1/> このテンプレートを削除すると、元に戻すことはできません。<1/> 本当に削除しますか？",
            "Empty values must be filled in when actually used.": "実際に使用する場合、空の値は必ず入力する必要があります。",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{count}}</0> other than <0>{{name}}</0>?": "<0>{{name}}</0>以外に<0>{{count}}</0>件を削除すると、元に戻すことはできません。<1/>本当に<0>{{name}}</0>以外に<0>{{count}}</0>件を削除しますか？",
            "If you remove all shares on <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{name}}</0>?": "<0>{{name}}</0>の共有をすべて解除すると、元に戻すことはできません。<1/>本当に<0>{{name}}</0>の共有をすべて解除しますか？",
            "If you remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>?": "<0>{{name}}</0>以外に<0>{{count}}</0>件の共有をすべて解除すると、元に戻すことはできません。<1/>本当に<0>{{name}}</0>以外に<0>{{count}}</0>件の共有をすべて解除しますか？",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "<0>{{name}}</0>を削除すると、一覧から消えます。<1/>他のユーザーは引き続きアクセスできます。<1/>本当に項目を削除しますか？",
            "If you remove <0>{{count}}</0> other than <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "<0>{{name}}</0>以外に<0>{{count}}</0>件を削除すると、一覧から消えます。<1/>他のユーザーは引き続きアクセスできます。<1/>本当に項目を削除しますか？",
            "Share request completed": "共有リクエストが完了しました。",
            "The selected item is restored": "選択した項目が復元されました。",
            "Error occurs!": "エラーが発生しました。",
            "Create Completed.": "作成が完了しました。",
            "Overlap other processing": "他の処理と重複しています。",
            "Users and teams added.": "ユーザーとチームが追加されました。",
            "Please enter the subject.": "件名を入力してください。",
            "Lineups still exist on date": "その日付にラインナップが残っています。",
            "Approval completed.": "承認が完了しました。",
            "Rejection completed.": "却下が完了しました。",
            "The Shared with list is Changed": "共有先リストが変更されました。",
            "The selected item is Approved": "選択した項目が承認されました。",
            "The selected item is Rejected": "選択した項目が却下されました。",
            "The selected item is Deleted": "選択した項目が削除されました。",
            "Select {{resourceType}} through search to put them in your content.": "検索を通じて {{resourceType}} を選択し、コンテンツに追加します。",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "表示する単語 - 英語、数字、スペース、特殊文字（~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?）を入力できます。",
            "Words similar to spoken sounds - Only English, -(Hyphen) can be entered.": "音声に似た単語（英語、-（ハイフン））のみ入力できます。",
            "Words to display - You can enter Korean, English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "表示する単語 - 韓国語、英語、数字、スペース、特殊文字(~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?)を入力してください。",
            "Deletion of vocabulary phrase {{item}} has been completed.": "単語 {{item}} の削除が完了しました。",
            "Deletion of vocabulary phrase {{item}} and {{count}} others has been completed.": "単語 {{item}} とその他 {{count}} の削除が完了しました。",
            "This page isn't working. {{line}} Please contact the manager.": "このページは動作していません。{{line}} 管理者にお問い合わせください。",
            "Failed to load analysis results.": "分析結果の読み込みに失敗しました。",
            "There are no video segments to edit for the selected labels.": "選択したラベルに編集できる区間がありません。",
            "Imported {{segmentCount}} segments of {{labels}} selected in {{engine}} as edit segments.": "<2>{{engine}}</2>で選択した<1>{{labels}}</1>の登場区間<0>{{segmentCount}}件</0>を編集区間として取り込みました。",
            "You can select up to {{max}} labels.": "最大{{max}}件まで選択できます。",
            "All {{max}} timestamps selected. Deselect one to add another.": "タイムスタンプを{{max}}件すべて選択しました。追加するには選択を解除してください。",
            "AI analysis uses the proxy video.": "AI分析にプロキシ映像を使用します。",
            "Creating a proxy video. Analyzing now uses the original and takes longer.": "プロキシ映像を作成しています。今すぐ分析すると原本で処理され、より時間がかかります。",
            "The proxy video could not be created. AI analysis will use the original.": "プロキシ映像を作成できませんでした。AI分析は原本で処理されます。",
            "The proxy video is used by AI Analysis, AI Workspace, and the Adobe plugin.": "プロキシ映像はAI分析、AIワークスペース、Adobeプラグインで使われます。",
            "Without it, AI Analysis runs on the original and can be slow or fail on size limits, and the Adobe plugin downloads the original file. This choice applies to assets created from now on.": "ない場合、AI分析はオリジナルで処理されるため遅くなったり容量制限で失敗することがあり、Adobeプラグインはオリジナルをそのままダウンロードします。この選択は今後作成されるアセットから適用されます。",
            "No proxy video. Proxy auto-generation applies only to videos registered after it was selected.": "プロキシ映像がありません。プロキシ自動生成はオンにした後に登録された映像にのみ適用されます。",
            "Proxy video - a small copy used for AI analysis and preview.": "プロキシ映像 — AI分析・プレビューに使う軽量コピーです。",
            "The start date must be on or before the end date.": "開始日は終了日と同じか、それより前の日付である必要があります。",
            "Finish or cancel the field being edited before saving.": "編集中のフィールドを完了またはキャンセルしてから保存してください。",
            "This value is not one of the allowed options.": "許可されたオプションにない値です。",
            "Assets closer to the top <0>match your search more accurately</0>.": "上にある資産ほど検索語と<0>より正確に一致</0>します。",
            "Requests that failed. The file may have been deleted or the URL may have been unpublished.": "失敗したリクエスト数です。ファイルが削除されたか、URL の公開が解除された可能性があります。"
        },
        "code": {
            "WORKFLOW_EMPTY_TREE_INCOMPLETE": "ワークフローが空です。",
            "WORKFLOW_MISSING_TRIGGER_INCOMPLETE": "トリガー(TRIGGER)ステップが必要です。",
            "WORKFLOW_MISSING_END_INCOMPLETE": "終了(END)ステップが必要です。",
            "WORKFLOW_MISSING_TASK_INCOMPLETE": "タスク(TASK)ステップを1つ以上追加してください。",
            "WORKFLOW_START_NO_NEXT_INCOMPLETE": "開始(START)ステップには次のステップを接続する必要があります。",
            "WORKFLOW_UNTERMINATED_PATH_INCOMPLETE": "すべての経路は終了(END)ステップで終わる必要があります。",
            "WORKFLOW_CHOICE_NO_NEXT_INCOMPLETE": "条件(CHOICE)ステップには次のステップを接続する必要があります。",
            "WORKFLOW_BRANCH_COUNT_INCOMPLETE": "並列ブロックには2〜5個の分岐が必要です。分岐を追加してください。",
            "WORKFLOW_BRANCH_COUNT_FATAL": "並列ブロックの分岐は2〜5個までです。",
            "WORKFLOW_SHAPE_UNKNOWN_KEY_FATAL": "ステップに許可されていないプロパティがあります。",
            "WORKFLOW_SHAPE_NAME_FATAL": "ステップ名が正しくありません。",
            "WORKFLOW_SHAPE_SCHEMA_FATAL": "ステップスキーマ情報が正しくありません。",
            "WORKFLOW_SHAPE_CONDITION_FATAL": "ステップ条件の形式が正しくありません。",
            "WORKFLOW_SHAPE_NEXT_FATAL": "ステップの次の接続構造が正しくありません。",
            "WORKFLOW_SHAPE_STEP_FATAL": "接続されたステップの構造が正しくありません。",
            "WORKFLOW_NODE_CAP_FATAL": "ワークフローが許容される最大ステップ数を超えました。",
            "WORKFLOW_BRANCH_NODE_CAP_FATAL": "並列分岐が許容される最大ステップ数を超えました。",
            "WORKFLOW_ROOT_NOT_START_FATAL": "ワークフローは開始(START)ステップから始める必要があります。",
            "WORKFLOW_DUPLICATE_START_FATAL": "開始(START)ステップは1つのみ存在できます。",
            "WORKFLOW_DUPLICATE_TRIGGER_FATAL": "トリガー(TRIGGER)ステップは1つのみ存在できます。",
            "WORKFLOW_DUPLICATE_END_FATAL": "終了(END)ステップは1つのみ存在できます。",
            "WORKFLOW_TRIGGER_NOT_AFTER_START_FATAL": "開始(START)ステップの直後にはトリガー(TRIGGER)ステップが必要です。",
            "WORKFLOW_DUPLICATE_NAME_FATAL": "ステップ名は重複できません。",
            "WORKFLOW_MULTIPLE_PARALLEL_FATAL": "並列ブロックは1つのみ使用できます。",
            "WORKFLOW_NAME_CHARSET_FATAL": "ステップ名に使用できない文字が含まれています。",
            "WORKFLOW_NAME_RESERVED_PREFIX_FATAL": "ステップ名は予約された接頭辞(\"__\")で始めることはできません。",
            "WORKFLOW_UNKNOWN_SCHEMA_FATAL": "ステップのスキーマがカタログに存在しません。",
            "WORKFLOW_CONDITION_SPEC_DEFERRED": "ステップの条件が必須仕様を満たしていません。",
            "WORKFLOW_END_HAS_NEXT_FATAL": "終了(END)ステップには次のステップを接続できません。",
            "WORKFLOW_START_BRANCHES_FATAL": "開始(START)ステップは並列ブロックへ直接分岐できません。",
            "WORKFLOW_NEXT_IS_START_FATAL": "他のステップから開始(START)ステップへ接続することはできません。",
            "WORKFLOW_NESTED_PARALLEL_FATAL": "並列ブロックを入れ子にすることはできません。",
            "WORKFLOW_NOT_PARALLELIZABLE_FATAL": "このステップは並列分岐として使用できません。",
            "WORKFLOW_FORBIDDEN_IN_BRANCH_FATAL": "開始(START)・トリガー(TRIGGER)・終了(END)ステップは並列分岐の内部で使用できません。",
            "WORKFLOW_INPUT_NOT_SATISFIED_DEFERRED": "前のステップの出力ではステップの入力条件を満たせません。",
            "WORKFLOW_DSL_NOT_BINDABLE_FATAL": "このフィールドにはDSLバインディングを使用できません。",
            "WORKFLOW_DSL_MALFORMED_DEFERRED": "DSLバインディングの形式が正しくありません。",
            "WORKFLOW_DSL_TARGET_NOT_FOUND_DEFERRED": "DSLバインディングが存在しないステップまたは出力を参照しています。",
            "WORKFLOW_DSL_OUT_OF_SCOPE_DEFERRED": "DSLバインディングが参照できない範囲のステップを指しています。",
            "OPERATION_ERROR": "ストレージ操作に失敗しました。",
            "OPERATION_COMPLETED": "ストレージ操作に成功しました。",
            "OPERATION_PARTIAL_COMPLETED": "要求された操作は部分的に成功しました。",
            "SUCCESS": "操作は成功しました。",
            "S3_OPERATION_FAIL": "ストレージで操作が失敗しました。",
            "NOT_EXIST_OBJECT_FROM_S3": "ファイルがストレージに存在しません。",
            "NOT_EXIST_OBJECT_FROM_SOURCE_DB": "レコードはインデックスDBに存在しません。",
            "OVERLAP_OTHER_PROCESSING": "ファイルが処理中であるため、操作を実行できません。",
            "FAIL_TO_CHANGE_STATUS": "ファイルの状態の変更中にエラーが発生しました。",
            "USER_DECISION_REQUIRED": "ファイルが重複するため、ユーザーは上書きするかスキップするかを選択する必要があります。",
            "UNKNOWN_ERROR": "不明なエラーが発生しました。",
            "DOWNLOAD_JOB_REJECTED_BY_SIZE": "ファイルサイズが原因でダウンロードジョブが拒否されました。",
            "DOWNLOAD_JOB_REJECTED_BY_COUNT": "ファイル数が原因でダウンロードジョブが拒否されました。",
            "DOWNLOAD_JOB_REJECTED_BY_FOLDER": "フォルダが含まれているリクエストが原因で、ダウンロードジョブが拒否されました。",
            "RESOURCE_NOT_FOUND": "ソースファイルが削除されました。",
            "OPERATION_FAILED": "ストレージ操作に失敗しました。",
            "OPERATION_ABORTED": "ストレージ操作が中止されました。",
            "INTERNAL_ERROR": "内部エラーが発生しました。",
            "CPA_INFO_PANEL_ASSETS_DESC_1": "資産はデジタルで保存できるすべてのコンテンツファイルであり、ファイルのメタデータが含まれています。",
            "CPA_INFO_PANEL_ASSETS_DESC_2": "資産ページでは、登録した資産のリストを確認し、「資産追加」でファイルをアップロードして資産にするか、既存資産の情報を修正/管理/ダウンロードすることができます。",
            "CPA_INFO_PANEL_ASSETS_ACTIONS_DESC": "<H4>行動</H4>\nファイルを資産にして管理することで、次の動作を実行できます。\n<List>\n<ListItem>さまざまなファイルタイプの画像、文書、オーディオファイル、ビデオファイルを追加</ListItem>\n<ListItem>ファイルのメタデータ情報を追加または編集</ListItem>\n<ListItem>タグまたはフォルダを介して資産をグループ化して資産を管理する</ListItem>\n<ListItem>資産名、ID、拡張子、ファイルタイプ、所有者、作成日、タグによる検索</ListItem>\n</List>",
            "CPA_INFO_PANEL_ASSETS_GRID_DESC": "<H4>グリッド/リストレアウト</H4>\n資産リストはグリッドまたはリストレイアウトで確認でき、リストレイアウトとして設定すると、テーブルの列をユーザーが直接指定して表示するかどうかを設定できます。\n（名前、タイプ、サイズ、アクセス権、所有者、作成日、最終変更日）",
            "CPA_INFO_PANEL_ASSETS_ADD_DESC": "<H4>資産を追加</H4>\n「資産の追加」ボタンをクリックするか、ファイルをリストにドラッグアンドドロップしてファイルを資産にすることができます。",
            "CPA_INFO_PANEL_ASSET_DETAIL_DESC": "資産の詳細は、資産の詳細を確認できます。",
            "CPA_INFO_PANEL_ASSET_DETAIL_OVERVIEW_DESC": "<H4>概要</H4>\n概要は、資産の基本的な詳細を確認し、アクセスとフォルダの場所を変更できます。",
            "CPA_INFO_PANEL_ASSET_DETAIL_METADATA_DESC": "<H4>メタデータ</H4>\nメタデータは属性とタグ情報を確認および変更できます。",
            "CPA_INFO_PANEL_ASSET_DETAIL_ACTION_DESC": "<H4>行動</H4>\nその資産を「ダウンロード/アーカイブ/削除」できます。",
            "CPA_INFO_PANEL_ASSET_DETAIL_ARCHIVE_DESC": "<H4>アーカイブ</H4>\nアーカイブオプションは、プロジェクト管理者がプロジェクト設定で設定でき、S3 Glacier Flexible Retrieval / S3 Glacier Deep Archiveのいずれかを選択して使用できます。<NewLine/>\nアーカイブされたファイルは手頃な価格ではなく、回復に時間がかかります。",
            "CPA_INFO_PANEL_ASSET_SEARCH_DESC": "資産リストで検索した結果を確認できます。<NewLine/>\n検索バーで資産名で検索するか、検索オプションウィンドウを開き、詳細検索条件を適用して検索できます。",
            "CPA_INFO_PANEL_ASSET_SEARCH_OPTIONS_DESC": "<H4>検索オプション</H4>\n検索オプションには、資産の名前、ID、拡張子、タイプ、所有者、作成日、タグがあり、必要な詳細オプションを適用して資産の詳細検索を行うことができます。",
            "CPA_INFO_PANEL_ASSET_SEARCH_GO_TO_DESC": "<H4>リストに移動</H4>\n資産リストに戻るには、「リストに移動（←）」ボタンをクリックします。",
            "CPA_INFO_PANEL_ADD_ASSETS_DESC": "さまざまな種類のファイルを資産にすることができます。",
            "CPA_INFO_PANEL_ADD_ASSETS_DETAILS_DESC": "<H4>資産の詳細</H4>\nファイルを直接ナビゲートするか、ドラッグアンドドロップして選択したファイルを確認し、選択したファイルの名前にしたい資産名を変更できます。<NewLine/>\n資産のアクセス権の有無を選択し、メタデータを作成して資産として登録できます。",
            "CPA_INFO_PANEL_ADD_ASSETS_ACCESS_DESC": "<H4>アクセス</H4>\nアクセス権は公開/非公開で選択できます。<NewLine/>\n公開選択時にすべてに公開され、非公開選択時にすべてに非公開処理されます。",
            "Project:Assets:Archive": "アセットアーカイブ権限",
            "Project:Assets:Edit": "アセット編集権限",
            "Project:Assets:Read": "アセット閲覧権限",
            "Project:Categories:Edit": "カテゴリ編集権限",
            "Project:Categories:Read": "カテゴリ閲覧権限",
            "Project:Channels:Edit": "チャンネル編集権限",
            "Project:Channels:Read": "チャンネル閲覧権限",
            "Project:Comments:Edit": "コメント編集権限",
            "Project:Comments:Read": "コメント閲覧権限",
            "Project:CustomContents:Edit": "カスタムコンテンツ編集権限",
            "Project:CustomContents:Read": "カスタムコンテンツ閲覧権限",
            "Project:Dashboard:Edit": "ダッシュボード編集権限",
            "Project:Dashboard:Read": "ダッシュボード閲覧権限",
            "Project:Download:Download": "ダウンロード権限",
            "Project:Folders:Edit": "フォルダ編集権限",
            "Project:Folders:Read": "フォルダ閲覧権限",
            "Project:IntegratedSearch:Read": " 統合検索閲覧権限",
            "Project:InteractiveVideos:Edit": "インタラクティブ動画編集権限",
            "Project:InteractiveVideos:Read": "インタラクティブ動画閲覧権限",
            "Project:Music:Edit": "音楽編集権限",
            "Project:Music:Read": "音楽閲覧権限",
            "Project:People:Edit": "人物編集権限",
            "Project:People:Read": "人物閲覧権限",
            "Project:Photo:Edit": "写真編集権限",
            "Project:Photo:Read": "写真閲覧権限",
            "Project:Shares:External": "外部共有権限",
            "Project:Shares:Internal": "内部共有権限",
            "Project:Statistics:Edit": " 統計編集権限",
            "Project:Statistics:Read": "統計閲覧権限",
            "Project:Storages:Edit": "ストレージ編集権限",
            "Project:Storages:Read": "ストレージ閲覧権限",
            "Project:Users&Groups:Read": "ユーザー・グループ閲覧権限",
            "Project:Videos:Edit": " 動画編集権限",
            "Project:Videos:Publish": "動画公開権限",
            "Project:Videos:Read": "動画閲覧権限",
            "Project:Shares:InternalRequest": "内部リクエスト権限"
        },
        "audit": {
            "Retrieve list of Actions": "アクション一覧取得",
            "Retrieve list of AI Face collections": "AIフェイスコレクション一覧取得",
            "Delete AI Face collection": "AIフェイスコレクション削除",
            "Update AI Face collection": "AIフェイスコレクション更新",
            "Retrieve list of archived assets": "アーカイブ済み資産一覧取得",
            "Retrieve archived asset details": "アーカイブ済み資産詳細取得",
            "Restore archived asset": "アーカイブ済み資産復元",
            "Retrieve list of assets": "資産一覧取得",
            "Create asset": "資産作成",
            "Retrieve asset details": "資産詳細取得",
            "Update asset": "資産更新",
            "Delete asset": "資産削除",
            "Activate asset": "資産アクティブ",
            "Archive asset": "資産アーカイブ",
            "Create file in asset": "ファイル資産作成",
            "Add files to asset": "ファイル資産追加",
            "Delete file from asset": "ファイル資産削除",
            "Update file in asset": "ファイル資産更新",
            "Update tags of asset": "タグ資産更新",
            "Delete tag from asset": "タグ資産削除",
            "Inactivate asset": "資産非アクティブ",
            "Attach People to asset": "資産と人物を連結",
            "Detach People from asset": "資産と人物との連結解除",
            "Retrieve asset status": "資産ステータス取得",
            "Retrieve upload URL for asset": "アップロードURL資産取得",
            "Retrieve list of audit logs": "監査ログ一覧取得",
            "Retrieve audit log details": "監査ログ詳細取得",
            "Send HEAD request to storage file": "ストレージファイルにHEAD要請",
            "Retrieve list of category groups": "カテゴリーグループ一覧取得",
            "Retrieve category group details": "カテゴリーグループ詳細取得",
            "Update category group": "カテゴリーグループ更新",
            "Delete category group": "カテゴリーグループ削除",
            "Retrieve list of categories": "カテゴリー一覧取得",
            "Create category": "カテゴリー作成",
            "Delete categories in bulk": "カテゴリー一括削除",
            "Retrieve category details": "カテゴリー詳細取得",
            "Update category": "カテゴリー更新",
            "Delete category": "カテゴリー削除",
            "Retrieve list of CDNs": "CDN一覧取得",
            "Create CDN": "CDN作成",
            "Retrieve CDN details": "CDN詳細取得",
            "Update CDN": "CDN更新",
            "Delete CDN": "CDN削除",
            "Retrieve list of channels": "チャネル一覧取得",
            "Create channel": "チャネル作成",
            "Retrieve channel details": "チャネル詳細取得",
            "Update channel": "チャネル更新",
            "Delete channel": "チャネル削除",
            "Update channel case": "チャネルケース更新",
            "Retrieve list of channel inputs": "チャネルインプット一覧取得",
            "Retrieve channel input details": "チャネルインプット詳細取得",
            "Retrieve channel encoder details": "チャネルエンコーダー詳細取得",
            "Reclaim channel": "回収チャネル",
            "Request channel approval": "チャネル承認リクエスト",
            "Retrieve list of channel schedules": "チャネルスケジュール一覧取得",
            "Update channel schedules in bulk": "チャネルスケジュール一括更新",
            "Delete channel schedules in bulk": "チャネルスケジュール一括削除",
            "Delete channel schedule": "チャネルスケジュール削除",
            "Retrieve channel schedule details": "チャネルスケジュール詳細取得",
            "Update channel schedule": "チャネルスケジュール更新",
            "Start channel": "チャネル開始",
            "Retrieve channel state": "チャネル状態取得",
            "Stop channel": "チャネル停止",
            "Request DRM token for video": "ビデオのDRMトークンリクエスト",
            "Retrieve Presigned URL of Master file for container format video": "コンテナフォーマットビデオのマスターファイルのPresigned URLを取得",
            "Retrieve Presigned URL of Daughter file for container format video": "コンテナフォーマットビデオのドーターファイルのPresigned URLを取得",
            "Retrieve list of transcode jobs": "トランスコードジョブ一覧取得",
            "Create transcode job": "トランスコードジョブ作成",
            "Create and start transcode job": "トランスコードジョブ作成と開始要請",
            "Retrieve upload URL for transcode job": "トランスコードジョブのためアップロードURL取得",
            "Retrieve transcode job details": "トランスコードジョブ詳細取得",
            "Update transcode job": "トランスコードジョブ更新",
            "Delete transcode job": "トランスコードジョブ削除",
            "Cancel transcode job": "トランスコードジョブ",
            "Retrieve transcode job status": "トランスコードジョブステータス取得",
            "Correct transcode job status": "トランスコードジョブ",
            "Start transcode job": "トランスコードジョブ開始",
            "Retrieve list of listings": "リスティング一覧取得",
            "Create listing": "リスティング作成",
            "Retrieve listing details": "リスティング詳細取得",
            "Update listing": "リスティング更新",
            "Delete listing": "リスティング削除",
            "Retrieve list of lineups": "ラインナップ一覧取得",
            "Create lineup": "ラインナップ作成",
            "Delete lineups in bulk": "ラインナップ一括削除",
            "Create lineups in bulk": "ラインナップ一括作成",
            "Retrieve lineup details": "ラインナップ詳細取得",
            "Update lineup": "ラインナップ更新",
            "Delete lineup": "ラインナップ削除",
            "Retrieve list of scheduled lineups after current time": "スケジュールラインナップ現在時刻一覧取得",
            "Retrieve list of localization resources": "ローカライゼーションリソース一覧取得",
            "Retrieve localization resource details": "ローカライゼーションリソース詳細取得",
            "Retrieve current user information": "現在ユーザー情報取得",
            "Retrieve list of Actions allowed for current user in project": "アクション許可済み現在ユーザープロジェクト一覧取得",
            "Retrieve list of Actions allowed for current user in space": "アクション許可済み現在ユーザースペース一覧取得",
            "Request PoPs user synchronization": "PoPsユーザー同期リクエスト",
            "Retrieve list of metadata fields": "メタデータフィールド一覧取得",
            "Create metadata field": "メタデータフィールド作成",
            "Retrieve metadata field details": "メタデータフィールド詳細取得",
            "Update metadata field": "メタデータフィールド更新",
            "Delete metadata field": "メタデータフィールド削除",
            "Retrieve list of metadata schemas": "メタデータスキーマ一覧取得",
            "Create metadata schema": "メタデータスキーマ作成",
            "Register metadata schema": "メタデータスキーマ",
            "Retrieve metadata schema details": "メタデータスキーマ詳細取得",
            "Update metadata schema": "メタデータスキーマ更新",
            "Delete metadata schema": "メタデータスキーマ削除",
            "Retrieve list of People": "ユーザー一覧取得",
            "Create People": "ユーザー作成",
            "Update People": "ユーザー更新",
            "Delete People": "ユーザー削除",
            "Retrieve People details": "ユーザー詳細取得",
            "Retrieve list of transcode pipelines": "トランスコードパイプライン一覧取得",
            "Retrieve transcode pipeline details": "トランスコードパイプライン詳細取得",
            "Retrieve embed URL": "埋込URL取得",
            "Retrieve shared URL": "共有URL取得",
            "Retrieve list of SNS accounts": "SNSアカウント一覧取得",
            "Create SNS account": "SNSアカウント作成",
            "Retrieve SNS account details": "SNSアカウント詳細取得",
            "Delete SNS account": "SNSアカウント削除",
            "Update SNS account": "SNSアカウント更新",
            "Retrieve SNS posting history": "SNS投稿履歴取得",
            "Retrieve list of videos posted to SNS": "SNSに投稿済みのビデオ一覧取得",
            "Post video to SNS": "SNSにビデオ投稿",
            "Retrieve SNS video details": "SNSビデオ詳細取得",
            "Retrieve transcode profile details": "トランスコードプロファイル詳細取得",
            "Retrieve list of programmes": "プログラム一覧取得",
            "Create programme": "プログラム作成",
            "Retrieve programme details": "プログラム詳細取得",
            "Update programme": "プログラム更新",
            "Delete programme": "プログラム削除",
            "Retrieve list of projects": "プロジェクト一覧取得",
            "Create project": "プロジェクト作成",
            "Delete project": "プロジェクト削除",
            "Retrieve project details": "プロジェクト詳細取得",
            "Update project": "プロジェクト更新",
            "Retrieve list of assignable members to project": "プロジェクトに割り当て可能なメンバー一覧取得",
            "Retrieve list of assignable teams to project": "プロジェクトに割り当て可能なグループ一覧取得",
            "Retrieve list of assigned project members": "プロジェクトに割り当てられたメンバー一覧取得",
            "Retrieve list of assigned project teams": "プロジェクトに割り当てられたグループ一覧取得",
            "Retrieve list of project members": "プロジェクトメンバー一覧取得",
            "Assign member to project": "プロジェクトにメンバー追加",
            "Unassign member from project": "プロジェクトからメンバー解除",
            "Add storages to project": "ストレージプロジェクト追加",
            "Update project storages": "プロジェクトストレージ更新",
            "Retrieve list of project teams": "プロジェクトグループ一覧取得",
            "Assign team to project": "プロジェクトにグループ追加",
            "Unassign team from project": "プロジェクトからグループ解除",
            "Create player": "プレイヤー作成",
            "Retrieve list of players": "プレイヤー一覧取得",
            "Create player profile": "プレイヤープロファイル作成",
            "Retrieve list of player profiles": "プレイヤープロファイル一覧取得",
            "Retrieve player profile details": "プレイヤープロファイル詳細取得",
            "Update player profile": "プレイヤープロファイル更新",
            "Delete player profile": "プレイヤープロファイル削除",
            "Retrieve player details": "プレイヤー詳細取得",
            "Update player": "プレイヤー更新",
            "Delete player": "プレイヤー削除",
            "Create player resource": "プレイヤーリソース作成",
            "Retrieve list of player resources": "プレイヤーリソース一覧取得",
            "Retrieve player resource details": "プレイヤーリソース詳細取得",
            "Update player resource": "プレイヤーリソース更新",
            "Delete player resource": "プレイヤーリソース削除",
            "Retrieve upload URL for resource": "アップロードURLリソース取得",
            "Create role": "役割作成",
            "Retrieve list of roles": "役割一覧取得",
            "Retrieve role details": "役割詳細取得",
            "Update role": "役割更新",
            "Delete role": "役割削除",
            "Attach permissions to role": "役割",
            "Retrieve list of permissions in role": "権限役割一覧取得",
            "Detach permission from role": "役割",
            "Retrieve list of settings": "設定一覧取得",
            "Create project settings": "プロジェクト設定作成",
            "Delete project settings": "プロジェクト設定削除",
            "Create space settings": "スペース設定作成",
            "Delete space settings": "スペース設定削除",
            "Create statistics": "統計作成",
            "Retrieve list of statistics widget groups": "統計ウィジェットグループ一覧取得",
            "Create statistics widget group": "統計ウィジェットグループ作成",
            "Delete statistics widget group": "統計ウィジェットグループ削除",
            "Retrieve list of widgets in specific statistics widget group": "ウィジェット特定統計ウィジェットグループ一覧取得",
            "Update statistics widgets": "統計ウィジェット更新",
            "Retrieve list of statistics widgets": "統計ウィジェット一覧取得",
            "Create statistics Aggregation": "統計集計作成",
            "Create statistics Feature": "統計機能作成",
            "Create statistics Resource": "統計リソース作成",
            "Retrieve list of stream inputs": "ストリームインプット一覧取得",
            "Create stream input": "ストリームインプット作成",
            "Retrieve list of whitelists": "ホワイトリスト一覧取得",
            "Retrieve stream input details": "ストリームインプット詳細取得",
            "Update stream input": "ストリームインプット更新",
            "Delete stream input": "ストリームインプット削除",
            "Retrieve list of teams": "グループ一覧取得",
            "Retrieve team details": "グループ詳細取得",
            "Retrieve list of team members": "グループメンバー一覧取得",
            "Retrieve list of event triggers": "イベントトリガー一覧取得",
            "Create event trigger": "イベントトリガー作成",
            "Retrieve event trigger details": "イベントトリガー詳細取得",
            "Delete event trigger": "イベントトリガー削除",
            "Update event trigger": "イベントトリガー更新",
            "Retrieve upload URL for event trigger": "アップロードURLイベントトリガー取得",
            "Retrieve list of users": "ユーザー一覧取得",
            "Retrieve user details": "ユーザー詳細取得",
            "Update user": "ユーザー更新",
            "Delete user": "ユーザー削除",
            "Retrieve list of videos": "ビデオ一覧取得",
            "Create video": "ビデオ作成",
            "Retrieve video details": "ビデオ詳細取得",
            "Update video": "ビデオ更新",
            "Delete video": "ビデオ削除",
            "Activate video": "ビデオアクティブ",
            "Request caption creation via video": "キャプション作成経由ビデオリクエスト",
            "Delete caption from video": "キャプションビデオ削除",
            "Update caption in video": "キャプションビデオ更新",
            "Inactivate video": "ビデオ非アクティブ",
            "Attach People to video": "ビデオ",
            "Detach People from video": "ビデオ",
            "Create posters for video in bulk": "ポスタービデオ一括作成",
            "Delete poster from video": "ポスタービデオ削除",
            "Create SNS posting for video": "SNS投稿ビデオ作成",
            "Retrieve video status": "ビデオステータス取得",
            "Retrieve Thumbnail profiles for video": "サムネイルプロファイルビデオ取得",
            "Create category group": "カテゴリーグループ作成",
            "Retrieve list of Resource Buckets": "リソースバケット一覧取得",
            "Create Resource Buckets in bulk": "リソースバケット一括作成",
            "Retrieve list of files in asset": "ファイル資産一覧取得",
            "Retrieve list of Searchable Buckets": "サーチャブルバケット一覧取得",
            "Create Searchable Bucket": "サーチャブルバケット作成",
            "Delete Searchable Bucket": "サーチャブルバケット削除",
            "Retrieve Searchable Bucket details": "サーチャブルバケット詳細取得",
            "Update Searchable Bucket": "サーチャブルバケット更新",
            "Register Searchable Bucket": "サーチャブルバケット",
            "Delete schedule": "スケジュール削除",
            "Retrieve list of asset types": "資産タイプ一覧取得",
            "Create asset type": "資産タイプ作成",
            "Retrieve list of asset extensions": "資産拡張機能一覧取得",
            "Create asset extension": "資産拡張機能作成",
            "Retrieve schedule details": "スケジュール詳細取得",
            "Retrieve list of schedules": "スケジュール一覧取得",
            "Delete schedules in bulk": "スケジュール一括削除",
            "Update schedule": "スケジュール更新",
            "Create schedules in bulk": "スケジュール一括作成",
            "Start schedule": "スケジュール開始",
            "Stop schedule": "スケジュール停止",
            "Lock schedule": "スケジュール",
            "End schedule": "スケジュール",
            "Request asset download": "資産ダウンロードリクエスト",
            "Retrieve asset download details": "資産ダウンロード詳細取得",
            "Retrieve schedule history details": "スケジュール履歴詳細取得",
            "Retrieve list of schedule histories": "スケジュール履歴一覧取得",
            "Retrieve hidden metadata field value": "非表示メタデータフィールド値取得",
            "Retrieve list of shared configurations for video": "ビデオ一の構成設定一覧取得",
            "Create shared configuration for video": "ビデオ一の構成設定作成",
            "Retrieve shared configuration details for video": "ビデオ一の構成設定詳細取得",
            "Update shared configuration for video": "ビデオ一の構成設定更新",
            "Delete shared configuration from video": "ビデオ一の構成設定削除",
            "Retrieve list of content schemas": "コンテンツスキーマ一覧取得",
            "Attach teaser images to video in bulk": "ビデオのティーザーイメージ一括追加",
            "Detach teaser image from video": "ビデオのティーザーイメージ一解除",
            "Attach teaser videos to video in bulk": "ビデオのティーザービデオ一括追加",
            "Detach teaser video from video": "ビデオのティーザービデオ解除",
            "Retrieve list of music": "ミュージック一覧取得",
            "Retrieve music details": "ミュージック詳細取得",
            "Update music": "ミュージック更新",
            "Delete music": "ミュージック削除",
            "Create music": "ミュージック作成",
            "Add file to music": "ファイルミュージック追加",
            "Update file in music": "ファイルミュージック更新",
            "Delete file from music": "ファイルミュージック削除",
            "Retrieve list of photos": "フォト一覧取得",
            "Retrieve photo details": "フォト詳細取得",
            "Update photo": "フォト更新",
            "Delete photo": "フォト削除",
            "Create photo": "フォト作成",
            "Add file to photo": "ファイルフォト追加",
            "Update file in photo": "ファイルフォト更新",
            "Delete file from photo": "ファイルフォト削除",
            "Retrieve asset file download link": "資産ファイルダウンロードリンク取得",
            "Retrieve download information": "ダウンロード情報取得",
            "Search": "未翻訳",
            "Retrieve list of attributions": "帰属一覧取得",
            "Create attribution": "帰属作成",
            "Retrieve attribution details": "帰属詳細取得",
            "Update attribution": "帰属更新",
            "Delete attribution": "帰属削除",
            "Retrieve list of asset files": "資産ファイル一覧取得",
            "Retrieve list of file versions in asset": "ファイルバージョン資産一覧取得",
            "Attach categories to asset in bulk": "資産にカテゴリ追加",
            "Detach categories from asset in bulk": "資産からカテゴリ解除",
            "Retrieve list of attribution keys": "アトリビュートキー一覧取得",
            "Update owner of asset": "資産の所有者更新",
            "Retrieve dashboard data": "ダッシュボードデータ取得",
            "Retrieve list of Actions for role": "アクション役割一覧取得",
            "Retrieve list of file meta keys": "ファイルメタキー一覧取得",
            "Update project member": "プロジェクトメンバー更新",
            "Update project team": "プロジェクトグループ更新",
            "Retrieve list of related contents in asset": "関連コンテンツ資産一覧取得",
            "Retrieve list of asynchronous Jobs": "非同期ジョブ一覧取得",
            "Create asynchronous Job": "非同期ジョブ作成",
            "Update asynchronous Job": "非同期ジョブ更新",
            "Create asynchronous Job Action": "非同期ジョブアクション作成",
            "Retrieve list of Tasks in asynchronous Job": "タスク非同期ジョブ一覧取得",
            "Create Task in asynchronous Job": "タスク非同期ジョブ作成",
            "Update Task in asynchronous Job": "タスク非同期ジョブ更新",
            "Request action on specific storage": "アクション特定ストレージリクエスト",
            "Retrieve asynchronous Job details": "非同期ジョブ詳細取得",
            "Retrieve asynchronous Job Alias": "非同期ジョブエイリアス取得",
            "Create Alias for asynchronous Job": "エイリアス非同期ジョブ作成",
            "Retrieve list of asynchronous Job Types": "非同期ジョブタイプ一覧取得",
            "Create asynchronous Job Type": "非同期ジョブタイプ作成",
            "Retrieve asynchronous Job Type details": "非同期ジョブタイプ詳細取得",
            "Update asynchronous Job Type": "非同期ジョブタイプ更新",
            "Delete asynchronous Job Type": "非同期ジョブタイプ削除",
            "Retrieve list of Actions in asynchronous Job Type": "アクション非同期ジョブタイプ一覧取得",
            "Create Action in asynchronous Job Type": "アクション非同期ジョブタイプ作成",
            "Update Action in asynchronous Job Type": "アクション非同期ジョブタイプ更新",
            "Delete Action in asynchronous Job Type": "アクション非同期ジョブタイプ削除",
            "Update music in bulk": "ミュージック一括更新",
            "Update photos in bulk": "フォト一括更新",
            "Retrieve list of hidden metadata": "非表示メタデータ一覧取得",
            "Update People in bulk": "ユーザー一括更新",
            "Retrieve list of item sets for metadata": "アイテムセットメタデータ一覧取得",
            "Create item set for metadata": "アイテムセットメタデータ作成",
            "Update item set for metadata": "アイテムセットメタデータ更新",
            "Delete item set for metadata": "アイテムセットメタデータ削除",
            "Retrieve list of elements in item set": "要素アイテムセット一覧取得",
            "Update videos in bulk": "ビデオ一括更新",
            "Start asynchronous Job": "非同期ジョブ開始",
            "Complete asynchronous Job": "非同期ジョブ完了",
            "Start Task in asynchronous Job": "タスク非同期ジョブ開始",
            "Complete Task in asynchronous Job": "ジョブ",
            "Create asynchronous Job Alias": "非同期ジョブエイリアス作成",
            "Retrieve asynchronous Job Alias details": "非同期ジョブエイリアス詳細取得",
            "Request fms action on specific storage": "FMSアクション特定ストレージリクエスト",
            "Retrieve list of Searchable Buckets by admin": "サーチャブルバケット管理者一覧取得",
            "Retrieve list of download jobs": "ダウンロードジョブ一覧取得",
            "Request download": "ダウンロードリクエスト",
            "Retrieve download job details": "ダウンロードジョブ詳細取得",
            "Retrieve list of download job tasks": "ダウンロードジョブタスク一覧取得",
            "Retrieve download job task details": "ダウンロードジョブタスク詳細取得",
            "Retrieve download link": "ダウンロードリンク取得",
            "Retrieve list of Batch Jobs": "バッチジョブ一覧取得",
            "Create Batch Job": "バッチジョブ作成",
            "Retrieve Batch Job details": "バッチジョブ詳細取得",
            "Retrieve list of Batch Job Tasks": "バッチジョブタスク一覧取得",
            "Retrieve Batch Job Task details": "バッチジョブタスク詳細取得",
            "Retrieve Presigned URL for S3 file": "事前署名済みURLS3ファイル取得",
            "Initiate multipart upload session for S3 file": "S3ファイルマルチパートアップロードセッション開始",
            "Complete multipart upload for S3 file": "S3ファイルマルチパートアップロード完了",
            "Abort multipart upload for S3 file": "S3ファイルマルチパートアップロード中止",
            "Retrieve Presigned URL for part upload in S3 file": "事前署名済みURLパートアップロードS3ファイル取得",
            "Retrieve Presigned URL for upload in S3 file": "事前署名済みURLアップロードS3ファイル取得",
            "Retrieve integrated search list": "統合検索一覧取得",
            "Retrieve list of Resource Buckets assigned to me": "リソースバケット割当済み私一覧取得",
            "Retrieve Task details in asynchronous Job": "非同期ジョブのタスク詳細取得",
            "Retrieve list of integrated search domains": "統合検索ドメイン一覧取得",
            "Create integrated search domain": "統合検索ドメイン作成",
            "Retrieve integrated search domain details": "統合検索ドメイン詳細取得",
            "Delete integrated search domain": "統合検索ドメイン削除",
            "Retrieve list of shared links": "外部リンク一覧取得",
            "Share link": "外部リンク",
            "Retrieve shared link details": "共有リンク詳細取得",
            "Delete shared link": "共有リンク削除",
            "Retrieve list of AWS S3 buckets": "AWSS3バケット一覧取得",
            "Retrieve list of internal shares": "内部共有一覧取得",
            "Create internal share": "内部共有作成",
            "Retrieve internal share details": "内部共有詳細取得",
            "Update internal share": "内部共有更新",
            "Update requester action in internal share": "リクエスターアクション内部共有更新",
            "Update approver action in internal share": "承認者アクション内部共有更新",
            "Retrieve list of approver candidates for internal share": "承認者候補内部共有一覧取得",
            "Retrieve list of shared resources": "共有リソース一覧取得",
            "Share resource": "リソースーの共有",
            "Retrieve shared resource details": "共有リソース詳細取得",
            "Delete shared resource": "共有リソース削除",
            "Retrieve list of grantees for shared resource": "付与先共有リソース一覧取得",
            "Add grantee to shared resource": "付与先共有リソース追加",
            "Retrieve grantee details for shared resource": "付与先詳細取得",
            "Update grantee for shared resource": "付与先共有リソース更新",
            "Remove grantee from shared resource": "付与先共有リソース削除",
            "Check share permission": "共有権限の検証",
            "Retrieve list of resources shared with me": "リソース共有私一覧取得",
            "Retrieve details of resource shared with me": "詳細リソース共有私取得",
            "Delete resource shared with me": "リソース共有私削除",
            "Retrieve list of drives": "ドライブ一覧取得",
            "Retrieve drive details": "ドライブ詳細取得",
            "Update drive": "ドライブ更新",
            "Retrieve list of folders": "フォルダ一覧取得",
            "Create folder": "フォルダ作成",
            "Retrieve folder details": "フォルダ詳細取得",
            "Update folder": "フォルダ更新",
            "Delete folder": "フォルダ削除",
            "Move folder": "フォルダの移動要請",
            "Retrieve list of metadata templates": "メタデータテンプレート一覧取得",
            "Create metadata template": "メタデータテンプレート作成",
            "Retrieve metadata template details": "メタデータテンプレート詳細取得",
            "Update metadata template": "メタデータテンプレート更新",
            "Delete metadata template": "メタデータテンプレート削除",
            "Register metadata template": "メタデータテンプレート登録",
            "Retrieve list of dashboard widgets": "ダッシュボードウィジェット一覧取得",
            "Create dashboard widget": "ダッシュボードウィジェット作成",
            "Retrieve dashboard widget details": "ダッシュボードウィジェット詳細取得",
            "Update dashboard widget": "ダッシュボードウィジェット更新",
            "Delete dashboard widget": "ダッシュボードウィジェット削除",
            "Retrieve list of dashboard widget data": "ダッシュボードウィジェットデータ一覧取得",
            "Retrieve list of storage folders": "ストレージフォルダ一覧取得",
            "Retrieve list of storage files": "ストレージファイル一覧取得",
            "Move asset": "資産のフォルダの移動要請",
            "Request storage action": "ストレージアクションリクエスト",
            "Lock Searchable Bucket": "サーチャブルバケット",
            "Unlock Searchable Bucket": "サーチャブルバケット",
            "Retrieve list of multipart upload jobs": "マルチパートアップロードジョブ一覧取得",
            "Retrieve list of parts in multipart upload job": "パートマルチパートアップロードジョブ一覧取得",
            "Retrieve list of collections": "コレクション一覧取得",
            "Create collection": "コレクション作成",
            "Retrieve collection details": "コレクション詳細取得",
            "Update collection": "コレクション更新",
            "Delete collection": "コレクション削除",
            "Retrieve list of items in collection": "アイテムコレクション一覧取得",
            "Update collection tags": "コレクションタグ更新",
            "Retrieve list of linked collections": "リンク済みコレクション一覧取得",
            "Request collection action": "コレクションアクションリクエスト",
            "Retrieve list of content field types": "コンテンツフィールドタイプ一覧取得",
            "Create content field type": "コンテンツフィールドタイプ作成",
            "Retrieve content field type details": "コンテンツフィールドタイプ詳細取得",
            "Update content field type": "コンテンツフィールドタイプ更新",
            "Delete content field type": "コンテンツフィールドタイプ削除",
            "Create content schema": "コンテンツスキーマ作成",
            "Request content schema field action": "コンテンツスキーマフィールドアクションリクエスト",
            "Retrieve content schema details": "コンテンツスキーマ詳細取得",
            "Update content schema": "コンテンツスキーマ更新",
            "Delete content schema": "コンテンツスキーマ削除",
            "Request content schema action": "コンテンツスキーマアクションリクエスト",
            "Retrieve list of projects assigned to content schema": "プロジェクト割当済みコンテンツスキーマ一覧取得",
            "Retrieve list of custom contents": "カスタムコンテンツ一覧取得",
            "Create custom content": "カスタムコンテンツ作成",
            "Retrieve custom content details": "カスタムコンテンツ詳細取得",
            "Update custom content": "カスタムコンテンツ更新",
            "Delete custom content": "カスタムコンテンツ削除",
            "Request custom content action": "カスタムコンテンツアクションリクエスト",
            "Retrieve custom content field details": "カスタムコンテンツフィールド詳細取得",
            "Request custom content action in bulk": "カスタムコンテンツアクション一括リクエスト",
            "Retrieve list of AI caption jobs": "AIキャプションジョブ一覧取得",
            "Create AI caption job": "AIキャプションジョブ作成",
            "Retrieve AI caption job details": "AIキャプションジョブ詳細取得",
            "Retrieve list of AI analysis jobs": "AI分析ジョブ一覧取得",
            "Create AI analysis job": "AI分析ジョブ作成",
            "Retrieve AI analysis job details": "AI分析ジョブ詳細取得",
            "Delete AI analysis job": "AI分析ジョブ削除",
            "Retrieve list of AI analysis job summaries": "AI分析ジョブサマリー一覧取得",
            "Retrieve list of AI analysis job results": "AI分析ジョブ結果一覧取得",
            "Retrieve list of AI analysis job original results": "AI分析ジョブオリジナル結果一覧取得",
            "Retrieve AI analysis job original result details": "AI分析ジョブオリジナル結果詳細取得",
            "Callback for AI analysis job engine": "AI分析ジョブエンジンコールバック",
            "Retrieve list of dictation vocabularies": "ディクテーションボキャブラリー一覧取得",
            "Create dictation vocabulary": "ディクテーションボキャブラリー作成",
            "Retrieve dictation vocabulary details": "ディクテーションボキャブラリー詳細取得",
            "Delete dictation vocabulary": "ディクテーションボキャブラリー削除",
            "Update dictation vocabulary": "ディクテーションボキャブラリー更新",
            "Retrieve list of phrases in vocabulary": "フレーズボキャブラリー一覧取得",
            "Request vocabulary phrase action": "ボキャブラリーフレーズアクションリクエスト",
            "Retrieve list of notifications": "通知一覧取得",
            "Create notification": "通知作成",
            "Retrieve notification details": "通知詳細取得",
            "Update notification": "通知更新",
            "Delete notification": "通知削除",
            "Retrieve list of notification subscriptions": "通知サブスクリプション一覧取得",
            "Subscribe to notification": "通知サブスクリプション",
            "Retrieve notification subscription details": "通知サブスクリプション詳細取得",
            "Unsubscribe from notification": "通知サブスクリプション解除",
            "Retrieve list of notification conditions": "通知条件一覧取得",
            "Update notification conditions": "通知条件更新",
            "Retrieve list of domain events": "ドメインイベント一覧取得",
            "Retrieve download links for AI analysis job": "ダウンロードリンクAI分析ジョブ取得",
            "Retrieve list of asset versions": "資産バージョン一覧取得",
            "Create asset version": "資産バージョン作成",
            "Retrieve asset version details": "資産バージョン詳細取得",
            "Delete asset version": "資産バージョン削除",
            "Retrieve list of comment threads": "コメントスレッド一覧取得",
            "Create comment thread": "コメントスレッド作成",
            "Retrieve list of comments in thread": "コメントスレッド一覧取得",
            "Create comment": "コメント作成",
            "Update comment": "コメント更新",
            "Delete comment": "コメント削除",
            "Request comment action": "コメントアクションリクエスト",
            "Delete comment thread": "コメントスレッド削除",
            "Retrieve comment details": "コメント詳細取得",
            "Update comment thread": "コメントスレッド更新",
            "Retrieve list of comments": "コメント一覧取得",
            "Retrieve list of Action Groups": "アクショングループ一覧取得",
            "Retrieve Action Group details": "アクショングループ詳細取得",
            "Retrieve list of my space permissions": "マイスペース権限一覧取得",
            "Retrieve list of my project permissions": "マイプロジェクト権限一覧取得",
            "Request role action": "役割アクションリクエスト",
            "Retrieve list of entities by role": "エンティティ役割一覧取得",
            "Assign role to entity": "ユザー及びグループに役割を設定",
            "Remove role from entity": "ユザー及びグループから役割を削除",
            "Create user": "ユーザー作成",
            "Create team": "グループ作成",
            "Update team": "グループ更新",
            "Delete team": "グループ削除",
            "Assign member to team": "グループにユザー追加",
            "Retrieve team member details": "グループユザーの詳細取得",
            "Remove member from team": "グループからユザー削除",
            "Assign project member": "プロジェクトメンバー",
            "Retrieve project member details": "プロジェクトメンバー詳細取得",
            "Remove project member": "プロジェクトメンバー削除",
            "Assign project team": "プロジェクトグループ",
            "Retrieve project team details": "プロジェクトグループ詳細取得",
            "Remove project team": "プロジェクトグループ削除",
            "Retrieve list of project team members": "プロジェクトグループメンバー一覧取得",
            "Retrieve project team member details": "プロジェクトグループメンバー詳細取得",
            "Retrieve list of Resource Types": "リソースタイプ一覧取得",
            "Copy asset": "資産のコピー",
            "Retrieve list of collections by asset": "コレクション資産一覧取得",
            "Delete users in bulk": "ユーザー一括削除",
            "Request team action": "グループアクションリクエスト",
            "Delete teams in bulk": "グループ一括削除",
            "Remove project members in bulk": "プロジェクトメンバー一括削除",
            "Remove project teams in bulk": "プロジェクトグループ一括削除",
            "Retrieve list of linked assets": "リンク済み資産一覧取得",
            "Add linked asset": "リンク済み資産追加",
            "Remove linked asset": "リンク済み資産削除",
            "Create comment attachment": "コメント添付ファイル作成",
            "Delete comment attachment": "コメント添付ファイル削除",
            "Request user action": "ユーザーアクションリクエスト",
            "Retrieve list of project admins": "プロジェクト管理者一覧取得",
            "Request project action": "プロジェクトアクションリクエスト",
            "Retrieve list of project member's teams": "プロジェクトメンバー'グループ一覧取得",
            "Retrieve list of project member's roles": "プロジェクトメンバー'役割一覧取得",
            "Retrieve list of project team's roles": "プロジェクトグループ'役割一覧取得",
            "Retrieve comment thread details": "コメントスレッド詳細取得",
            "Retrieve list of thread entities": "スレッドエンティティ一覧取得",
            "Create thread entity": "スレッドエンティティ作成",
            "Retrieve list of pending users for space invitation": "保留中ユーザースペース招待一覧取得",
            "Request space user invitation": "スペースユーザー招待リクエスト",
            "Retrieve list of pending users for project invitation": "保留中ユーザープロジェクト招待一覧取得",
            "Request project user invitation": "プロジェクトユーザー招待リクエスト",
            "Retrieve list of assignable members to team": "割当可能メンバーグループ一覧取得",
            "Create exported metadata job": "エクスポート済みメタデータジョブ作成",
            "Retrieve list of exported metadata jobs": "エクスポート済みメタデータジョブ一覧取得",
            "Retrieve exported metadata job details": "エクスポート済みメタデータジョブ詳細取得",
            "Update exported metadata job": "エクスポート済みメタデータジョブ更新",
            "Delete exported metadata job": "エクスポート済みメタデータジョブ削除",
            "Retrieve upload Presigned URL for preview resource": "アップロード事前署名済みURLプレビューリソース取得",
            "Request preview resource action": "プレビューリソースアクションリクエスト",
            "Retrieve list of audit log search keys": "監査ログ検索キー一覧取得",
            "Retrieve embed URL for posting": "埋込URL投稿取得",
            "Request role management action": "役割管理アクションリクエスト",
            "Retrieve list of report settings": "レポート設定一覧取得",
            "Retrieve report setting details": "レポート設定詳細取得",
            "Update report setting": "レポート設定更新",
            "Retrieve list of reports": "レポート一覧取得",
            "Retrieve report details": "レポート詳細取得",
            "Retrieve list of report subscribers": "レポートサブスクライバー一覧取得",
            "Capture asset frame": "資産のフレームキャップチャ",
            "Retrieve list of links": "リンク一覧取得",
            "Create link": "リンク作成",
            "Update link": "リンク更新",
            "Delete link": "リンク削除",
            "Create drive": "ドライブ作成",
            "Delete drive": "ドライブ削除",
            "Validate share grantee": "共有者検証",
            "Apply asset owner lock": "資産所有者ロック",
            "Release asset owner lock": "資産所有者ロック解除",
            "Create video clip from asset": "ビデオクリップ資産作成",
            "Retrieve list of favorite resources": "お気に入りリソース一覧取得",
            "Create favorite resource": "お気に入りリソース作成",
            "Delete favorite resource": "お気に入りリソース削除",
            "Retrieve list of custom menu sets": "カスタムメニューセット一覧取得",
            "Create custom menu set": "カスタムメニューセット作成",
            "Retrieve custom menu set details": "カスタムメニューセット詳細取得",
            "Update custom menu set": "カスタムメニューセット更新",
            "Delete custom menu set": "カスタムメニューセット削除",
            "Request custom menu set action": "カスタムメニューセットアクションリクエスト",
            "Retrieve list of custom menus": "カスタムメニュー一覧取得",
            "Create custom menu": "カスタムメニュー作成",
            "Retrieve custom menu details": "カスタムメニュー詳細取得",
            "Update custom menu": "カスタムメニュー更新",
            "Delete custom menu": "カスタムメニュー削除",
            "Retrieve list of asset histories": "資産履歴一覧取得",
            "Retrieve asset history details": "資産履歴詳細取得",
            "Retrieve integrated search detailed list": "統合検索詳細一覧取得",
            "Retrieve list of my requests": "マイリクエスト一覧取得",
            "Retrieve my request details": "マイリクエスト詳細取得",
            "Update my request": "マイリクエスト更新",
            "Delete my request": "マイリクエスト削除",
            "Create request": "リクエスト作成",
            "Retrieve list of requests": "リクエスト一覧取得",
            "Retrieve request details": "リクエスト詳細取得",
            "Update request": "リクエスト更新",
            "Delete request": "リクエスト削除",
            "Update request status": "リクエストステータス更新",
            "Create attachment in my request": "添付ファイルマイリクエスト作成",
            "Delete attachment from my request": "添付ファイルマイリクエスト削除",
            "Create attachment in request": "添付ファイルリクエスト作成",
            "Delete attachment from request": "添付ファイルリクエスト削除",
            "Retrieve list of request categories": "リクエストカテゴリー一覧取得",
            "Retrieve list of assets shared with me": "資産共有私一覧取得",
            "Share asset": "資産共有",
            "Retrieve list of shared assets": "共有資産一覧取得",
            "Unshare asset": "資産共有解除",
            "Assign request assignee": "妖精の担当者設定",
            "Retrieve custom metadata details of asset": "カスタムメタデータ詳細取得",
            "Retrieve list of projects for asset shared with me": "プロジェクト資産共有私一覧取得",
            "Retrieve list of user agreements": "ユーザー同意一覧取得",
            "Retrieve user agreement details": "ユーザー同意詳細取得",
            "Update user agreement consent": "ユーザー同意同意更新",
            "Create favorite resources in bulk": "お気に入りリソース一括作成",
            "Delete favorite resources in bulk": "お気に入りリソース一括削除",
            "Retrieve list of supported regions by provider": "サポート済み地域プロバイダー一覧取得",
            "Update asset share": "資産共有更新",
            "Retrieve list of assets I shared": "資産私共有一覧取得",
            "Retrieve list of projects for asset shared by me": "プロジェクト資産共有私一覧取得",
            "Retrieve list of asset owners": "資産所有者一覧取得",
            "Retrieve list of usage metric tenants": "使用状況メトリックテナント一覧取得",
            "Retrieve list of usage metrics": "使用状況メトリック一覧取得",
            "Retrieve list of usage metric data": "使用状況メトリックデータ一覧取得",
            "Retrieve assignable storages": "割当可能ストレージ取得",
            "Retrieve assigned storages": "割当済みストレージ取得",
            "Manage project storages": "プロジェクトストレージ管理",
            "Update owners of assets in bulk": "所有者資産一括更新",
            "Callback for Gen AI service": "Gen AIサービスのコールバック",
            "Create AI job in request": "リクエストでAIジョブを作成",
            "AI Source Synchronization": "AIソースの同期",
            "Delete Gen AI Source": "Gen AIソースを削除",
            "Create prompt preset": "プロンプトプリセットを作成",
            "Update prompt preset": "プロンプトプリセットを更新",
            "Delete prompt preset": "プロンプトプリセットを削除",
            "Update prompt preset status": "プロンプトプリセットのステータスを更新"
        }
    }
}
